(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('axios'), require('stellar-sdk')) :
    typeof define === 'function' && define.amd ? define(['exports', 'axios', 'stellar-sdk'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.yieldblox = {}, global.axios, global.StellarSdk));
})(this, (function (exports, axios, stellarSdk) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    // ***** YBX Accounts ***** //
    var POOL_ACCOUNT_1_ID = 'GDGHQTCJ3SGFBWBHJGVRUFBRLZGS5VS52HEDH4GVPX5GZRJQAOW7ZM37';
    var ISSUANCE_ACCOUNT_ID = 'GCIWMQHPST7LQ7V4LHAF2UP6ZSDCFRYYP7IM4BBAFSBZMVTR3BB4OQZ5';
    var DIST_ACCOUNT_ID = 'GATBAGTTQLQ4VKZMXLINLS6M4F2PEXMAZCK5ZE5ES4B6A2DXNGCFRX54';
    var ESCROW_ACCOUNT_ID = 'GANC25ARTWI2XFLZYFKFIDMXC3CFSNC6LBTHLHBQDMLZCRAJ4ISDCOHR';
    var DAO_TREASURY_ID = 'GDMZKMXXIU6HKKQLEK7RFB7CJJZJ7QJ5E6DWOSYHVYHGOGPONGSJMSY6';
    var CONTROLLED_ACCOUNTS = [
        POOL_ACCOUNT_1_ID,
        ISSUANCE_ACCOUNT_ID,
        DIST_ACCOUNT_ID,
        ESCROW_ACCOUNT_ID,
        DAO_TREASURY_ID,
    ];
    // ***** YBX Assets ***** //
    var YBX_TOKEN = "YBX:".concat(ISSUANCE_ACCOUNT_ID);
    var VEYBX_TOKEN = "veYBX:".concat(ESCROW_ACCOUNT_ID);
    var GYBX_TOKEN = "gYBX:".concat(ESCROW_ACCOUNT_ID);
    var VYBX_TOKEN = "vYBX:".concat(ESCROW_ACCOUNT_ID);
    var DEX_USDC = 'USDC:GAEB3HSAWRVILER6T5NMX5VAPTK4PPO2BAL37HR2EOUIK567GJFEO437';
    // ***** Network Assets ***** //
    var NATIVE = 'XLM:native';
    var TESTNET_USDC = 'USDC:GAEB3HSAWRVILER6T5NMX5VAPTK4PPO2BAL37HR2EOUIK567GJFEO437';
    var PUBNET_USDC = 'USDC:GAEB3HSAWRVILER6T5NMX5VAPTK4PPO2BAL37HR2EOUIK567GJFEO437';
    var STELLAR_MIN = '0.0000001';
    var STELLAR_MAX = '922337203685.4775807';
    var STELLAR_ZERO = '0.0000000';
    // ***** Math Constants ***** //
    var STARTING_irTRACKER_BALANCE = 100000;
    var XLM_RESERVE = 1000;
    var BLOCKS_PER_YEAR = 6307200;
    var FIVE_MIN = 5 * 60 * 1000;
    var XDR_NUMBER_SHIFT = -7;
    var MONTH_IN_DAYS = 30.436875;

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    var bignumber = {exports: {}};

    /*! bignumber.js v4.1.0 https://github.com/MikeMcl/bignumber.js/LICENCE */

    (function (module) {
    (function (globalObj) {

        /*
          bignumber.js v4.1.0
          A JavaScript library for arbitrary-precision arithmetic.
          https://github.com/MikeMcl/bignumber.js
          Copyright (c) 2017 Michael Mclaughlin <M8ch88l@gmail.com>
          MIT Expat Licence
        */


        var BigNumber,
            isNumeric = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
            mathceil = Math.ceil,
            mathfloor = Math.floor,
            notBool = ' not a boolean or binary digit',
            roundingMode = 'rounding mode',
            tooManyDigits = 'number type has more than 15 significant digits',
            ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_',
            BASE = 1e14,
            LOG_BASE = 14,
            MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
            // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
            POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
            SQRT_BASE = 1e7,

            /*
             * The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
             * the arguments to toExponential, toFixed, toFormat, and toPrecision, beyond which an
             * exception is thrown (if ERRORS is true).
             */
            MAX = 1E9;                                   // 0 to MAX_INT32


        /*
         * Create and return a BigNumber constructor.
         */
        function constructorFactory(config) {
            var div, parseNumeric,

                // id tracks the caller function, so its name can be included in error messages.
                id = 0,
                P = BigNumber.prototype,
                ONE = new BigNumber(1),


                /********************************* EDITABLE DEFAULTS **********************************/


                /*
                 * The default values below must be integers within the inclusive ranges stated.
                 * The values can also be changed at run-time using BigNumber.config.
                 */

                // The maximum number of decimal places for operations involving division.
                DECIMAL_PLACES = 20,                     // 0 to MAX

                /*
                 * The rounding mode used when rounding to the above decimal places, and when using
                 * toExponential, toFixed, toFormat and toPrecision, and round (default value).
                 * UP         0 Away from zero.
                 * DOWN       1 Towards zero.
                 * CEIL       2 Towards +Infinity.
                 * FLOOR      3 Towards -Infinity.
                 * HALF_UP    4 Towards nearest neighbour. If equidistant, up.
                 * HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
                 * HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
                 * HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
                 * HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
                 */
                ROUNDING_MODE = 4,                       // 0 to 8

                // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

                // The exponent value at and beneath which toString returns exponential notation.
                // Number type: -7
                TO_EXP_NEG = -7,                         // 0 to -MAX

                // The exponent value at and above which toString returns exponential notation.
                // Number type: 21
                TO_EXP_POS = 21,                         // 0 to MAX

                // RANGE : [MIN_EXP, MAX_EXP]

                // The minimum exponent value, beneath which underflow to zero occurs.
                // Number type: -324  (5e-324)
                MIN_EXP = -1e7,                          // -1 to -MAX

                // The maximum exponent value, above which overflow to Infinity occurs.
                // Number type:  308  (1.7976931348623157e+308)
                // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
                MAX_EXP = 1e7,                           // 1 to MAX

                // Whether BigNumber Errors are ever thrown.
                ERRORS = true,                           // true or false

                // Change to intValidatorNoErrors if ERRORS is false.
                isValidInt = intValidatorWithErrors,     // intValidatorWithErrors/intValidatorNoErrors

                // Whether to use cryptographically-secure random number generation, if available.
                CRYPTO = false,                          // true or false

                /*
                 * The modulo mode used when calculating the modulus: a mod n.
                 * The quotient (q = a / n) is calculated according to the corresponding rounding mode.
                 * The remainder (r) is calculated as: r = a - n * q.
                 *
                 * UP        0 The remainder is positive if the dividend is negative, else is negative.
                 * DOWN      1 The remainder has the same sign as the dividend.
                 *             This modulo mode is commonly known as 'truncated division' and is
                 *             equivalent to (a % n) in JavaScript.
                 * FLOOR     3 The remainder has the same sign as the divisor (Python %).
                 * HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
                 * EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
                 *             The remainder is always positive.
                 *
                 * The truncated division, floored division, Euclidian division and IEEE 754 remainder
                 * modes are commonly used for the modulus operation.
                 * Although the other rounding modes can also be used, they may not give useful results.
                 */
                MODULO_MODE = 1,                         // 0 to 9

                // The maximum number of significant digits of the result of the toPower operation.
                // If POW_PRECISION is 0, there will be unlimited significant digits.
                POW_PRECISION = 0,                       // 0 to MAX

                // The format specification used by the BigNumber.prototype.toFormat method.
                FORMAT = {
                    decimalSeparator: '.',
                    groupSeparator: ',',
                    groupSize: 3,
                    secondaryGroupSize: 0,
                    fractionGroupSeparator: '\xA0',      // non-breaking space
                    fractionGroupSize: 0
                };


            /******************************************************************************************/


            // CONSTRUCTOR


            /*
             * The BigNumber constructor and exported function.
             * Create and return a new instance of a BigNumber object.
             *
             * n {number|string|BigNumber} A numeric value.
             * [b] {number} The base of n. Integer, 2 to 64 inclusive.
             */
            function BigNumber( n, b ) {
                var c, e, i, num, len, str,
                    x = this;

                // Enable constructor usage without new.
                if ( !( x instanceof BigNumber ) ) {

                    // 'BigNumber() constructor call without new: {n}'
                    if (ERRORS) raise( 26, 'constructor call without new', n );
                    return new BigNumber( n, b );
                }

                // 'new BigNumber() base not an integer: {b}'
                // 'new BigNumber() base out of range: {b}'
                if ( b == null || !isValidInt( b, 2, 64, id, 'base' ) ) {

                    // Duplicate.
                    if ( n instanceof BigNumber ) {
                        x.s = n.s;
                        x.e = n.e;
                        x.c = ( n = n.c ) ? n.slice() : n;
                        id = 0;
                        return;
                    }

                    if ( ( num = typeof n == 'number' ) && n * 0 == 0 ) {
                        x.s = 1 / n < 0 ? ( n = -n, -1 ) : 1;

                        // Fast path for integers.
                        if ( n === ~~n ) {
                            for ( e = 0, i = n; i >= 10; i /= 10, e++ );
                            x.e = e;
                            x.c = [n];
                            id = 0;
                            return;
                        }

                        str = n + '';
                    } else {
                        if ( !isNumeric.test( str = n + '' ) ) return parseNumeric( x, str, num );
                        x.s = str.charCodeAt(0) === 45 ? ( str = str.slice(1), -1 ) : 1;
                    }
                } else {
                    b = b | 0;
                    str = n + '';

                    // Ensure return value is rounded to DECIMAL_PLACES as with other bases.
                    // Allow exponential notation to be used with base 10 argument.
                    if ( b == 10 ) {
                        x = new BigNumber( n instanceof BigNumber ? n : str );
                        return round( x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE );
                    }

                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    // Any number in exponential form will fail due to the [Ee][+-].
                    if ( ( num = typeof n == 'number' ) && n * 0 != 0 ||
                      !( new RegExp( '^-?' + ( c = '[' + ALPHABET.slice( 0, b ) + ']+' ) +
                        '(?:\\.' + c + ')?$',b < 37 ? 'i' : '' ) ).test(str) ) {
                        return parseNumeric( x, str, num, b );
                    }

                    if (num) {
                        x.s = 1 / n < 0 ? ( str = str.slice(1), -1 ) : 1;

                        if ( ERRORS && str.replace( /^0\.0*|\./, '' ).length > 15 ) {

                            // 'new BigNumber() number type has more than 15 significant digits: {n}'
                            raise( id, tooManyDigits, n );
                        }

                        // Prevent later check for length on converted number.
                        num = false;
                    } else {
                        x.s = str.charCodeAt(0) === 45 ? ( str = str.slice(1), -1 ) : 1;
                    }

                    str = convertBase( str, 10, b, x.s );
                }

                // Decimal point?
                if ( ( e = str.indexOf('.') ) > -1 ) str = str.replace( '.', '' );

                // Exponential form?
                if ( ( i = str.search( /e/i ) ) > 0 ) {

                    // Determine exponent.
                    if ( e < 0 ) e = i;
                    e += +str.slice( i + 1 );
                    str = str.substring( 0, i );
                } else if ( e < 0 ) {

                    // Integer.
                    e = str.length;
                }

                // Determine leading zeros.
                for ( i = 0; str.charCodeAt(i) === 48; i++ );

                // Determine trailing zeros.
                for ( len = str.length; str.charCodeAt(--len) === 48; );
                str = str.slice( i, len + 1 );

                if (str) {
                    len = str.length;

                    // Disallow numbers with over 15 significant digits if number type.
                    // 'new BigNumber() number type has more than 15 significant digits: {n}'
                    if ( num && ERRORS && len > 15 && ( n > MAX_SAFE_INTEGER || n !== mathfloor(n) ) ) {
                        raise( id, tooManyDigits, x.s * n );
                    }

                    e = e - i - 1;

                     // Overflow?
                    if ( e > MAX_EXP ) {

                        // Infinity.
                        x.c = x.e = null;

                    // Underflow?
                    } else if ( e < MIN_EXP ) {

                        // Zero.
                        x.c = [ x.e = 0 ];
                    } else {
                        x.e = e;
                        x.c = [];

                        // Transform base

                        // e is the base 10 exponent.
                        // i is where to slice str to get the first element of the coefficient array.
                        i = ( e + 1 ) % LOG_BASE;
                        if ( e < 0 ) i += LOG_BASE;

                        if ( i < len ) {
                            if (i) x.c.push( +str.slice( 0, i ) );

                            for ( len -= LOG_BASE; i < len; ) {
                                x.c.push( +str.slice( i, i += LOG_BASE ) );
                            }

                            str = str.slice(i);
                            i = LOG_BASE - str.length;
                        } else {
                            i -= len;
                        }

                        for ( ; i--; str += '0' );
                        x.c.push( +str );
                    }
                } else {

                    // Zero.
                    x.c = [ x.e = 0 ];
                }

                id = 0;
            }


            // CONSTRUCTOR PROPERTIES


            BigNumber.another = constructorFactory;

            BigNumber.ROUND_UP = 0;
            BigNumber.ROUND_DOWN = 1;
            BigNumber.ROUND_CEIL = 2;
            BigNumber.ROUND_FLOOR = 3;
            BigNumber.ROUND_HALF_UP = 4;
            BigNumber.ROUND_HALF_DOWN = 5;
            BigNumber.ROUND_HALF_EVEN = 6;
            BigNumber.ROUND_HALF_CEIL = 7;
            BigNumber.ROUND_HALF_FLOOR = 8;
            BigNumber.EUCLID = 9;


            /*
             * Configure infrequently-changing library-wide settings.
             *
             * Accept an object or an argument list, with one or many of the following properties or
             * parameters respectively:
             *
             *   DECIMAL_PLACES  {number}  Integer, 0 to MAX inclusive
             *   ROUNDING_MODE   {number}  Integer, 0 to 8 inclusive
             *   EXPONENTIAL_AT  {number|number[]}  Integer, -MAX to MAX inclusive or
             *                                      [integer -MAX to 0 incl., 0 to MAX incl.]
             *   RANGE           {number|number[]}  Non-zero integer, -MAX to MAX inclusive or
             *                                      [integer -MAX to -1 incl., integer 1 to MAX incl.]
             *   ERRORS          {boolean|number}   true, false, 1 or 0
             *   CRYPTO          {boolean|number}   true, false, 1 or 0
             *   MODULO_MODE     {number}           0 to 9 inclusive
             *   POW_PRECISION   {number}           0 to MAX inclusive
             *   FORMAT          {object}           See BigNumber.prototype.toFormat
             *      decimalSeparator       {string}
             *      groupSeparator         {string}
             *      groupSize              {number}
             *      secondaryGroupSize     {number}
             *      fractionGroupSeparator {string}
             *      fractionGroupSize      {number}
             *
             * (The values assigned to the above FORMAT object properties are not checked for validity.)
             *
             * E.g.
             * BigNumber.config(20, 4) is equivalent to
             * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
             *
             * Ignore properties/parameters set to null or undefined.
             * Return an object with the properties current values.
             */
            BigNumber.config = BigNumber.set = function () {
                var v, p,
                    i = 0,
                    r = {},
                    a = arguments,
                    o = a[0],
                    has = o && typeof o == 'object'
                      ? function () { if ( o.hasOwnProperty(p) ) return ( v = o[p] ) != null; }
                      : function () { if ( a.length > i ) return ( v = a[i++] ) != null; };

                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // 'config() DECIMAL_PLACES not an integer: {v}'
                // 'config() DECIMAL_PLACES out of range: {v}'
                if ( has( p = 'DECIMAL_PLACES' ) && isValidInt( v, 0, MAX, 2, p ) ) {
                    DECIMAL_PLACES = v | 0;
                }
                r[p] = DECIMAL_PLACES;

                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // 'config() ROUNDING_MODE not an integer: {v}'
                // 'config() ROUNDING_MODE out of range: {v}'
                if ( has( p = 'ROUNDING_MODE' ) && isValidInt( v, 0, 8, 2, p ) ) {
                    ROUNDING_MODE = v | 0;
                }
                r[p] = ROUNDING_MODE;

                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // 'config() EXPONENTIAL_AT not an integer: {v}'
                // 'config() EXPONENTIAL_AT out of range: {v}'
                if ( has( p = 'EXPONENTIAL_AT' ) ) {

                    if ( isArray(v) ) {
                        if ( isValidInt( v[0], -MAX, 0, 2, p ) && isValidInt( v[1], 0, MAX, 2, p ) ) {
                            TO_EXP_NEG = v[0] | 0;
                            TO_EXP_POS = v[1] | 0;
                        }
                    } else if ( isValidInt( v, -MAX, MAX, 2, p ) ) {
                        TO_EXP_NEG = -( TO_EXP_POS = ( v < 0 ? -v : v ) | 0 );
                    }
                }
                r[p] = [ TO_EXP_NEG, TO_EXP_POS ];

                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // 'config() RANGE not an integer: {v}'
                // 'config() RANGE cannot be zero: {v}'
                // 'config() RANGE out of range: {v}'
                if ( has( p = 'RANGE' ) ) {

                    if ( isArray(v) ) {
                        if ( isValidInt( v[0], -MAX, -1, 2, p ) && isValidInt( v[1], 1, MAX, 2, p ) ) {
                            MIN_EXP = v[0] | 0;
                            MAX_EXP = v[1] | 0;
                        }
                    } else if ( isValidInt( v, -MAX, MAX, 2, p ) ) {
                        if ( v | 0 ) MIN_EXP = -( MAX_EXP = ( v < 0 ? -v : v ) | 0 );
                        else if (ERRORS) raise( 2, p + ' cannot be zero', v );
                    }
                }
                r[p] = [ MIN_EXP, MAX_EXP ];

                // ERRORS {boolean|number} true, false, 1 or 0.
                // 'config() ERRORS not a boolean or binary digit: {v}'
                if ( has( p = 'ERRORS' ) ) {

                    if ( v === !!v || v === 1 || v === 0 ) {
                        id = 0;
                        isValidInt = ( ERRORS = !!v ) ? intValidatorWithErrors : intValidatorNoErrors;
                    } else if (ERRORS) {
                        raise( 2, p + notBool, v );
                    }
                }
                r[p] = ERRORS;

                // CRYPTO {boolean|number} true, false, 1 or 0.
                // 'config() CRYPTO not a boolean or binary digit: {v}'
                // 'config() crypto unavailable: {crypto}'
                if ( has( p = 'CRYPTO' ) ) {

                    if ( v === true || v === false || v === 1 || v === 0 ) {
                        if (v) {
                            v = typeof crypto == 'undefined';
                            if ( !v && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
                                CRYPTO = true;
                            } else if (ERRORS) {
                                raise( 2, 'crypto unavailable', v ? void 0 : crypto );
                            } else {
                                CRYPTO = false;
                            }
                        } else {
                            CRYPTO = false;
                        }
                    } else if (ERRORS) {
                        raise( 2, p + notBool, v );
                    }
                }
                r[p] = CRYPTO;

                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // 'config() MODULO_MODE not an integer: {v}'
                // 'config() MODULO_MODE out of range: {v}'
                if ( has( p = 'MODULO_MODE' ) && isValidInt( v, 0, 9, 2, p ) ) {
                    MODULO_MODE = v | 0;
                }
                r[p] = MODULO_MODE;

                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // 'config() POW_PRECISION not an integer: {v}'
                // 'config() POW_PRECISION out of range: {v}'
                if ( has( p = 'POW_PRECISION' ) && isValidInt( v, 0, MAX, 2, p ) ) {
                    POW_PRECISION = v | 0;
                }
                r[p] = POW_PRECISION;

                // FORMAT {object}
                // 'config() FORMAT not an object: {v}'
                if ( has( p = 'FORMAT' ) ) {

                    if ( typeof v == 'object' ) {
                        FORMAT = v;
                    } else if (ERRORS) {
                        raise( 2, p + ' not an object', v );
                    }
                }
                r[p] = FORMAT;

                return r;
            };


            /*
             * Return a new BigNumber whose value is the maximum of the arguments.
             *
             * arguments {number|string|BigNumber}
             */
            BigNumber.max = function () { return maxOrMin( arguments, P.lt ); };


            /*
             * Return a new BigNumber whose value is the minimum of the arguments.
             *
             * arguments {number|string|BigNumber}
             */
            BigNumber.min = function () { return maxOrMin( arguments, P.gt ); };


            /*
             * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
             * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
             * zeros are produced).
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
             *
             * 'random() decimal places not an integer: {dp}'
             * 'random() decimal places out of range: {dp}'
             * 'random() crypto unavailable: {crypto}'
             */
            BigNumber.random = (function () {
                var pow2_53 = 0x20000000000000;

                // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
                // Check if Math.random() produces more than 32 bits of randomness.
                // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
                // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
                var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
                  ? function () { return mathfloor( Math.random() * pow2_53 ); }
                  : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
                      (Math.random() * 0x800000 | 0); };

                return function (dp) {
                    var a, b, e, k, v,
                        i = 0,
                        c = [],
                        rand = new BigNumber(ONE);

                    dp = dp == null || !isValidInt( dp, 0, MAX, 14 ) ? DECIMAL_PLACES : dp | 0;
                    k = mathceil( dp / LOG_BASE );

                    if (CRYPTO) {

                        // Browsers supporting crypto.getRandomValues.
                        if (crypto.getRandomValues) {

                            a = crypto.getRandomValues( new Uint32Array( k *= 2 ) );

                            for ( ; i < k; ) {

                                // 53 bits:
                                // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                                // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                                // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                                //                                     11111 11111111 11111111
                                // 0x20000 is 2^21.
                                v = a[i] * 0x20000 + (a[i + 1] >>> 11);

                                // Rejection sampling:
                                // 0 <= v < 9007199254740992
                                // Probability that v >= 9e15, is
                                // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                                if ( v >= 9e15 ) {
                                    b = crypto.getRandomValues( new Uint32Array(2) );
                                    a[i] = b[0];
                                    a[i + 1] = b[1];
                                } else {

                                    // 0 <= v <= 8999999999999999
                                    // 0 <= (v % 1e14) <= 99999999999999
                                    c.push( v % 1e14 );
                                    i += 2;
                                }
                            }
                            i = k / 2;

                        // Node.js supporting crypto.randomBytes.
                        } else if (crypto.randomBytes) {

                            // buffer
                            a = crypto.randomBytes( k *= 7 );

                            for ( ; i < k; ) {

                                // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                                // 0x100000000 is 2^32, 0x1000000 is 2^24
                                // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                                // 0 <= v < 9007199254740992
                                v = ( ( a[i] & 31 ) * 0x1000000000000 ) + ( a[i + 1] * 0x10000000000 ) +
                                      ( a[i + 2] * 0x100000000 ) + ( a[i + 3] * 0x1000000 ) +
                                      ( a[i + 4] << 16 ) + ( a[i + 5] << 8 ) + a[i + 6];

                                if ( v >= 9e15 ) {
                                    crypto.randomBytes(7).copy( a, i );
                                } else {

                                    // 0 <= (v % 1e14) <= 99999999999999
                                    c.push( v % 1e14 );
                                    i += 7;
                                }
                            }
                            i = k / 7;
                        } else {
                            CRYPTO = false;
                            if (ERRORS) raise( 14, 'crypto unavailable', crypto );
                        }
                    }

                    // Use Math.random.
                    if (!CRYPTO) {

                        for ( ; i < k; ) {
                            v = random53bitInt();
                            if ( v < 9e15 ) c[i++] = v % 1e14;
                        }
                    }

                    k = c[--i];
                    dp %= LOG_BASE;

                    // Convert trailing digits to zeros according to dp.
                    if ( k && dp ) {
                        v = POWS_TEN[LOG_BASE - dp];
                        c[i] = mathfloor( k / v ) * v;
                    }

                    // Remove trailing elements which are zero.
                    for ( ; c[i] === 0; c.pop(), i-- );

                    // Zero?
                    if ( i < 0 ) {
                        c = [ e = 0 ];
                    } else {

                        // Remove leading elements which are zero and adjust exponent accordingly.
                        for ( e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

                        // Count the digits of the first element of c to determine leading zeros, and...
                        for ( i = 1, v = c[0]; v >= 10; v /= 10, i++);

                        // adjust the exponent accordingly.
                        if ( i < LOG_BASE ) e -= LOG_BASE - i;
                    }

                    rand.e = e;
                    rand.c = c;
                    return rand;
                };
            })();


            // PRIVATE FUNCTIONS


            // Convert a numeric string of baseIn to a numeric string of baseOut.
            function convertBase( str, baseOut, baseIn, sign ) {
                var d, e, k, r, x, xc, y,
                    i = str.indexOf( '.' ),
                    dp = DECIMAL_PLACES,
                    rm = ROUNDING_MODE;

                if ( baseIn < 37 ) str = str.toLowerCase();

                // Non-integer.
                if ( i >= 0 ) {
                    k = POW_PRECISION;

                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace( '.', '' );
                    y = new BigNumber(baseIn);
                    x = y.pow( str.length - i );
                    POW_PRECISION = k;

                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut( toFixedPoint( coeffToString( x.c ), x.e ), 10, baseOut );
                    y.e = y.c.length;
                }

                // Convert the number as integer.
                xc = toBaseOut( str, baseIn, baseOut );
                e = k = xc.length;

                // Remove trailing zeros.
                for ( ; xc[--k] == 0; xc.pop() );
                if ( !xc[0] ) return '0';

                if ( i < 0 ) {
                    --e;
                } else {
                    x.c = xc;
                    x.e = e;

                    // sign is needed for correct rounding.
                    x.s = sign;
                    x = div( x, y, dp, rm, baseOut );
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }

                d = e + dp + 1;

                // The rounding digit, i.e. the digit to the right of the digit that may be rounded up.
                i = xc[d];
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;

                r = rm < 4 ? ( i != null || r ) && ( rm == 0 || rm == ( x.s < 0 ? 3 : 2 ) )
                           : i > k || i == k &&( rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
                             rm == ( x.s < 0 ? 8 : 7 ) );

                if ( d < 1 || !xc[0] ) {

                    // 1^-dp or 0.
                    str = r ? toFixedPoint( '1', -dp ) : '0';
                } else {
                    xc.length = d;

                    if (r) {

                        // Rounding up may mean the previous digit has to be rounded up and so on.
                        for ( --baseOut; ++xc[--d] > baseOut; ) {
                            xc[d] = 0;

                            if ( !d ) {
                                ++e;
                                xc = [1].concat(xc);
                            }
                        }
                    }

                    // Determine trailing zeros.
                    for ( k = xc.length; !xc[--k]; );

                    // E.g. [4, 11, 15] becomes 4bf.
                    for ( i = 0, str = ''; i <= k; str += ALPHABET.charAt( xc[i++] ) );
                    str = toFixedPoint( str, e );
                }

                // The caller will add the sign.
                return str;
            }


            // Perform division in the specified base. Called by div and convertBase.
            div = (function () {

                // Assume non-zero x and k.
                function multiply( x, k, base ) {
                    var m, temp, xlo, xhi,
                        carry = 0,
                        i = x.length,
                        klo = k % SQRT_BASE,
                        khi = k / SQRT_BASE | 0;

                    for ( x = x.slice(); i--; ) {
                        xlo = x[i] % SQRT_BASE;
                        xhi = x[i] / SQRT_BASE | 0;
                        m = khi * xlo + xhi * klo;
                        temp = klo * xlo + ( ( m % SQRT_BASE ) * SQRT_BASE ) + carry;
                        carry = ( temp / base | 0 ) + ( m / SQRT_BASE | 0 ) + khi * xhi;
                        x[i] = temp % base;
                    }

                    if (carry) x = [carry].concat(x);

                    return x;
                }

                function compare( a, b, aL, bL ) {
                    var i, cmp;

                    if ( aL != bL ) {
                        cmp = aL > bL ? 1 : -1;
                    } else {

                        for ( i = cmp = 0; i < aL; i++ ) {

                            if ( a[i] != b[i] ) {
                                cmp = a[i] > b[i] ? 1 : -1;
                                break;
                            }
                        }
                    }
                    return cmp;
                }

                function subtract( a, b, aL, base ) {
                    var i = 0;

                    // Subtract b from a.
                    for ( ; aL--; ) {
                        a[aL] -= i;
                        i = a[aL] < b[aL] ? 1 : 0;
                        a[aL] = i * base + a[aL] - b[aL];
                    }

                    // Remove leading zeros.
                    for ( ; !a[0] && a.length > 1; a.splice(0, 1) );
                }

                // x: dividend, y: divisor.
                return function ( x, y, dp, rm, base ) {
                    var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
                        yL, yz,
                        s = x.s == y.s ? 1 : -1,
                        xc = x.c,
                        yc = y.c;

                    // Either NaN, Infinity or 0?
                    if ( !xc || !xc[0] || !yc || !yc[0] ) {

                        return new BigNumber(

                          // Return NaN if either NaN, or both Infinity or 0.
                          !x.s || !y.s || ( xc ? yc && xc[0] == yc[0] : !yc ) ? NaN :

                            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                            xc && xc[0] == 0 || !yc ? s * 0 : s / 0
                        );
                    }

                    q = new BigNumber(s);
                    qc = q.c = [];
                    e = x.e - y.e;
                    s = dp + e + 1;

                    if ( !base ) {
                        base = BASE;
                        e = bitFloor( x.e / LOG_BASE ) - bitFloor( y.e / LOG_BASE );
                        s = s / LOG_BASE | 0;
                    }

                    // Result exponent may be one less then the current value of e.
                    // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                    for ( i = 0; yc[i] == ( xc[i] || 0 ); i++ );
                    if ( yc[i] > ( xc[i] || 0 ) ) e--;

                    if ( s < 0 ) {
                        qc.push(1);
                        more = true;
                    } else {
                        xL = xc.length;
                        yL = yc.length;
                        i = 0;
                        s += 2;

                        // Normalise xc and yc so highest order digit of yc is >= base / 2.

                        n = mathfloor( base / ( yc[0] + 1 ) );

                        // Not necessary, but to handle odd bases where yc[0] == ( base / 2 ) - 1.
                        // if ( n > 1 || n++ == 1 && yc[0] < base / 2 ) {
                        if ( n > 1 ) {
                            yc = multiply( yc, n, base );
                            xc = multiply( xc, n, base );
                            yL = yc.length;
                            xL = xc.length;
                        }

                        xi = yL;
                        rem = xc.slice( 0, yL );
                        remL = rem.length;

                        // Add zeros to make remainder as long as divisor.
                        for ( ; remL < yL; rem[remL++] = 0 );
                        yz = yc.slice();
                        yz = [0].concat(yz);
                        yc0 = yc[0];
                        if ( yc[1] >= base / 2 ) yc0++;
                        // Not necessary, but to prevent trial digit n > base, when using base 3.
                        // else if ( base == 3 && yc0 == 1 ) yc0 = 1 + 1e-15;

                        do {
                            n = 0;

                            // Compare divisor and remainder.
                            cmp = compare( yc, rem, yL, remL );

                            // If divisor < remainder.
                            if ( cmp < 0 ) {

                                // Calculate trial digit, n.

                                rem0 = rem[0];
                                if ( yL != remL ) rem0 = rem0 * base + ( rem[1] || 0 );

                                // n is how many times the divisor goes into the current remainder.
                                n = mathfloor( rem0 / yc0 );

                                //  Algorithm:
                                //  1. product = divisor * trial digit (n)
                                //  2. if product > remainder: product -= divisor, n--
                                //  3. remainder -= product
                                //  4. if product was < remainder at 2:
                                //    5. compare new remainder and divisor
                                //    6. If remainder > divisor: remainder -= divisor, n++

                                if ( n > 1 ) {

                                    // n may be > base only when base is 3.
                                    if (n >= base) n = base - 1;

                                    // product = divisor * trial digit.
                                    prod = multiply( yc, n, base );
                                    prodL = prod.length;
                                    remL = rem.length;

                                    // Compare product and remainder.
                                    // If product > remainder.
                                    // Trial digit n too high.
                                    // n is 1 too high about 5% of the time, and is not known to have
                                    // ever been more than 1 too high.
                                    while ( compare( prod, rem, prodL, remL ) == 1 ) {
                                        n--;

                                        // Subtract divisor from product.
                                        subtract( prod, yL < prodL ? yz : yc, prodL, base );
                                        prodL = prod.length;
                                        cmp = 1;
                                    }
                                } else {

                                    // n is 0 or 1, cmp is -1.
                                    // If n is 0, there is no need to compare yc and rem again below,
                                    // so change cmp to 1 to avoid it.
                                    // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                    if ( n == 0 ) {

                                        // divisor < remainder, so n must be at least 1.
                                        cmp = n = 1;
                                    }

                                    // product = divisor
                                    prod = yc.slice();
                                    prodL = prod.length;
                                }

                                if ( prodL < remL ) prod = [0].concat(prod);

                                // Subtract product from remainder.
                                subtract( rem, prod, remL, base );
                                remL = rem.length;

                                 // If product was < remainder.
                                if ( cmp == -1 ) {

                                    // Compare divisor and new remainder.
                                    // If divisor < new remainder, subtract divisor from remainder.
                                    // Trial digit n too low.
                                    // n is 1 too low about 5% of the time, and very rarely 2 too low.
                                    while ( compare( yc, rem, yL, remL ) < 1 ) {
                                        n++;

                                        // Subtract divisor from remainder.
                                        subtract( rem, yL < remL ? yz : yc, remL, base );
                                        remL = rem.length;
                                    }
                                }
                            } else if ( cmp === 0 ) {
                                n++;
                                rem = [0];
                            } // else cmp === 1 and n will be 0

                            // Add the next digit, n, to the result array.
                            qc[i++] = n;

                            // Update the remainder.
                            if ( rem[0] ) {
                                rem[remL++] = xc[xi] || 0;
                            } else {
                                rem = [ xc[xi] ];
                                remL = 1;
                            }
                        } while ( ( xi++ < xL || rem[0] != null ) && s-- );

                        more = rem[0] != null;

                        // Leading zero?
                        if ( !qc[0] ) qc.splice(0, 1);
                    }

                    if ( base == BASE ) {

                        // To calculate q.e, first get the number of digits of qc[0].
                        for ( i = 1, s = qc[0]; s >= 10; s /= 10, i++ );
                        round( q, dp + ( q.e = i + e * LOG_BASE - 1 ) + 1, rm, more );

                    // Caller is convertBase.
                    } else {
                        q.e = e;
                        q.r = +more;
                    }

                    return q;
                };
            })();


            /*
             * Return a string representing the value of BigNumber n in fixed-point or exponential
             * notation rounded to the specified decimal places or significant digits.
             *
             * n is a BigNumber.
             * i is the index of the last digit required (i.e. the digit that may be rounded up).
             * rm is the rounding mode.
             * caller is caller id: toExponential 19, toFixed 20, toFormat 21, toPrecision 24.
             */
            function format( n, i, rm, caller ) {
                var c0, e, ne, len, str;

                rm = rm != null && isValidInt( rm, 0, 8, caller, roundingMode )
                  ? rm | 0 : ROUNDING_MODE;

                if ( !n.c ) return n.toString();
                c0 = n.c[0];
                ne = n.e;

                if ( i == null ) {
                    str = coeffToString( n.c );
                    str = caller == 19 || caller == 24 && ne <= TO_EXP_NEG
                      ? toExponential( str, ne )
                      : toFixedPoint( str, ne );
                } else {
                    n = round( new BigNumber(n), i, rm );

                    // n.e may have changed if the value was rounded up.
                    e = n.e;

                    str = coeffToString( n.c );
                    len = str.length;

                    // toPrecision returns exponential notation if the number of significant digits
                    // specified is less than the number of digits necessary to represent the integer
                    // part of the value in fixed-point notation.

                    // Exponential notation.
                    if ( caller == 19 || caller == 24 && ( i <= e || e <= TO_EXP_NEG ) ) {

                        // Append zeros?
                        for ( ; len < i; str += '0', len++ );
                        str = toExponential( str, e );

                    // Fixed-point notation.
                    } else {
                        i -= ne;
                        str = toFixedPoint( str, e );

                        // Append zeros?
                        if ( e + 1 > len ) {
                            if ( --i > 0 ) for ( str += '.'; i--; str += '0' );
                        } else {
                            i += e - len;
                            if ( i > 0 ) {
                                if ( e + 1 == len ) str += '.';
                                for ( ; i--; str += '0' );
                            }
                        }
                    }
                }

                return n.s < 0 && c0 ? '-' + str : str;
            }


            // Handle BigNumber.max and BigNumber.min.
            function maxOrMin( args, method ) {
                var m, n,
                    i = 0;

                if ( isArray( args[0] ) ) args = args[0];
                m = new BigNumber( args[0] );

                for ( ; ++i < args.length; ) {
                    n = new BigNumber( args[i] );

                    // If any number is NaN, return NaN.
                    if ( !n.s ) {
                        m = n;
                        break;
                    } else if ( method.call( m, n ) ) {
                        m = n;
                    }
                }

                return m;
            }


            /*
             * Return true if n is an integer in range, otherwise throw.
             * Use for argument validation when ERRORS is true.
             */
            function intValidatorWithErrors( n, min, max, caller, name ) {
                if ( n < min || n > max || n != truncate(n) ) {
                    raise( caller, ( name || 'decimal places' ) +
                      ( n < min || n > max ? ' out of range' : ' not an integer' ), n );
                }

                return true;
            }


            /*
             * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
             * Called by minus, plus and times.
             */
            function normalise( n, c, e ) {
                var i = 1,
                    j = c.length;

                 // Remove trailing zeros.
                for ( ; !c[--j]; c.pop() );

                // Calculate the base 10 exponent. First get the number of digits of c[0].
                for ( j = c[0]; j >= 10; j /= 10, i++ );

                // Overflow?
                if ( ( e = i + e * LOG_BASE - 1 ) > MAX_EXP ) {

                    // Infinity.
                    n.c = n.e = null;

                // Underflow?
                } else if ( e < MIN_EXP ) {

                    // Zero.
                    n.c = [ n.e = 0 ];
                } else {
                    n.e = e;
                    n.c = c;
                }

                return n;
            }


            // Handle values that fail the validity test in BigNumber.
            parseNumeric = (function () {
                var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
                    dotAfter = /^([^.]+)\.$/,
                    dotBefore = /^\.([^.]+)$/,
                    isInfinityOrNaN = /^-?(Infinity|NaN)$/,
                    whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

                return function ( x, str, num, b ) {
                    var base,
                        s = num ? str : str.replace( whitespaceOrPlus, '' );

                    // No exception on ±Infinity or NaN.
                    if ( isInfinityOrNaN.test(s) ) {
                        x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                    } else {
                        if ( !num ) {

                            // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                            s = s.replace( basePrefix, function ( m, p1, p2 ) {
                                base = ( p2 = p2.toLowerCase() ) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                                return !b || b == base ? p1 : m;
                            });

                            if (b) {
                                base = b;

                                // E.g. '1.' to '1', '.1' to '0.1'
                                s = s.replace( dotAfter, '$1' ).replace( dotBefore, '0.$1' );
                            }

                            if ( str != s ) return new BigNumber( s, base );
                        }

                        // 'new BigNumber() not a number: {n}'
                        // 'new BigNumber() not a base {b} number: {n}'
                        if (ERRORS) raise( id, 'not a' + ( b ? ' base ' + b : '' ) + ' number', str );
                        x.s = null;
                    }

                    x.c = x.e = null;
                    id = 0;
                }
            })();


            // Throw a BigNumber Error.
            function raise( caller, msg, val ) {
                var error = new Error( [
                    'new BigNumber',     // 0
                    'cmp',               // 1
                    'config',            // 2
                    'div',               // 3
                    'divToInt',          // 4
                    'eq',                // 5
                    'gt',                // 6
                    'gte',               // 7
                    'lt',                // 8
                    'lte',               // 9
                    'minus',             // 10
                    'mod',               // 11
                    'plus',              // 12
                    'precision',         // 13
                    'random',            // 14
                    'round',             // 15
                    'shift',             // 16
                    'times',             // 17
                    'toDigits',          // 18
                    'toExponential',     // 19
                    'toFixed',           // 20
                    'toFormat',          // 21
                    'toFraction',        // 22
                    'pow',               // 23
                    'toPrecision',       // 24
                    'toString',          // 25
                    'BigNumber'          // 26
                ][caller] + '() ' + msg + ': ' + val );

                error.name = 'BigNumber Error';
                id = 0;
                throw error;
            }


            /*
             * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
             * If r is truthy, it is known that there are more digits after the rounding digit.
             */
            function round( x, sd, rm, r ) {
                var d, i, j, k, n, ni, rd,
                    xc = x.c,
                    pows10 = POWS_TEN;

                // if x is not Infinity or NaN...
                if (xc) {

                    // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                    // n is a base 1e14 number, the value of the element of array x.c containing rd.
                    // ni is the index of n within x.c.
                    // d is the number of digits of n.
                    // i is the index of rd within n including leading zeros.
                    // j is the actual index of rd within n (if < 0, rd is a leading zero).
                    out: {

                        // Get the number of digits of the first element of xc.
                        for ( d = 1, k = xc[0]; k >= 10; k /= 10, d++ );
                        i = sd - d;

                        // If the rounding digit is in the first element of xc...
                        if ( i < 0 ) {
                            i += LOG_BASE;
                            j = sd;
                            n = xc[ ni = 0 ];

                            // Get the rounding digit at index j of n.
                            rd = n / pows10[ d - j - 1 ] % 10 | 0;
                        } else {
                            ni = mathceil( ( i + 1 ) / LOG_BASE );

                            if ( ni >= xc.length ) {

                                if (r) {

                                    // Needed by sqrt.
                                    for ( ; xc.length <= ni; xc.push(0) );
                                    n = rd = 0;
                                    d = 1;
                                    i %= LOG_BASE;
                                    j = i - LOG_BASE + 1;
                                } else {
                                    break out;
                                }
                            } else {
                                n = k = xc[ni];

                                // Get the number of digits of n.
                                for ( d = 1; k >= 10; k /= 10, d++ );

                                // Get the index of rd within n.
                                i %= LOG_BASE;

                                // Get the index of rd within n, adjusted for leading zeros.
                                // The number of leading zeros of n is given by LOG_BASE - d.
                                j = i - LOG_BASE + d;

                                // Get the rounding digit at index j of n.
                                rd = j < 0 ? 0 : n / pows10[ d - j - 1 ] % 10 | 0;
                            }
                        }

                        r = r || sd < 0 ||

                        // Are there any non-zero digits after the rounding digit?
                        // The expression  n % pows10[ d - j - 1 ]  returns all digits of n to the right
                        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                          xc[ni + 1] != null || ( j < 0 ? n : n % pows10[ d - j - 1 ] );

                        r = rm < 4
                          ? ( rd || r ) && ( rm == 0 || rm == ( x.s < 0 ? 3 : 2 ) )
                          : rd > 5 || rd == 5 && ( rm == 4 || r || rm == 6 &&

                            // Check whether the digit to the left of the rounding digit is odd.
                            ( ( i > 0 ? j > 0 ? n / pows10[ d - j ] : 0 : xc[ni - 1] ) % 10 ) & 1 ||
                              rm == ( x.s < 0 ? 8 : 7 ) );

                        if ( sd < 1 || !xc[0] ) {
                            xc.length = 0;

                            if (r) {

                                // Convert sd to decimal places.
                                sd -= x.e + 1;

                                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                                xc[0] = pows10[ ( LOG_BASE - sd % LOG_BASE ) % LOG_BASE ];
                                x.e = -sd || 0;
                            } else {

                                // Zero.
                                xc[0] = x.e = 0;
                            }

                            return x;
                        }

                        // Remove excess digits.
                        if ( i == 0 ) {
                            xc.length = ni;
                            k = 1;
                            ni--;
                        } else {
                            xc.length = ni + 1;
                            k = pows10[ LOG_BASE - i ];

                            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                            // j > 0 means i > number of leading zeros of n.
                            xc[ni] = j > 0 ? mathfloor( n / pows10[ d - j ] % pows10[j] ) * k : 0;
                        }

                        // Round up?
                        if (r) {

                            for ( ; ; ) {

                                // If the digit to be rounded up is in the first element of xc...
                                if ( ni == 0 ) {

                                    // i will be the length of xc[0] before k is added.
                                    for ( i = 1, j = xc[0]; j >= 10; j /= 10, i++ );
                                    j = xc[0] += k;
                                    for ( k = 1; j >= 10; j /= 10, k++ );

                                    // if i != k the length has increased.
                                    if ( i != k ) {
                                        x.e++;
                                        if ( xc[0] == BASE ) xc[0] = 1;
                                    }

                                    break;
                                } else {
                                    xc[ni] += k;
                                    if ( xc[ni] != BASE ) break;
                                    xc[ni--] = 0;
                                    k = 1;
                                }
                            }
                        }

                        // Remove trailing zeros.
                        for ( i = xc.length; xc[--i] === 0; xc.pop() );
                    }

                    // Overflow? Infinity.
                    if ( x.e > MAX_EXP ) {
                        x.c = x.e = null;

                    // Underflow? Zero.
                    } else if ( x.e < MIN_EXP ) {
                        x.c = [ x.e = 0 ];
                    }
                }

                return x;
            }


            // PROTOTYPE/INSTANCE METHODS


            /*
             * Return a new BigNumber whose value is the absolute value of this BigNumber.
             */
            P.absoluteValue = P.abs = function () {
                var x = new BigNumber(this);
                if ( x.s < 0 ) x.s = 1;
                return x;
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
             * number in the direction of Infinity.
             */
            P.ceil = function () {
                return round( new BigNumber(this), this.e + 1, 2 );
            };


            /*
             * Return
             * 1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
             * -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
             * 0 if they have the same value,
             * or null if the value of either is NaN.
             */
            P.comparedTo = P.cmp = function ( y, b ) {
                id = 1;
                return compare( this, new BigNumber( y, b ) );
            };


            /*
             * Return the number of decimal places of the value of this BigNumber, or null if the value
             * of this BigNumber is ±Infinity or NaN.
             */
            P.decimalPlaces = P.dp = function () {
                var n, v,
                    c = this.c;

                if ( !c ) return null;
                n = ( ( v = c.length - 1 ) - bitFloor( this.e / LOG_BASE ) ) * LOG_BASE;

                // Subtract the number of trailing zeros of the last number.
                if ( v = c[v] ) for ( ; v % 10 == 0; v /= 10, n-- );
                if ( n < 0 ) n = 0;

                return n;
            };


            /*
             *  n / 0 = I
             *  n / N = N
             *  n / I = 0
             *  0 / n = 0
             *  0 / 0 = N
             *  0 / N = N
             *  0 / I = 0
             *  N / n = N
             *  N / 0 = N
             *  N / N = N
             *  N / I = N
             *  I / n = I
             *  I / 0 = I
             *  I / N = N
             *  I / I = N
             *
             * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
             * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
             */
            P.dividedBy = P.div = function ( y, b ) {
                id = 3;
                return div( this, new BigNumber( y, b ), DECIMAL_PLACES, ROUNDING_MODE );
            };


            /*
             * Return a new BigNumber whose value is the integer part of dividing the value of this
             * BigNumber by the value of BigNumber(y, b).
             */
            P.dividedToIntegerBy = P.divToInt = function ( y, b ) {
                id = 4;
                return div( this, new BigNumber( y, b ), 0, 1 );
            };


            /*
             * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
             * otherwise returns false.
             */
            P.equals = P.eq = function ( y, b ) {
                id = 5;
                return compare( this, new BigNumber( y, b ) ) === 0;
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber rounded to a whole
             * number in the direction of -Infinity.
             */
            P.floor = function () {
                return round( new BigNumber(this), this.e + 1, 3 );
            };


            /*
             * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
             * otherwise returns false.
             */
            P.greaterThan = P.gt = function ( y, b ) {
                id = 6;
                return compare( this, new BigNumber( y, b ) ) > 0;
            };


            /*
             * Return true if the value of this BigNumber is greater than or equal to the value of
             * BigNumber(y, b), otherwise returns false.
             */
            P.greaterThanOrEqualTo = P.gte = function ( y, b ) {
                id = 7;
                return ( b = compare( this, new BigNumber( y, b ) ) ) === 1 || b === 0;

            };


            /*
             * Return true if the value of this BigNumber is a finite number, otherwise returns false.
             */
            P.isFinite = function () {
                return !!this.c;
            };


            /*
             * Return true if the value of this BigNumber is an integer, otherwise return false.
             */
            P.isInteger = P.isInt = function () {
                return !!this.c && bitFloor( this.e / LOG_BASE ) > this.c.length - 2;
            };


            /*
             * Return true if the value of this BigNumber is NaN, otherwise returns false.
             */
            P.isNaN = function () {
                return !this.s;
            };


            /*
             * Return true if the value of this BigNumber is negative, otherwise returns false.
             */
            P.isNegative = P.isNeg = function () {
                return this.s < 0;
            };


            /*
             * Return true if the value of this BigNumber is 0 or -0, otherwise returns false.
             */
            P.isZero = function () {
                return !!this.c && this.c[0] == 0;
            };


            /*
             * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
             * otherwise returns false.
             */
            P.lessThan = P.lt = function ( y, b ) {
                id = 8;
                return compare( this, new BigNumber( y, b ) ) < 0;
            };


            /*
             * Return true if the value of this BigNumber is less than or equal to the value of
             * BigNumber(y, b), otherwise returns false.
             */
            P.lessThanOrEqualTo = P.lte = function ( y, b ) {
                id = 9;
                return ( b = compare( this, new BigNumber( y, b ) ) ) === -1 || b === 0;
            };


            /*
             *  n - 0 = n
             *  n - N = N
             *  n - I = -I
             *  0 - n = -n
             *  0 - 0 = 0
             *  0 - N = N
             *  0 - I = -I
             *  N - n = N
             *  N - 0 = N
             *  N - N = N
             *  N - I = N
             *  I - n = I
             *  I - 0 = I
             *  I - N = N
             *  I - I = N
             *
             * Return a new BigNumber whose value is the value of this BigNumber minus the value of
             * BigNumber(y, b).
             */
            P.minus = P.sub = function ( y, b ) {
                var i, j, t, xLTy,
                    x = this,
                    a = x.s;

                id = 10;
                y = new BigNumber( y, b );
                b = y.s;

                // Either NaN?
                if ( !a || !b ) return new BigNumber(NaN);

                // Signs differ?
                if ( a != b ) {
                    y.s = -b;
                    return x.plus(y);
                }

                var xe = x.e / LOG_BASE,
                    ye = y.e / LOG_BASE,
                    xc = x.c,
                    yc = y.c;

                if ( !xe || !ye ) {

                    // Either Infinity?
                    if ( !xc || !yc ) return xc ? ( y.s = -b, y ) : new BigNumber( yc ? x : NaN );

                    // Either zero?
                    if ( !xc[0] || !yc[0] ) {

                        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                        return yc[0] ? ( y.s = -b, y ) : new BigNumber( xc[0] ? x :

                          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                          ROUNDING_MODE == 3 ? -0 : 0 );
                    }
                }

                xe = bitFloor(xe);
                ye = bitFloor(ye);
                xc = xc.slice();

                // Determine which is the bigger number.
                if ( a = xe - ye ) {

                    if ( xLTy = a < 0 ) {
                        a = -a;
                        t = xc;
                    } else {
                        ye = xe;
                        t = yc;
                    }

                    t.reverse();

                    // Prepend zeros to equalise exponents.
                    for ( b = a; b--; t.push(0) );
                    t.reverse();
                } else {

                    // Exponents equal. Check digit by digit.
                    j = ( xLTy = ( a = xc.length ) < ( b = yc.length ) ) ? a : b;

                    for ( a = b = 0; b < j; b++ ) {

                        if ( xc[b] != yc[b] ) {
                            xLTy = xc[b] < yc[b];
                            break;
                        }
                    }
                }

                // x < y? Point xc to the array of the bigger number.
                if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;

                b = ( j = yc.length ) - ( i = xc.length );

                // Append zeros to xc if shorter.
                // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
                if ( b > 0 ) for ( ; b--; xc[i++] = 0 );
                b = BASE - 1;

                // Subtract yc from xc.
                for ( ; j > a; ) {

                    if ( xc[--j] < yc[j] ) {
                        for ( i = j; i && !xc[--i]; xc[i] = b );
                        --xc[i];
                        xc[j] += BASE;
                    }

                    xc[j] -= yc[j];
                }

                // Remove leading zeros and adjust exponent accordingly.
                for ( ; xc[0] == 0; xc.splice(0, 1), --ye );

                // Zero?
                if ( !xc[0] ) {

                    // Following IEEE 754 (2008) 6.3,
                    // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                    y.s = ROUNDING_MODE == 3 ? -1 : 1;
                    y.c = [ y.e = 0 ];
                    return y;
                }

                // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
                // for finite x and y.
                return normalise( y, xc, ye );
            };


            /*
             *   n % 0 =  N
             *   n % N =  N
             *   n % I =  n
             *   0 % n =  0
             *  -0 % n = -0
             *   0 % 0 =  N
             *   0 % N =  N
             *   0 % I =  0
             *   N % n =  N
             *   N % 0 =  N
             *   N % N =  N
             *   N % I =  N
             *   I % n =  N
             *   I % 0 =  N
             *   I % N =  N
             *   I % I =  N
             *
             * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
             * BigNumber(y, b). The result depends on the value of MODULO_MODE.
             */
            P.modulo = P.mod = function ( y, b ) {
                var q, s,
                    x = this;

                id = 11;
                y = new BigNumber( y, b );

                // Return NaN if x is Infinity or NaN, or y is NaN or zero.
                if ( !x.c || !y.s || y.c && !y.c[0] ) {
                    return new BigNumber(NaN);

                // Return x if y is Infinity or x is zero.
                } else if ( !y.c || x.c && !x.c[0] ) {
                    return new BigNumber(x);
                }

                if ( MODULO_MODE == 9 ) {

                    // Euclidian division: q = sign(y) * floor(x / abs(y))
                    // r = x - qy    where  0 <= r < abs(y)
                    s = y.s;
                    y.s = 1;
                    q = div( x, y, 0, 3 );
                    y.s = s;
                    q.s *= s;
                } else {
                    q = div( x, y, 0, MODULO_MODE );
                }

                return x.minus( q.times(y) );
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber negated,
             * i.e. multiplied by -1.
             */
            P.negated = P.neg = function () {
                var x = new BigNumber(this);
                x.s = -x.s || null;
                return x;
            };


            /*
             *  n + 0 = n
             *  n + N = N
             *  n + I = I
             *  0 + n = n
             *  0 + 0 = 0
             *  0 + N = N
             *  0 + I = I
             *  N + n = N
             *  N + 0 = N
             *  N + N = N
             *  N + I = N
             *  I + n = I
             *  I + 0 = I
             *  I + N = N
             *  I + I = I
             *
             * Return a new BigNumber whose value is the value of this BigNumber plus the value of
             * BigNumber(y, b).
             */
            P.plus = P.add = function ( y, b ) {
                var t,
                    x = this,
                    a = x.s;

                id = 12;
                y = new BigNumber( y, b );
                b = y.s;

                // Either NaN?
                if ( !a || !b ) return new BigNumber(NaN);

                // Signs differ?
                 if ( a != b ) {
                    y.s = -b;
                    return x.minus(y);
                }

                var xe = x.e / LOG_BASE,
                    ye = y.e / LOG_BASE,
                    xc = x.c,
                    yc = y.c;

                if ( !xe || !ye ) {

                    // Return ±Infinity if either ±Infinity.
                    if ( !xc || !yc ) return new BigNumber( a / 0 );

                    // Either zero?
                    // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                    if ( !xc[0] || !yc[0] ) return yc[0] ? y : new BigNumber( xc[0] ? x : a * 0 );
                }

                xe = bitFloor(xe);
                ye = bitFloor(ye);
                xc = xc.slice();

                // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
                if ( a = xe - ye ) {
                    if ( a > 0 ) {
                        ye = xe;
                        t = yc;
                    } else {
                        a = -a;
                        t = xc;
                    }

                    t.reverse();
                    for ( ; a--; t.push(0) );
                    t.reverse();
                }

                a = xc.length;
                b = yc.length;

                // Point xc to the longer array, and b to the shorter length.
                if ( a - b < 0 ) t = yc, yc = xc, xc = t, b = a;

                // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
                for ( a = 0; b; ) {
                    a = ( xc[--b] = xc[b] + yc[b] + a ) / BASE | 0;
                    xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
                }

                if (a) {
                    xc = [a].concat(xc);
                    ++ye;
                }

                // No need to check for zero, as +x + +y != 0 && -x + -y != 0
                // ye = MAX_EXP + 1 possible
                return normalise( y, xc, ye );
            };


            /*
             * Return the number of significant digits of the value of this BigNumber.
             *
             * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
             */
            P.precision = P.sd = function (z) {
                var n, v,
                    x = this,
                    c = x.c;

                // 'precision() argument not a boolean or binary digit: {z}'
                if ( z != null && z !== !!z && z !== 1 && z !== 0 ) {
                    if (ERRORS) raise( 13, 'argument' + notBool, z );
                    if ( z != !!z ) z = null;
                }

                if ( !c ) return null;
                v = c.length - 1;
                n = v * LOG_BASE + 1;

                if ( v = c[v] ) {

                    // Subtract the number of trailing zeros of the last element.
                    for ( ; v % 10 == 0; v /= 10, n-- );

                    // Add the number of digits of the first element.
                    for ( v = c[0]; v >= 10; v /= 10, n++ );
                }

                if ( z && x.e + 1 > n ) n = x.e + 1;

                return n;
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
             * dp decimal places using rounding mode rm, or to 0 and ROUNDING_MODE respectively if
             * omitted.
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'round() decimal places out of range: {dp}'
             * 'round() decimal places not an integer: {dp}'
             * 'round() rounding mode not an integer: {rm}'
             * 'round() rounding mode out of range: {rm}'
             */
            P.round = function ( dp, rm ) {
                var n = new BigNumber(this);

                if ( dp == null || isValidInt( dp, 0, MAX, 15 ) ) {
                    round( n, ~~dp + this.e + 1, rm == null ||
                      !isValidInt( rm, 0, 8, 15, roundingMode ) ? ROUNDING_MODE : rm | 0 );
                }

                return n;
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
             * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
             *
             * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
             *
             * If k is out of range and ERRORS is false, the result will be ±0 if k < 0, or ±Infinity
             * otherwise.
             *
             * 'shift() argument not an integer: {k}'
             * 'shift() argument out of range: {k}'
             */
            P.shift = function (k) {
                var n = this;
                return isValidInt( k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER, 16, 'argument' )

                  // k < 1e+21, or truncate(k) will produce exponential notation.
                  ? n.times( '1e' + truncate(k) )
                  : new BigNumber( n.c && n.c[0] && ( k < -MAX_SAFE_INTEGER || k > MAX_SAFE_INTEGER )
                    ? n.s * ( k < 0 ? 0 : 1 / 0 )
                    : n );
            };


            /*
             *  sqrt(-n) =  N
             *  sqrt( N) =  N
             *  sqrt(-I) =  N
             *  sqrt( I) =  I
             *  sqrt( 0) =  0
             *  sqrt(-0) = -0
             *
             * Return a new BigNumber whose value is the square root of the value of this BigNumber,
             * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
             */
            P.squareRoot = P.sqrt = function () {
                var m, n, r, rep, t,
                    x = this,
                    c = x.c,
                    s = x.s,
                    e = x.e,
                    dp = DECIMAL_PLACES + 4,
                    half = new BigNumber('0.5');

                // Negative/NaN/Infinity/zero?
                if ( s !== 1 || !c || !c[0] ) {
                    return new BigNumber( !s || s < 0 && ( !c || c[0] ) ? NaN : c ? x : 1 / 0 );
                }

                // Initial estimate.
                s = Math.sqrt( +x );

                // Math.sqrt underflow/overflow?
                // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
                if ( s == 0 || s == 1 / 0 ) {
                    n = coeffToString(c);
                    if ( ( n.length + e ) % 2 == 0 ) n += '0';
                    s = Math.sqrt(n);
                    e = bitFloor( ( e + 1 ) / 2 ) - ( e < 0 || e % 2 );

                    if ( s == 1 / 0 ) {
                        n = '1e' + e;
                    } else {
                        n = s.toExponential();
                        n = n.slice( 0, n.indexOf('e') + 1 ) + e;
                    }

                    r = new BigNumber(n);
                } else {
                    r = new BigNumber( s + '' );
                }

                // Check for zero.
                // r could be zero if MIN_EXP is changed after the this value was created.
                // This would cause a division by zero (x/t) and hence Infinity below, which would cause
                // coeffToString to throw.
                if ( r.c[0] ) {
                    e = r.e;
                    s = e + dp;
                    if ( s < 3 ) s = 0;

                    // Newton-Raphson iteration.
                    for ( ; ; ) {
                        t = r;
                        r = half.times( t.plus( div( x, t, dp, 1 ) ) );

                        if ( coeffToString( t.c   ).slice( 0, s ) === ( n =
                             coeffToString( r.c ) ).slice( 0, s ) ) {

                            // The exponent of r may here be one less than the final result exponent,
                            // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                            // are indexed correctly.
                            if ( r.e < e ) --s;
                            n = n.slice( s - 3, s + 1 );

                            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                            // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                            // iteration.
                            if ( n == '9999' || !rep && n == '4999' ) {

                                // On the first iteration only, check to see if rounding up gives the
                                // exact result as the nines may infinitely repeat.
                                if ( !rep ) {
                                    round( t, t.e + DECIMAL_PLACES + 2, 0 );

                                    if ( t.times(t).eq(x) ) {
                                        r = t;
                                        break;
                                    }
                                }

                                dp += 4;
                                s += 4;
                                rep = 1;
                            } else {

                                // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                                // result. If not, then there are further digits and m will be truthy.
                                if ( !+n || !+n.slice(1) && n.charAt(0) == '5' ) {

                                    // Truncate to the first rounding digit.
                                    round( r, r.e + DECIMAL_PLACES + 2, 1 );
                                    m = !r.times(r).eq(x);
                                }

                                break;
                            }
                        }
                    }
                }

                return round( r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m );
            };


            /*
             *  n * 0 = 0
             *  n * N = N
             *  n * I = I
             *  0 * n = 0
             *  0 * 0 = 0
             *  0 * N = N
             *  0 * I = N
             *  N * n = N
             *  N * 0 = N
             *  N * N = N
             *  N * I = N
             *  I * n = I
             *  I * 0 = N
             *  I * N = N
             *  I * I = I
             *
             * Return a new BigNumber whose value is the value of this BigNumber times the value of
             * BigNumber(y, b).
             */
            P.times = P.mul = function ( y, b ) {
                var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
                    base, sqrtBase,
                    x = this,
                    xc = x.c,
                    yc = ( id = 17, y = new BigNumber( y, b ) ).c;

                // Either NaN, ±Infinity or ±0?
                if ( !xc || !yc || !xc[0] || !yc[0] ) {

                    // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                    if ( !x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc ) {
                        y.c = y.e = y.s = null;
                    } else {
                        y.s *= x.s;

                        // Return ±Infinity if either is ±Infinity.
                        if ( !xc || !yc ) {
                            y.c = y.e = null;

                        // Return ±0 if either is ±0.
                        } else {
                            y.c = [0];
                            y.e = 0;
                        }
                    }

                    return y;
                }

                e = bitFloor( x.e / LOG_BASE ) + bitFloor( y.e / LOG_BASE );
                y.s *= x.s;
                xcL = xc.length;
                ycL = yc.length;

                // Ensure xc points to longer array and xcL to its length.
                if ( xcL < ycL ) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;

                // Initialise the result array with zeros.
                for ( i = xcL + ycL, zc = []; i--; zc.push(0) );

                base = BASE;
                sqrtBase = SQRT_BASE;

                for ( i = ycL; --i >= 0; ) {
                    c = 0;
                    ylo = yc[i] % sqrtBase;
                    yhi = yc[i] / sqrtBase | 0;

                    for ( k = xcL, j = i + k; j > i; ) {
                        xlo = xc[--k] % sqrtBase;
                        xhi = xc[k] / sqrtBase | 0;
                        m = yhi * xlo + xhi * ylo;
                        xlo = ylo * xlo + ( ( m % sqrtBase ) * sqrtBase ) + zc[j] + c;
                        c = ( xlo / base | 0 ) + ( m / sqrtBase | 0 ) + yhi * xhi;
                        zc[j--] = xlo % base;
                    }

                    zc[j] = c;
                }

                if (c) {
                    ++e;
                } else {
                    zc.splice(0, 1);
                }

                return normalise( y, zc, e );
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber rounded to a maximum of
             * sd significant digits using rounding mode rm, or ROUNDING_MODE if rm is omitted.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toDigits() precision out of range: {sd}'
             * 'toDigits() precision not an integer: {sd}'
             * 'toDigits() rounding mode not an integer: {rm}'
             * 'toDigits() rounding mode out of range: {rm}'
             */
            P.toDigits = function ( sd, rm ) {
                var n = new BigNumber(this);
                sd = sd == null || !isValidInt( sd, 1, MAX, 18, 'precision' ) ? null : sd | 0;
                rm = rm == null || !isValidInt( rm, 0, 8, 18, roundingMode ) ? ROUNDING_MODE : rm | 0;
                return sd ? round( n, sd, rm ) : n;
            };


            /*
             * Return a string representing the value of this BigNumber in exponential notation and
             * rounded using ROUNDING_MODE to dp fixed decimal places.
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toExponential() decimal places not an integer: {dp}'
             * 'toExponential() decimal places out of range: {dp}'
             * 'toExponential() rounding mode not an integer: {rm}'
             * 'toExponential() rounding mode out of range: {rm}'
             */
            P.toExponential = function ( dp, rm ) {
                return format( this,
                  dp != null && isValidInt( dp, 0, MAX, 19 ) ? ~~dp + 1 : null, rm, 19 );
            };


            /*
             * Return a string representing the value of this BigNumber in fixed-point notation rounding
             * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
             *
             * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
             * but e.g. (-0.00001).toFixed(0) is '-0'.
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toFixed() decimal places not an integer: {dp}'
             * 'toFixed() decimal places out of range: {dp}'
             * 'toFixed() rounding mode not an integer: {rm}'
             * 'toFixed() rounding mode out of range: {rm}'
             */
            P.toFixed = function ( dp, rm ) {
                return format( this, dp != null && isValidInt( dp, 0, MAX, 20 )
                  ? ~~dp + this.e + 1 : null, rm, 20 );
            };


            /*
             * Return a string representing the value of this BigNumber in fixed-point notation rounded
             * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
             * of the FORMAT object (see BigNumber.config).
             *
             * FORMAT = {
             *      decimalSeparator : '.',
             *      groupSeparator : ',',
             *      groupSize : 3,
             *      secondaryGroupSize : 0,
             *      fractionGroupSeparator : '\xA0',    // non-breaking space
             *      fractionGroupSize : 0
             * };
             *
             * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toFormat() decimal places not an integer: {dp}'
             * 'toFormat() decimal places out of range: {dp}'
             * 'toFormat() rounding mode not an integer: {rm}'
             * 'toFormat() rounding mode out of range: {rm}'
             */
            P.toFormat = function ( dp, rm ) {
                var str = format( this, dp != null && isValidInt( dp, 0, MAX, 21 )
                  ? ~~dp + this.e + 1 : null, rm, 21 );

                if ( this.c ) {
                    var i,
                        arr = str.split('.'),
                        g1 = +FORMAT.groupSize,
                        g2 = +FORMAT.secondaryGroupSize,
                        groupSeparator = FORMAT.groupSeparator,
                        intPart = arr[0],
                        fractionPart = arr[1],
                        isNeg = this.s < 0,
                        intDigits = isNeg ? intPart.slice(1) : intPart,
                        len = intDigits.length;

                    if (g2) i = g1, g1 = g2, g2 = i, len -= i;

                    if ( g1 > 0 && len > 0 ) {
                        i = len % g1 || g1;
                        intPart = intDigits.substr( 0, i );

                        for ( ; i < len; i += g1 ) {
                            intPart += groupSeparator + intDigits.substr( i, g1 );
                        }

                        if ( g2 > 0 ) intPart += groupSeparator + intDigits.slice(i);
                        if (isNeg) intPart = '-' + intPart;
                    }

                    str = fractionPart
                      ? intPart + FORMAT.decimalSeparator + ( ( g2 = +FORMAT.fractionGroupSize )
                        ? fractionPart.replace( new RegExp( '\\d{' + g2 + '}\\B', 'g' ),
                          '$&' + FORMAT.fractionGroupSeparator )
                        : fractionPart )
                      : intPart;
                }

                return str;
            };


            /*
             * Return a string array representing the value of this BigNumber as a simple fraction with
             * an integer numerator and an integer denominator. The denominator will be a positive
             * non-zero value less than or equal to the specified maximum denominator. If a maximum
             * denominator is not specified, the denominator will be the lowest value necessary to
             * represent the number exactly.
             *
             * [md] {number|string|BigNumber} Integer >= 1 and < Infinity. The maximum denominator.
             *
             * 'toFraction() max denominator not an integer: {md}'
             * 'toFraction() max denominator out of range: {md}'
             */
            P.toFraction = function (md) {
                var arr, d0, d2, e, exp, n, n0, q, s,
                    k = ERRORS,
                    x = this,
                    xc = x.c,
                    d = new BigNumber(ONE),
                    n1 = d0 = new BigNumber(ONE),
                    d1 = n0 = new BigNumber(ONE);

                if ( md != null ) {
                    ERRORS = false;
                    n = new BigNumber(md);
                    ERRORS = k;

                    if ( !( k = n.isInt() ) || n.lt(ONE) ) {

                        if (ERRORS) {
                            raise( 22,
                              'max denominator ' + ( k ? 'out of range' : 'not an integer' ), md );
                        }

                        // ERRORS is false:
                        // If md is a finite non-integer >= 1, round it to an integer and use it.
                        md = !k && n.c && round( n, n.e + 1, 1 ).gte(ONE) ? n : null;
                    }
                }

                if ( !xc ) return x.toString();
                s = coeffToString(xc);

                // Determine initial denominator.
                // d is a power of 10 and the minimum max denominator that specifies the value exactly.
                e = d.e = s.length - x.e - 1;
                d.c[0] = POWS_TEN[ ( exp = e % LOG_BASE ) < 0 ? LOG_BASE + exp : exp ];
                md = !md || n.cmp(d) > 0 ? ( e > 0 ? d : n1 ) : n;

                exp = MAX_EXP;
                MAX_EXP = 1 / 0;
                n = new BigNumber(s);

                // n0 = d1 = 0
                n0.c[0] = 0;

                for ( ; ; )  {
                    q = div( n, d, 0, 1 );
                    d2 = d0.plus( q.times(d1) );
                    if ( d2.cmp(md) == 1 ) break;
                    d0 = d1;
                    d1 = d2;
                    n1 = n0.plus( q.times( d2 = n1 ) );
                    n0 = d2;
                    d = n.minus( q.times( d2 = d ) );
                    n = d2;
                }

                d2 = div( md.minus(d0), d1, 0, 1 );
                n0 = n0.plus( d2.times(n1) );
                d0 = d0.plus( d2.times(d1) );
                n0.s = n1.s = x.s;
                e *= 2;

                // Determine which fraction is closer to x, n0/d0 or n1/d1
                arr = div( n1, d1, e, ROUNDING_MODE ).minus(x).abs().cmp(
                      div( n0, d0, e, ROUNDING_MODE ).minus(x).abs() ) < 1
                        ? [ n1.toString(), d1.toString() ]
                        : [ n0.toString(), d0.toString() ];

                MAX_EXP = exp;
                return arr;
            };


            /*
             * Return the value of this BigNumber converted to a number primitive.
             */
            P.toNumber = function () {
                return +this;
            };


            /*
             * Return a BigNumber whose value is the value of this BigNumber raised to the power n.
             * If m is present, return the result modulo m.
             * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
             * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using
             * ROUNDING_MODE.
             *
             * The modular power operation works efficiently when x, n, and m are positive integers,
             * otherwise it is equivalent to calculating x.toPower(n).modulo(m) (with POW_PRECISION 0).
             *
             * n {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
             * [m] {number|string|BigNumber} The modulus.
             *
             * 'pow() exponent not an integer: {n}'
             * 'pow() exponent out of range: {n}'
             *
             * Performs 54 loop iterations for n of 9007199254740991.
             */
            P.toPower = P.pow = function ( n, m ) {
                var k, y, z,
                    i = mathfloor( n < 0 ? -n : +n ),
                    x = this;

                if ( m != null ) {
                    id = 23;
                    m = new BigNumber(m);
                }

                // Pass ±Infinity to Math.pow if exponent is out of range.
                if ( !isValidInt( n, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER, 23, 'exponent' ) &&
                  ( !isFinite(n) || i > MAX_SAFE_INTEGER && ( n /= 0 ) ||
                    parseFloat(n) != n && !( n = NaN ) ) || n == 0 ) {
                    k = Math.pow( +x, n );
                    return new BigNumber( m ? k % m : k );
                }

                if (m) {
                    if ( n > 1 && x.gt(ONE) && x.isInt() && m.gt(ONE) && m.isInt() ) {
                        x = x.mod(m);
                    } else {
                        z = m;

                        // Nullify m so only a single mod operation is performed at the end.
                        m = null;
                    }
                } else if (POW_PRECISION) {

                    // Truncating each coefficient array to a length of k after each multiplication
                    // equates to truncating significant digits to POW_PRECISION + [28, 41],
                    // i.e. there will be a minimum of 28 guard digits retained.
                    // (Using + 1.5 would give [9, 21] guard digits.)
                    k = mathceil( POW_PRECISION / LOG_BASE + 2 );
                }

                y = new BigNumber(ONE);

                for ( ; ; ) {
                    if ( i % 2 ) {
                        y = y.times(x);
                        if ( !y.c ) break;
                        if (k) {
                            if ( y.c.length > k ) y.c.length = k;
                        } else if (m) {
                            y = y.mod(m);
                        }
                    }

                    i = mathfloor( i / 2 );
                    if ( !i ) break;
                    x = x.times(x);
                    if (k) {
                        if ( x.c && x.c.length > k ) x.c.length = k;
                    } else if (m) {
                        x = x.mod(m);
                    }
                }

                if (m) return y;
                if ( n < 0 ) y = ONE.div(y);

                return z ? y.mod(z) : k ? round( y, POW_PRECISION, ROUNDING_MODE ) : y;
            };


            /*
             * Return a string representing the value of this BigNumber rounded to sd significant digits
             * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
             * necessary to represent the integer part of the value in fixed-point notation, then use
             * exponential notation.
             *
             * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
             * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
             *
             * 'toPrecision() precision not an integer: {sd}'
             * 'toPrecision() precision out of range: {sd}'
             * 'toPrecision() rounding mode not an integer: {rm}'
             * 'toPrecision() rounding mode out of range: {rm}'
             */
            P.toPrecision = function ( sd, rm ) {
                return format( this, sd != null && isValidInt( sd, 1, MAX, 24, 'precision' )
                  ? sd | 0 : null, rm, 24 );
            };


            /*
             * Return a string representing the value of this BigNumber in base b, or base 10 if b is
             * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
             * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
             * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
             * TO_EXP_NEG, return exponential notation.
             *
             * [b] {number} Integer, 2 to 64 inclusive.
             *
             * 'toString() base not an integer: {b}'
             * 'toString() base out of range: {b}'
             */
            P.toString = function (b) {
                var str,
                    n = this,
                    s = n.s,
                    e = n.e;

                // Infinity or NaN?
                if ( e === null ) {

                    if (s) {
                        str = 'Infinity';
                        if ( s < 0 ) str = '-' + str;
                    } else {
                        str = 'NaN';
                    }
                } else {
                    str = coeffToString( n.c );

                    if ( b == null || !isValidInt( b, 2, 64, 25, 'base' ) ) {
                        str = e <= TO_EXP_NEG || e >= TO_EXP_POS
                          ? toExponential( str, e )
                          : toFixedPoint( str, e );
                    } else {
                        str = convertBase( toFixedPoint( str, e ), b | 0, 10, s );
                    }

                    if ( s < 0 && n.c[0] ) str = '-' + str;
                }

                return str;
            };


            /*
             * Return a new BigNumber whose value is the value of this BigNumber truncated to a whole
             * number.
             */
            P.truncated = P.trunc = function () {
                return round( new BigNumber(this), this.e + 1, 1 );
            };


            /*
             * Return as toString, but do not accept a base argument, and include the minus sign for
             * negative zero.
             */
            P.valueOf = P.toJSON = function () {
                var str,
                    n = this,
                    e = n.e;

                if ( e === null ) return n.toString();

                str = coeffToString( n.c );

                str = e <= TO_EXP_NEG || e >= TO_EXP_POS
                    ? toExponential( str, e )
                    : toFixedPoint( str, e );

                return n.s < 0 ? '-' + str : str;
            };


            P.isBigNumber = true;

            if ( config != null ) BigNumber.config(config);

            return BigNumber;
        }


        // PRIVATE HELPER FUNCTIONS


        function bitFloor(n) {
            var i = n | 0;
            return n > 0 || n === i ? i : i - 1;
        }


        // Return a coefficient array as a string of base 10 digits.
        function coeffToString(a) {
            var s, z,
                i = 1,
                j = a.length,
                r = a[0] + '';

            for ( ; i < j; ) {
                s = a[i++] + '';
                z = LOG_BASE - s.length;
                for ( ; z--; s = '0' + s );
                r += s;
            }

            // Determine trailing zeros.
            for ( j = r.length; r.charCodeAt(--j) === 48; );
            return r.slice( 0, j + 1 || 1 );
        }


        // Compare the value of BigNumbers x and y.
        function compare( x, y ) {
            var a, b,
                xc = x.c,
                yc = y.c,
                i = x.s,
                j = y.s,
                k = x.e,
                l = y.e;

            // Either NaN?
            if ( !i || !j ) return null;

            a = xc && !xc[0];
            b = yc && !yc[0];

            // Either zero?
            if ( a || b ) return a ? b ? 0 : -j : i;

            // Signs differ?
            if ( i != j ) return i;

            a = i < 0;
            b = k == l;

            // Either Infinity?
            if ( !xc || !yc ) return b ? 0 : !xc ^ a ? 1 : -1;

            // Compare exponents.
            if ( !b ) return k > l ^ a ? 1 : -1;

            j = ( k = xc.length ) < ( l = yc.length ) ? k : l;

            // Compare digit by digit.
            for ( i = 0; i < j; i++ ) if ( xc[i] != yc[i] ) return xc[i] > yc[i] ^ a ? 1 : -1;

            // Compare lengths.
            return k == l ? 0 : k > l ^ a ? 1 : -1;
        }


        /*
         * Return true if n is a valid number in range, otherwise false.
         * Use for argument validation when ERRORS is false.
         * Note: parseInt('1e+1') == 1 but parseFloat('1e+1') == 10.
         */
        function intValidatorNoErrors( n, min, max ) {
            return ( n = truncate(n) ) >= min && n <= max;
        }


        function isArray(obj) {
            return Object.prototype.toString.call(obj) == '[object Array]';
        }


        /*
         * Convert string of baseIn to an array of numbers of baseOut.
         * Eg. convertBase('255', 10, 16) returns [15, 15].
         * Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
         */
        function toBaseOut( str, baseIn, baseOut ) {
            var j,
                arr = [0],
                arrL,
                i = 0,
                len = str.length;

            for ( ; i < len; ) {
                for ( arrL = arr.length; arrL--; arr[arrL] *= baseIn );
                arr[ j = 0 ] += ALPHABET.indexOf( str.charAt( i++ ) );

                for ( ; j < arr.length; j++ ) {

                    if ( arr[j] > baseOut - 1 ) {
                        if ( arr[j + 1] == null ) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
            }

            return arr.reverse();
        }


        function toExponential( str, e ) {
            return ( str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str ) +
              ( e < 0 ? 'e' : 'e+' ) + e;
        }


        function toFixedPoint( str, e ) {
            var len, z;

            // Negative exponent?
            if ( e < 0 ) {

                // Prepend zeros.
                for ( z = '0.'; ++e; z += '0' );
                str = z + str;

            // Positive exponent
            } else {
                len = str.length;

                // Append zeros.
                if ( ++e > len ) {
                    for ( z = '0', e -= len; --e; z += '0' );
                    str += z;
                } else if ( e < len ) {
                    str = str.slice( 0, e ) + '.' + str.slice(e);
                }
            }

            return str;
        }


        function truncate(n) {
            n = parseFloat(n);
            return n < 0 ? mathceil(n) : mathfloor(n);
        }


        // EXPORT


        BigNumber = constructorFactory();
        BigNumber['default'] = BigNumber.BigNumber = BigNumber;


        // AMD.
        if ( module.exports ) {
            module.exports = BigNumber;

        // Browser.
        } else {
            if ( !globalObj ) globalObj = typeof self != 'undefined' ? self : Function('return this')();
            globalObj.BigNumber = BigNumber;
        }
    })(commonjsGlobal);
    }(bignumber));

    var BigNumber = bignumber.exports;

    /**
     * Some general purpose utils to make managing Stellar data easier
     */
    // ********** CONST **********
    // Transformations require some use of constants
    var SHIFT_CONST = 15;
    // ********** Object Transformers ********** //
    /**
     * Transform the Horizon.BalanceLine object into a consistent KV store for relevant balances
     * @param horizonBalances - The BalanceLines for the account
     * @param xlmReserve - The amount of XLM that is required for a minimum balance
     * @returns A Record KV such that <assetId, balance>
     */
    function ToBalanceRecord(horizonBalances, xlmReserve) {
        var balances = {};
        for (var _i = 0, horizonBalances_1 = horizonBalances; _i < horizonBalances_1.length; _i++) {
            var bl = horizonBalances_1[_i];
            switch (bl.asset_type) {
                case 'native':
                    balances[NATIVE] = new bignumber.exports.BigNumber(bl.balance)
                        .minus(bl.selling_liabilities)
                        .minus(xlmReserve)
                        .toFixed(7, bignumber.exports.BigNumber.ROUND_DOWN);
                    break;
                case 'credit_alphanum4':
                case 'credit_alphanum12':
                    var assetId = "".concat(bl.asset_code, ":").concat(bl.asset_issuer);
                    balances[assetId] = new bignumber.exports.BigNumber(bl.balance)
                        .minus(bl.selling_liabilities)
                        .toFixed(7, bignumber.exports.BigNumber.ROUND_DOWN);
                    break;
                default:
                    continue;
            }
        }
        return balances;
    }
    /**
     * Transform the ServerApi.PaymentPathRecord object into a useful object
     * @param pathRecord
     * @returns An array of pathPayments with useful info
     */
    function ToPaymentPath(pathRecord) {
        var sendAssetId = getAssetIdFromObject(pathRecord.source_asset_type, pathRecord.source_asset_issuer, pathRecord.source_asset_code);
        var destAssetId = getAssetIdFromObject(pathRecord.destination_asset_type, pathRecord.destination_asset_issuer, pathRecord.destination_asset_code);
        if (!sendAssetId || !destAssetId) {
            throw new Error('Invalid asset type. When did LP shares become transferrable?');
        }
        var path = [];
        for (var _i = 0, _a = pathRecord.path; _i < _a.length; _i++) {
            var stop = _a[_i];
            var id = getAssetIdFromObject(stop.asset_type, stop.asset_issuer, stop.asset_code);
            if (!id)
                throw new Error('Invalid asset type. When did LP shares become transferrable?');
            path.push(id);
        }
        return {
            sendAmount: pathRecord.source_amount,
            sendAssetId: sendAssetId,
            destAmount: pathRecord.destination_amount,
            destAssetId: destAssetId,
            path: path,
        };
    }
    /**
     * Transform the ServerApi.OfferRecord object into a vote object
     * @param offerRecord
     * @returns The vote object, or undefined if the offer is not a valid vote
     */
    function ToVote(offerRecord) {
        var sellingAssetId = getAssetIdFromObject(offerRecord.selling.asset_type, offerRecord.selling.asset_issuer, offerRecord.selling.asset_code);
        if (offerRecord.price !== '1.0000000' || sellingAssetId !== VYBX_TOKEN) {
            return undefined;
        }
        // offer record represents a vote object
        var buyingAssetid = getAssetIdFromObject(offerRecord.buying.asset_type, offerRecord.buying.asset_issuer, offerRecord.buying.asset_code);
        return {
            offerId: offerRecord.id.toString(),
            amount: offerRecord.amount,
            assetId: buyingAssetid,
        };
    }
    /**
     * Transform a Trade into a BigNumber
     * @note
     * This is only for special trades like `Issuance Trades` where the base and counter
     * amounts make up the exponent and mantissa such that:
     *
     * exponent (base 10) -> base - 15
     *
     * mantissa (base 10) -> counter
     *
     * @param trade - The Trade Record to transform
     * @returns A BigNumber
     * @throws If the trade is malformed
     */
    function tradeToNumber(trade) {
        // if both amounts are stellar min the issuanceRatio is 0
        if (trade.base_amount === STELLAR_MIN && trade.counter_amount === STELLAR_MIN) {
            return new bignumber.exports.BigNumber(0);
        }
        // exponent (base 10) -> counter - 15
        // mantissa (base 10) -> base
        var exponent = Math.round(parseFloat(trade.counter_amount) - SHIFT_CONST);
        return new bignumber.exports.BigNumber(trade.base_amount).shift(exponent);
    }
    // ********** Asset Id Helpers ********** //
    /**
     * Creates an asset object from an assetId
     * @param {string} assetId
     * @returns Asset object
     */
    function getAssetFromId(assetId) {
        if (assetId === 'XLM:native') {
            return stellarSdk.Asset.native();
        }
        var assetIdCodes = assetId.split(':');
        return new stellarSdk.Asset(assetIdCodes[0], assetIdCodes[1]);
    }
    /**
     * Creates an assetId from a horizon object that includes an asset
     * @param {string} asset_type Asset type. Only native or credit_alphanum types supported
     * @param {string} asset_issuer Asset issuer (optional)
     * @param {string} asset_code Asset code (optional)
     * @returns assetId if the asset is valid, undefined otherwise
     */
    function getAssetIdFromObject(asset_type, asset_issuer, asset_code) {
        switch (asset_type) {
            case 'native':
                return NATIVE;
            case 'credit_alphanum4':
            case 'credit_alphanum12':
                return "".concat(asset_code, ":").concat(asset_issuer);
            default:
                throw new Error('Invalid object');
        }
    }

    var transformer = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ToBalanceRecord: ToBalanceRecord,
        ToPaymentPath: ToPaymentPath,
        ToVote: ToVote,
        tradeToNumber: tradeToNumber,
        getAssetFromId: getAssetFromId,
        getAssetIdFromObject: getAssetIdFromObject
    });

    /**
     * Get the Unix time (s since epoch) from an arbitrarily long ISO string
     * Required to store numbers in claimable balance predicates
     * JS and Stellar inconsistent with ISO-8601 formatting past year 9999
     * @param isoString - The ISO-8601 timestamp
     * @returns A BigNumber as a Timestamp
     */
    function getUnixTimeFromIsoString(isoString) {
        var tm = _getTimestampFromString(isoString);
        return _getUnixTimestamp(tm);
    }
    function _getUnixTimestamp(timestamp) {
        var dayOfYear = _getDayOfYear(timestamp);
        timestamp.tm_yday = dayOfYear;
        var secondsInCurrentYear = new BigNumber(timestamp.tm_sec + timestamp.tm_min * 60 + timestamp.tm_hour * 3600 + timestamp.tm_yday * 86400);
        var secondsSince1970 = new BigNumber(timestamp.tm_year - 1970).times(31536000);
        var leapDaysSince1973 = Math.floor((timestamp.tm_year - 1969) / 4);
        var skipped100YearSince2001 = Math.floor((timestamp.tm_year - 1901) / 100);
        var added400YearStart2001 = Math.floor((timestamp.tm_year - 1601) / 400);
        var secondsFromLeapDaysSince1973 = new BigNumber(leapDaysSince1973 - skipped100YearSince2001 + added400YearStart2001).times(86400);
        var unixTimestamp = secondsInCurrentYear
            .plus(secondsSince1970)
            .plus(secondsFromLeapDaysSince1973);
        return unixTimestamp;
    }
    function _getTimestampFromString(isoString) {
        var iso8601 = isoString.split('T');
        var ymd = iso8601[0].split('-');
        var hms = iso8601[1].split(':');
        var year = ymd[0];
        if (year[0] === '+') {
            year = year.slice(1);
        }
        var second = hms[2].split('.')[0];
        if (second[second.length - 1] === 'Z') {
            second = second.slice(0, -1);
        }
        return {
            tm_sec: parseFloat(second),
            tm_min: parseFloat(hms[1]),
            tm_hour: parseFloat(hms[0]),
            tm_mday: parseFloat(ymd[2]),
            tm_mon: parseFloat(ymd[1]),
            tm_year: parseFloat(year),
            tm_yday: 0,
        };
    }
    function _getDayOfYear(timestamp) {
        var leapYear = _isLeapYear(timestamp.tm_year);
        var dayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        var dayOfYear = dayCount[timestamp.tm_mon - 1] + timestamp.tm_mday - 1;
        if (timestamp.tm_mon > 1 && leapYear)
            dayOfYear++;
        return dayOfYear;
    }
    function _isLeapYear(year) {
        // if year is not divisible by 4, return false
        if (year % 4 !== 0)
            return false;
        // if year IS divisible by 4
        // -> if year is not evenly divisible by 100 OR if year is divisible by 400, return true
        return year % 100 !== 0 || year % 400 === 0;
    }

    /**
     * Helper utils for determining valid predicates
     */
    // ========== Verify Predicates ==========
    /**
     * Verify a predicate can unconditionally claim
     * @param predicate - The predicate to verify
     * @returns If the predicate is unconditional
     */
    function VerifyUnconditionalPredicate(predicate) {
        // @ts-ignore - TODO: Submit issue
        if (predicate.unconditional)
            return true;
        return false;
    }
    /**
     * Verify a predicate can never claim
     * @param predicate - The predicate to verify
     * @returns If the predicate can never claim
     */
    function VerifyNeverPredicate(predicate) {
        var _a;
        // @ts-ignore - TODO: Submit issue
        if ((_a = predicate.not) === null || _a === void 0 ? void 0 : _a.unconditional)
            return true;
        return false;
    }
    // ========== Read Predicates ==========
    function numberFromPredicate(predicate) {
        var _a;
        var before;
        if (predicate.abs_before) {
            before = predicate.abs_before;
        }
        else if ((_a = predicate.not) === null || _a === void 0 ? void 0 : _a.abs_before) {
            before = predicate.not.abs_before;
        }
        if (!before)
            throw new Error('incorrect predicate');
        var seconds = getUnixTimeFromIsoString(before);
        return seconds.shift(-7);
    }

    var predicates = /*#__PURE__*/Object.freeze({
        __proto__: null,
        VerifyUnconditionalPredicate: VerifyUnconditionalPredicate,
        VerifyNeverPredicate: VerifyNeverPredicate,
        numberFromPredicate: numberFromPredicate
    });

    // TODO: Talk to mark
    /**
     * Utils to help extract information out of transaction objects
     */
    function getOpMetadata(opXdr, op, poolId) {
        // operation! Get what we need :)
        var delta;
        var account;
        var asset;
        var destination;
        switch (op.type) {
            case 'payment':
                delta = new BigNumber(op.amount);
                account = op.destination;
                asset = op.asset;
                destination = op.destination;
                if (op.source === poolId) {
                    delta = delta.times(-1);
                    account = poolId;
                    if (op.destination === poolId) {
                        delta = new BigNumber(0);
                    }
                }
                break;
            case 'pathPaymentStrictReceive':
                account = op.destination;
                asset = op.destAsset;
                delta = _decodePathPaymentDelta(opXdr.changes(), account, asset);
                break;
            case 'claimClaimableBalance':
                if (op.source === undefined) {
                    return undefined; // the pool account has to be the source of a cb to be valid
                }
                account = op.source;
                var claim = _decodeClaimableBalanceChange(opXdr.changes());
                if (claim) {
                    delta = claim.amount;
                    asset = claim.asset;
                }
                break;
            case 'createClaimableBalance':
                if (op.source === undefined) {
                    return undefined;
                }
                account = op.source;
                delta = new BigNumber(op.amount).times(-1); // this money is leaving the source
                asset = op.asset;
                break;
            case 'clawback':
                // clawbacks are only relevant if issued / clawed by the pool
                if (op.source !== poolId) {
                    return undefined;
                }
                account = poolId;
                delta = new BigNumber(op.amount); // this money is entering the pool
                asset = op.asset;
                break;
            case 'clawbackClaimableBalance':
                // clawbacks are only relevant if issued / clawed by the pool
                if (op.source !== poolId) {
                    return undefined;
                }
                account = op.source;
                var clawback = _decodeClaimableBalanceChange(opXdr.changes());
                if (clawback) {
                    delta = clawback.amount;
                    asset = clawback.asset;
                }
                break;
            default:
                return undefined;
        }
        if (account === undefined || delta === undefined || asset === undefined) {
            return undefined;
        }
        return {
            asset: asset,
            delta: delta,
            account: account,
            destination: destination,
        };
    }
    function _decodePathPaymentDelta(changes, account, asset) {
        var balanceUpdated = changes.find(function (c) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            try {
                if (!asset.isNative()) {
                    return (_toAccountId((_c = (_b = (_a = c.updated()) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b.trustLine()) === null || _c === void 0 ? void 0 : _c.accountId()) === account &&
                        ((_g = _toAsset((_f = (_e = (_d = c.updated()) === null || _d === void 0 ? void 0 : _d.data()) === null || _e === void 0 ? void 0 : _e.trustLine()) === null || _f === void 0 ? void 0 : _f.asset())) === null || _g === void 0 ? void 0 : _g.equals(asset)));
                }
                return _toAccountId((_k = (_j = (_h = c.updated()) === null || _h === void 0 ? void 0 : _h.data()) === null || _j === void 0 ? void 0 : _j.account()) === null || _k === void 0 ? void 0 : _k.accountId()) === account;
            }
            catch (e) {
                // this gets mad when it doesn't exists instead of being undefined like a good boy
                return false;
            }
        });
        var balanceState = changes.find(function (c) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            try {
                if (!asset.isNative()) {
                    return (_toAccountId((_c = (_b = (_a = c.state()) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b.trustLine()) === null || _c === void 0 ? void 0 : _c.accountId()) === account &&
                        ((_g = _toAsset((_f = (_e = (_d = c.state()) === null || _d === void 0 ? void 0 : _d.data()) === null || _e === void 0 ? void 0 : _e.trustLine()) === null || _f === void 0 ? void 0 : _f.asset())) === null || _g === void 0 ? void 0 : _g.equals(asset)));
                }
                return _toAccountId((_k = (_j = (_h = c.state()) === null || _h === void 0 ? void 0 : _h.data()) === null || _j === void 0 ? void 0 : _j.account()) === null || _k === void 0 ? void 0 : _k.accountId()) === account;
            }
            catch (e) {
                // this gets mad when it doesn't exists instead of being undefined like a good boy
                return false;
            }
        });
        if (!balanceState || !balanceUpdated) {
            return undefined;
        }
        if (asset.isNative()) {
            return _toBigNumber(balanceUpdated.updated().data().account().balance()).minus(_toBigNumber(balanceState.state().data().account().balance()));
        }
        return _toBigNumber(balanceUpdated.updated().data().trustLine().balance()).minus(_toBigNumber(balanceState.state().data().trustLine().balance()));
    }
    function _decodeClaimableBalanceChange(changes) {
        var _a, _b;
        var claimChange = changes.find(function (c) {
            var _a, _b;
            try {
                // @ts-ignore
                return ((_b = (_a = c.state()) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b._arm) === 'claimableBalance';
            }
            catch (e) {
                // this gets mad when it doesn't exists instead of being undefined like a good boy
                return false;
            }
        });
        var claimData = (_b = (_a = claimChange === null || claimChange === void 0 ? void 0 : claimChange.state()) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b.claimableBalance();
        if (claimData === undefined)
            return undefined;
        var asset = _toAsset(claimData.asset());
        var amount = _toBigNumber(claimData.amount());
        if (asset === undefined || amount === undefined) {
            return undefined;
        }
        return {
            asset: asset,
            amount: amount,
        };
    }
    function _toAsset(xdrAsset) {
        switch (xdrAsset.switch()) {
            case stellarSdk.xdr.AssetType.assetTypeCreditAlphanum4():
                var alphaNum4 = xdrAsset.alphaNum4();
                return new stellarSdk.Asset(alphaNum4.assetCode().toString().replace(/\0/g, ''), stellarSdk.StrKey.encodeEd25519PublicKey(alphaNum4.issuer().ed25519()));
            case stellarSdk.xdr.AssetType.assetTypeCreditAlphanum12():
                var alphaNum12 = xdrAsset.alphaNum12();
                return new stellarSdk.Asset(alphaNum12.assetCode().toString().replace(/\0/g, ''), stellarSdk.StrKey.encodeEd25519PublicKey(alphaNum12.issuer().ed25519()));
            case stellarSdk.xdr.AssetType.assetTypeNative():
                return stellarSdk.Asset.native();
            default:
                // not a supported asset type, ignore
                return undefined;
        }
    }
    function _toBigNumber(xdrNum) {
        return new BigNumber(xdrNum.toString()).shift(XDR_NUMBER_SHIFT);
    }
    function _matchAccount(xdrAccount, accountId) {
        return _toAccountId(xdrAccount.accountId()) === accountId;
    }
    function _matchTrustline(xdrTrustline, accountId, asset) {
        if (_toAccountId(xdrTrustline.accountId()) === accountId) {
            var assetFromXdr = _toAsset(xdrTrustline.asset());
            if (assetFromXdr && asset.equals(assetFromXdr))
                return true;
        }
        return false;
    }
    function _toAccountId(account) {
        return stellarSdk.StrKey.encodeEd25519PublicKey(account.ed25519());
    }
    function getStartingBalance(opXdr, accountId, asset) {
        var _a, _b, _c, _d;
        var balance;
        var changes = opXdr.changes();
        for (var _i = 0, changes_1 = changes; _i < changes_1.length; _i++) {
            var change = changes_1[_i];
            if (asset.isNative()) {
                var xdrAccount = void 0;
                try {
                    xdrAccount = (_b = (_a = change.state()) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b.account();
                }
                catch (_e) {
                    continue;
                }
                if (_matchAccount(xdrAccount, accountId)) {
                    balance = _toBigNumber(xdrAccount.balance());
                }
            }
            else {
                var xdrTrustline = void 0;
                try {
                    xdrTrustline = (_d = (_c = change.state()) === null || _c === void 0 ? void 0 : _c.data()) === null || _d === void 0 ? void 0 : _d.trustLine();
                }
                catch (_f) {
                    continue;
                }
                if (_matchTrustline(xdrTrustline, accountId, asset)) {
                    balance = _toBigNumber(xdrTrustline.balance());
                }
            }
        }
        return balance;
    }

    var opParser = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getOpMetadata: getOpMetadata,
        getStartingBalance: getStartingBalance
    });

    function GetAccrualDataFromTransaction(txRecord, poolAsset) {
        var block = txRecord.ledger_attr;
        var time = new Date(txRecord.created_at).getTime();
        var poolBalance;
        var trackerBalance;
        var trackerPayment;
        var trackerCorrection = new BigNumber(0); // might not exist
        var deltaLiabilities = new BigNumber(0);
        var deltaUnderlying = new BigNumber(0);
        var tx = new stellarSdk.Transaction(txRecord.envelope_xdr, stellarSdk.Networks.PUBLIC);
        var resultTx = stellarSdk.xdr.TransactionMeta.fromXDR(txRecord.result_meta_xdr, 'base64');
        var underlying = getAssetFromId(poolAsset.underlyingId);
        var liability = getAssetFromId(poolAsset.liabilityTokenId);
        var tracker = getAssetFromId(poolAsset.accrualTokenId);
        // iterate through operations
        for (var i = 0; i < tx.operations.length; i++) {
            var opMeta = getOpMetadata(resultTx.v2().operations()[i], tx.operations[i], poolAsset.pool.id);
            if (opMeta) {
                if (opMeta.asset.equals(underlying) && opMeta.account === poolAsset.pool.id) {
                    deltaUnderlying = deltaUnderlying.plus(opMeta.delta);
                }
                else if (opMeta.asset.equals(liability) && opMeta.account === poolAsset.pool.id) {
                    deltaLiabilities = deltaLiabilities.minus(opMeta.delta);
                }
                else if (opMeta.asset.equals(tracker) && opMeta.account === poolAsset.pool.id) {
                    if (trackerPayment === undefined) {
                        trackerPayment = opMeta.delta.times(-1);
                        if (opMeta.destination && opMeta.destination === ESCROW_ACCOUNT_ID)
                            trackerPayment = new BigNumber(0);
                    }
                    else {
                        trackerCorrection = opMeta.delta.times(-1);
                    }
                }
            }
        }
        if (trackerPayment === undefined) {
            return undefined;
        }
        // need to fetch the starting balances of the poolAccount and trackerAccount
        for (var _i = 0, _a = resultTx.v2().operations(); _i < _a.length; _i++) {
            var op = _a[_i];
            if (poolBalance && trackerBalance)
                break;
            if (poolBalance === undefined) {
                var startingBal = getStartingBalance(op, poolAsset.pool.id, underlying);
                if (startingBal)
                    poolBalance = startingBal;
            }
            if (trackerBalance === undefined) {
                var startingBal = getStartingBalance(op, poolAsset.data.trackingAccountId, tracker);
                if (startingBal)
                    trackerBalance = startingBal;
            }
        }
        if (poolBalance === undefined || trackerBalance === undefined) {
            return undefined;
        }
        return {
            block: block,
            timestamp: time,
            poolBalance: poolBalance,
            trackerBalance: trackerBalance,
            trackerPayment: trackerPayment,
            trackerCorrection: trackerCorrection,
            deltaLiabilities: deltaLiabilities,
            deltaUnderlying: deltaUnderlying,
        };
    }

    var txDecoder = /*#__PURE__*/Object.freeze({
        __proto__: null,
        GetAccrualDataFromTransaction: GetAccrualDataFromTransaction
    });

    /**
     * HorizonServer wraps the stellar-sdk Server class
     * @constructor
     * @param {string} horizonUrl Horizon Server URL (ex. `https://horizon-testnet.stellar.org`).
     */
    var HorizonServer = /** @class */ (function () {
        function HorizonServer(horizonUrl) {
            // Note - Stellar users Axios under the hood. Should work for
            //        both browsers and node
            var isTestnet = horizonUrl.includes('testnet');
            if (isTestnet) {
                this.network = stellarSdk.Networks.TESTNET;
                this.USDCAssetId = TESTNET_USDC;
            }
            else {
                this.network = stellarSdk.Networks.PUBLIC;
                this.USDCAssetId = PUBNET_USDC;
            }
            this.server = new stellarSdk.Server(horizonUrl);
            this.horizonUrl = horizonUrl;
        }
        HorizonServer.Configure = function (horizonUrl) {
            HorizonServer.instance = new HorizonServer(horizonUrl);
            return HorizonServer.instance;
        };
        // Gets the configured horizon instance.
        // Throws an exception if it is not configured.
        HorizonServer.getInstance = function () {
            if (HorizonServer.instance) {
                return HorizonServer.instance;
            }
            throw new Error('Horizon not configured');
        };
        // ********** General **********
        /**
         * Collect all responses from a collection page
         * @param task - The collection page
         * @returns All responses
         */
        HorizonServer.PageResponse = function (task) {
            return __awaiter(this, void 0, void 0, function () {
                var entries, page;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            entries = [];
                            return [4 /*yield*/, task];
                        case 1:
                            page = _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!(page.records.length !== 0)) return [3 /*break*/, 4];
                            entries = entries.concat(page.records);
                            return [4 /*yield*/, page.next()];
                        case 3:
                            page = _a.sent();
                            return [3 /*break*/, 2];
                        case 4: return [2 /*return*/, entries];
                    }
                });
            });
        };
        // ********** Account **********
        /**
         * Fetch an account for Horizon
         * @param accountId - The accountId for the account
         * @returns AccountResponse
         */
        HorizonServer.prototype.GetAccountAsync = function (accountId) {
            return __awaiter(this, void 0, void 0, function () {
                var account;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.server.loadAccount(accountId)];
                        case 1:
                            account = _a.sent();
                            return [2 /*return*/, account];
                    }
                });
            });
        };
        // ********** Paths ***********
        /**
         * Fetch path strict receive
         * @param {string[]} sendAssetIds
         * @param {string} destAssetId
         * @param {string} destAmount
         * @returns PathResponse
         */
        HorizonServer.prototype.GetPathStrictReceiveAsync = function (sendAssetIds, destAssetId, destAmount) {
            return __awaiter(this, void 0, void 0, function () {
                var sendAssets, _i, sendAssetIds_1, assetId, destAsset;
                return __generator(this, function (_a) {
                    sendAssets = [];
                    for (_i = 0, sendAssetIds_1 = sendAssetIds; _i < sendAssetIds_1.length; _i++) {
                        assetId = sendAssetIds_1[_i];
                        sendAssets.push(getAssetFromId(assetId));
                    }
                    destAsset = getAssetFromId(destAssetId);
                    return [2 /*return*/, this.server.strictReceivePaths(sendAssets, destAsset, destAmount).limit(10).call()];
                });
            });
        };
        /**
         * Fetch path strict send
         * @param {string[]} sendAssetIds
         * @param {string} destAssetId
         * @param {string} destAmount
         * @returns PathResponse
         */
        HorizonServer.prototype.GetPathStrictSendAsync = function (sendAssetId, destAssetId, sendAmount) {
            return __awaiter(this, void 0, void 0, function () {
                var sendAsset, destAsset;
                return __generator(this, function (_a) {
                    sendAsset = getAssetFromId(sendAssetId);
                    destAsset = getAssetFromId(destAssetId);
                    return [2 /*return*/, this.server.strictSendPaths(sendAsset, sendAmount, [destAsset]).limit(10).call()];
                });
            });
        };
        // ********** Asset **********
        /**
         * Fetch the Asset record for an asset
         * @param assetId - The assetId for the asset to find the record of
         * @returns AssetRecord
         */
        HorizonServer.prototype.GetAssetAsync = function (assetId) {
            return __awaiter(this, void 0, void 0, function () {
                var assetToFind, records;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            assetToFind = getAssetFromId(assetId);
                            return [4 /*yield*/, this.server
                                    .assets()
                                    .forCode(assetToFind.code)
                                    .forIssuer(assetToFind.issuer)
                                    .call()];
                        case 1:
                            records = (_a.sent()).records;
                            if (records.length !== 1) {
                                throw new stellarSdk.NotFoundError('Unable to find unique asset', []);
                            }
                            return [2 /*return*/, records[0]];
                    }
                });
            });
        };
        // ********** Claimable Balances **********
        /**
         * Fetch claimable balances for a given sponsor
         * @param sponsor Account Sponsoring the Claimable Balance
         * @param assetId Asset Sponsored by the Claimable Balance
         * @param claimant Claimant Account on the Claimable Balance
         * @param order Order to list claimable balances in
         * @returns ClaimableBalancesRecord
         */
        HorizonServer.prototype.GetClaimableBalancesAsync = function (sponsor, assetId, claimant, order) {
            return __awaiter(this, void 0, void 0, function () {
                var cbCall;
                return __generator(this, function (_a) {
                    cbCall = this.server.claimableBalances().limit(200);
                    if (sponsor)
                        cbCall = cbCall.sponsor(sponsor);
                    if (assetId)
                        cbCall = cbCall.asset(getAssetFromId(assetId));
                    if (claimant)
                        cbCall = cbCall.claimant(claimant);
                    return [2 /*return*/, cbCall.order(order !== null && order !== void 0 ? order : 'desc').call()];
                });
            });
        };
        // ********** OrderBooks ***********
        /**
         * Gets a stellar orderbook for an asset pair
         * @param {string} selling AssetId of the asset being sold
         * @param {string} buying AssetId of the asset being bought
         * @returns
         */
        HorizonServer.prototype.GetOrderbookAsync = function (selling, buying) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.server
                            .orderbook(getAssetFromId(selling), getAssetFromId(buying))
                            .call()];
                });
            });
        };
        // ********** Trades ***********
        /**
         * Get a TWAP for an asset pair. Puts at most 10 prices prices into 1m buckets.
         * @param sellAssetId - The assetId being sold
         * @param buyAssetId - The assetId being bought
         * @param timestamp - The end time of the TWAP
         * @param duration - Time to look for prices (in minutes)
         * @returns
         */
        HorizonServer.prototype.getTWAPAsync = function (sellAssetId, buyAssetId, timestamp, duration
        // @ts-ignore - TODO: file issue for unexposed api resp.
        ) {
            return __awaiter(this, void 0, void 0, function () {
                var sellAsset, buyAsset, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            sellAsset = getAssetFromId(sellAssetId);
                            buyAsset = getAssetFromId(buyAssetId);
                            return [4 /*yield*/, this.server
                                    .tradeAggregation(sellAsset, buyAsset, timestamp - (duration + 1) * 60 * 1000, timestamp, 60000, 0)
                                    .limit(10)
                                    .order('desc')
                                    .call()];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            error_1 = _a.sent();
                            console.error("Error attempting to TWAP for ".concat(sellAssetId, " -> ").concat(buyAssetId));
                            throw error_1;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * Gets trades for an asset pair
         * @param sellAssetId AssetId being sold
         * @param  buyAssetId AssetId being bought
         */
        HorizonServer.prototype.GetTradesAsync = function (sellAssetId, buyAssetId) {
            return __awaiter(this, void 0, void 0, function () {
                var sellAsset, buyAsset, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            sellAsset = getAssetFromId(sellAssetId);
                            buyAsset = getAssetFromId(buyAssetId);
                            return [4 /*yield*/, this.server
                                    .trades()
                                    .forAssetPair(sellAsset, buyAsset)
                                    .limit(200)
                                    .order('desc')
                                    .call()];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            error_2 = _a.sent();
                            console.error("Error attempting to get trades for ".concat(sellAssetId, ":").concat(buyAssetId));
                            throw error_2;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        // ********** Offers *********
        /**
         * Gets a users offers selling a given asset
         * @param userId user making the offer
         * @param selling AssetId of the asset being sold
         * @returns
         * Remarks
         * - use axios here as the js sdk is missing a seller field
         * - This call will not handle next so it will break with over 200 offers
         */
        HorizonServer.prototype.GetOffersAsync = function (userId, selling) {
            return __awaiter(this, void 0, void 0, function () {
                var resp, data, records, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, axios__default["default"].get("".concat(this.horizonUrl, "/offers?selling=").concat(selling.split(':')[0], "%3A").concat(selling.split(':')[1], "&seller=").concat(userId))];
                        case 1:
                            resp = _a.sent();
                            data = resp.data;
                            records = data._embedded;
                            return [2 /*return*/, records];
                        case 2:
                            error_3 = _a.sent();
                            console.error(error_3);
                            throw error_3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        // ********* Transactions **********
        HorizonServer.prototype.GetTransactionsAsync = function (accountId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.server
                            .transactions()
                            .forAccount(accountId)
                            .includeFailed(false)
                            .limit(200)
                            .order('desc')
                            .call()];
                });
            });
        };
        HorizonServer.prototype.GetTransactionByHashAsync = function (hash) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, this.server.transactions().transaction(hash).call()];
                });
            });
        };
        // ********** Ledger ***********
        HorizonServer.prototype.GetCurrentLedger = function (timestamp) {
            return __awaiter(this, void 0, void 0, function () {
                var ledgers, lastLedger, _i, _a, ledger, ledgerTimestamp;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.server.ledgers().limit(20).order('desc').call()];
                        case 1:
                            ledgers = _b.sent();
                            for (_i = 0, _a = ledgers.records; _i < _a.length; _i++) {
                                ledger = _a[_i];
                                ledgerTimestamp = new Date(ledger.closed_at).getTime();
                                if (ledgerTimestamp < timestamp) {
                                    lastLedger = ledger;
                                    break;
                                }
                            }
                            if (!lastLedger)
                                throw new Error('Unable to find ledger older than timestamp');
                            return [2 /*return*/, lastLedger.sequence];
                    }
                });
            });
        };
        return HorizonServer;
    }());

    var LIB_VERSION = "0.1.43";

    /**
     * A base class for Stellar accounts to manage relevant account information.
     */
    var BaseAccount = /** @class */ (function () {
        /**
         * @param params - The baseAccountParams, constructed from the AccountResponse
         */
        function BaseAccount(params) {
            this.id = params.id;
            this.sequence = params.sequence;
            this.signers = params.signers;
            this.threshold = params.threshold;
            this._balances = params.balances;
        }
        /**
         * Construct the base account params from an accountResponse
         * @param accountResponse - The accountResponse from Horizon
         * @returns The BaseAccountParams
         */
        BaseAccount.getBaseAccountParams = function (accountResponse) {
            var id = accountResponse.id, sequence = accountResponse.sequence, signers = accountResponse.signers;
            var xlmReserve = (2 +
                accountResponse.subentry_count +
                // @ts-ignore - stellar-sdk PR
                accountResponse.num_sponsoring -
                // @ts-ignore - stellar-sdk PR
                accountResponse.num_sponsored) *
                0.5;
            var balances = ToBalanceRecord(accountResponse.balances, xlmReserve);
            var threshold = accountResponse.thresholds.high_threshold;
            return {
                id: id,
                sequence: sequence,
                balances: balances,
                signers: signers,
                threshold: threshold,
            };
        };
        /**
         * Get an accounts balance of a given asset
         * @param assetId - The assetId to get the balance of
         * @returns The amount the account has, or undefined if no trustline exists
         */
        BaseAccount.prototype.getBalance = function (assetId) {
            return this._balances[assetId];
        };
        return BaseAccount;
    }());

    /**
     * Helper functions to ensure safe, consistent math
     *
     * Interface only with Bignumber.js to avoid rounding problems with JS number
     */
    // ********** General **********
    /**
     * Divides two numbers and returns a real number
     * (ex. 2/0 => MAX_NUM and 0/2 => 0
     * @param numberator
     * @param denominator
     */
    function divideToNumber(numberator, denominator) {
        var divided = numberator.dividedBy(denominator);
        if (!divided.isFinite()) {
            if (divided.isNaN())
                return new BigNumber(0);
            return new BigNumber(Number.MAX_SAFE_INTEGER);
        }
        return divided;
    }
    /**
     * Divides two numbers and returns an error if undefined
     * (ex. 2/0 => ERROR and 0/2 => 0
     * @param numberator
     * @param denominator
     */
    function divideToError(numberator, denominator) {
        var divided = numberator.dividedBy(denominator);
        if (!divided.isFinite() || divided.isNaN() || !divided) {
            throw new Error('Error Dividing, something is Undefined or NaN');
        }
        return divided;
    }
    // ********** Pool Token Calculations ***********
    /**
     * Calculates pool token value
     * @param lTokensOut
     * @param trackerBalance
     * @returns
     */
    function PoolTokenValue(pTokensOut, underyingBalance, liabilitiesOut) {
        var numerator = liabilitiesOut.plus(underyingBalance);
        return divideToError(numerator, pTokensOut);
    }
    // ********** Utilization Ratio Calculations **********
    /**
     * Calculates liabilities outstanding
     * @param lTokensOut
     * @param trackerBalance
     * @returns
     */
    function CalcOutstandingLiabilities(lTokensOut, trackerBalance) {
        var numerator = lTokensOut.times(trackerBalance);
        var denominator = new BigNumber(STARTING_irTRACKER_BALANCE);
        return divideToNumber(numerator, denominator);
    }
    /**
     * Calculate the current utilization ratio
     * @param outstandingLiabilities - The outstanding liabilities for a given asset
     * @param poolBalance - The current pool balance / liquidity for a given asset
     * @returns Current Utilization Ratio
     */
    function CalcUtilizationRatio(outstandingLiabilities, poolBalance) {
        return outstandingLiabilities.dividedBy(outstandingLiabilities.plus(poolBalance));
    }
    function CalcOrigUtilizationRatio() {
        return Error();
    }
    function CalcUtilizationAdjustment() {
        return Error();
    }
    function CalcAvgUtilizationRatio() {
        return Error();
    }
    // ********** Interest Rate Calculations **********
    /**
     * Calculate the current spot floating interest rate for an asset
     * @param mktAsset - The market asset data
     * @param utilRate - The current utilization rate for the asset
     * @returns The spot floating interest rate
     */
    function CalcFloatInterestRate(assetData, utilRate) {
        // The borrow spot rate is based on the interest rate curve defined in the asset constants
        // Determine the location on the step function curve and build the result
        var baseRate = function (utilizationRatio) {
            var m = new BigNumber(assetData.slope0);
            return m.times(utilizationRatio).plus(assetData.baseRateConstant);
        };
        var rate1 = function (utilizationRatio) {
            var m = new BigNumber(assetData.slope1);
            return m
                .times(utilizationRatio.minus(assetData.rateThreshold1))
                .plus(baseRate(new BigNumber(assetData.rateThreshold1)));
        };
        var rate2 = function (utilizationRatio) {
            var m = new BigNumber(assetData.slope2);
            return m
                .times(utilizationRatio.minus(assetData.rateThreshold2))
                .plus(rate1(new BigNumber(assetData.rateThreshold2)));
        };
        var rate3 = function (utilizationRatio) {
            var m = new BigNumber(assetData.slope3);
            return m
                .times(utilizationRatio.minus(assetData.rateThreshold3))
                .plus(rate2(new BigNumber(assetData.rateThreshold3)));
        };
        if (utilRate.lessThanOrEqualTo(assetData.rateThreshold1)) {
            return baseRate(utilRate);
        }
        if (utilRate.lessThanOrEqualTo(assetData.rateThreshold2)) {
            return rate1(utilRate);
        }
        if (utilRate.lessThanOrEqualTo(assetData.rateThreshold3)) {
            return rate2(utilRate);
        }
        return rate3(utilRate);
    }
    // export function CalcFixedInterestRate(floatRate: BigNumber, utilRate: BigNumber) {
    //   let floatScaler = floatRate.times(new BigNumber('1.05').minus(utilRate));
    //   return floatRate.plus(floatScaler);
    // }
    /**
     * Calculate the Lending Spot Rate for an asset
     * @param borrowRate - The current borrow spot rate for the asset
     * @param utilRate - The current utilization rate for the asset
     * @returns Calculated Lending interest rate
     */
    function CalcLendInterestRate(borrowRate, utilRate) {
        return borrowRate.times(utilRate);
    }
    /**
     * Calculate a interest accrual payment to an accured interest tracker
     * @param block0 - Block of the accrual before last
     * @param block1 - Block of the last accrual
     * @param interestRate - The interest rate the accrual before last
     * @param balance - The current tracker balance
     * @returns Accrued interest amount
     */
    function CalcAccrual(firstBlock, secondBlock, interestRate, balance) {
        var blockDif = new BigNumber(secondBlock - firstBlock);
        return interestRate.times(balance).dividedBy(BLOCKS_PER_YEAR).times(blockDif);
    }
    /**
     * Calculate the next year worth of YBX being issued
     * @param outstandingYbx - The current YBX on the market
     * @param totalSupply - The
     * @returns
     */
    function CalcYbxIssuanceForYear(outstandingYbx, totalSupply) {
        // this value represents the yearly issuance percentage based on 1
        // year of 0.1% daily issuance #math
        var ybxIssuanceYearly = 0.30593;
        return totalSupply.minus(outstandingYbx).times(ybxIssuanceYearly);
    }
    /**
     * Calculate the amount of YBX being issued to 1 yToken over a year
     * @param ybxIssuanceForYear - The YBX being issued over the next year
     * @param poolTokenRecord - The record for the yToken
     * @param yTokenRate - The conversion rate from yToken to underlying
     * @param assetData - The asset data for the underlying token
     * @returns The YBX per underlying per year
     */
    function CalcLendYbxTokenYield(ybxIssuanceForYear, poolTokenRecord, yTokenRate, assetData) {
        var issuanceForAsset = ybxIssuanceForYear.times(assetData.lendingAllocation);
        // get market in terms of underlying for easier pricing
        var marketUnderlying = yTokenRate.times(poolTokenRecord.claimable_balances_amount);
        return issuanceForAsset.dividedBy(marketUnderlying);
    }
    /**
     * Calculate the amount of YBX being issued to 1 lToken over a year
     * @param ybxIssuanceForYear - The YBX being issued over the next year
     * @param outstandingLiabilities - The outstanding lTokens
     * @param assetData - The asset data for the underlying token
     * @returns The YBX per underlying per year
     */
    function CalcBorrowYbxTokenYield(ybxIssuanceForYear, outstandingLiabilities, assetData) {
        var issuanceForAsset = ybxIssuanceForYear.times(assetData.borrowingAllocation);
        return issuanceForAsset.dividedBy(outstandingLiabilities);
    }
    // ********** Protocol Calculations **********
    /**
     * Calculate the outstaning tokens from an AssetRecord result
     * @param assetRecord - The Asset ledger state
     * @returns The outstanding token count
     */
    function CalcOutstandingTokens(assetRecord) {
        return new BigNumber(assetRecord.amount).plus(assetRecord.claimable_balances_amount);
    }
    function CalcMinCollateralRequirement() {
        return Error();
    }
    function CalcMaxLiquidationAmount(borrowLimitUSD, liabilitiesUSD, avgWithdrawalIncentive, avgWithdrawalLTV) {
        var numerator = borrowLimitUSD.minus(liabilitiesUSD.times(1.02));
        var denominator = avgWithdrawalIncentive.plus(1).times(avgWithdrawalLTV).minus(1.02);
        return divideToNumber(numerator, denominator);
    }
    /**
     * Calculates the backstop amount for a liquidation incentive
     * @param avgLiquidationIncentive - Users average liquidation incentive
     * @param liabilityValue - Total value of users liabilities
     * @param collateralValue - total value of users collateral
     * @returns
     */
    function CalcBackstopAmount(avgLiquidationIncentive, liabilityValue, collateralValue) {
        var denominator = avgLiquidationIncentive.plus(1);
        return liabilityValue.minus(divideToNumber(collateralValue, denominator));
    }
    function CalcHealthFactor() {
        return Error();
    }
    function CalcMaximumLiability() {
        return Error();
    }
    /**
     * Calculates the YBX issued in a given day
     * @param outstanding YBX currently outstanding
     * @param issuanceRate YBX issuance rate
     * @param toIssue total YBX to be issued
     * @returns YBX issuance for the day
     */
    function CalcYbxIssuance(outstanding, issuanceRate, toIssue) {
        var remainingIssuance = toIssue.minus(outstanding);
        return remainingIssuance.times(issuanceRate);
    }
    function CalcPessimisticBlockWeightedAvgPosition() {
        return Error();
    }
    // ********** Price Calculations ***********
    function calcTWAPForPeriod(open, high, low, close) {
        var temp = new BigNumber(open).plus(high).plus(low).plus(close).dividedBy(4);
        return temp;
    }

    var safeMath = /*#__PURE__*/Object.freeze({
        __proto__: null,
        divideToNumber: divideToNumber,
        divideToError: divideToError,
        PoolTokenValue: PoolTokenValue,
        CalcOutstandingLiabilities: CalcOutstandingLiabilities,
        CalcUtilizationRatio: CalcUtilizationRatio,
        CalcOrigUtilizationRatio: CalcOrigUtilizationRatio,
        CalcUtilizationAdjustment: CalcUtilizationAdjustment,
        CalcAvgUtilizationRatio: CalcAvgUtilizationRatio,
        CalcFloatInterestRate: CalcFloatInterestRate,
        CalcLendInterestRate: CalcLendInterestRate,
        CalcAccrual: CalcAccrual,
        CalcYbxIssuanceForYear: CalcYbxIssuanceForYear,
        CalcLendYbxTokenYield: CalcLendYbxTokenYield,
        CalcBorrowYbxTokenYield: CalcBorrowYbxTokenYield,
        CalcOutstandingTokens: CalcOutstandingTokens,
        CalcMinCollateralRequirement: CalcMinCollateralRequirement,
        CalcMaxLiquidationAmount: CalcMaxLiquidationAmount,
        CalcBackstopAmount: CalcBackstopAmount,
        CalcHealthFactor: CalcHealthFactor,
        CalcMaximumLiability: CalcMaximumLiability,
        CalcYbxIssuance: CalcYbxIssuance,
        CalcPessimisticBlockWeightedAvgPosition: CalcPessimisticBlockWeightedAvgPosition,
        calcTWAPForPeriod: calcTWAPForPeriod
    });

    /**
     * A governance proposal for YieldBlox
     * @abstract
     */
    var BaseProposal = /** @class */ (function (_super) {
        __extends(BaseProposal, _super);
        /**
         * @param baseAccountParams - The accountParams for the backing account
         * @param data - The proposal data
         * @param type - The type of proposal
         * @param status - The current status of the proposal
         * @param quorum - The quorum percentage required
         * @param ownerId - The accountId of the proposal owner
         * @param lastModifiedTime - The last time the account was modified
         */
        function BaseProposal(baseAccountParams, data, type, status, quorum, ownerId, lastModifiedTime) {
            var _this = _super.call(this, baseAccountParams) || this;
            _this._horizon = HorizonServer.getInstance();
            _this.data = data;
            _this.type = type;
            _this.status = status;
            _this.quorum = quorum;
            _this.ownerId = ownerId;
            _this.lastModifiedTime = lastModifiedTime;
            return _this;
        }
        return BaseProposal;
    }(BaseAccount));

    /**
     * A base class for reading data off fields off of a Stellar Account
     */
    var BaseData = /** @class */ (function () {
        function BaseData(data) {
            this._data = data;
        }
        BaseData.prototype.getAllDataEntries = function () {
            return this._data;
        };
        /**
         * Fetch a decode an entry from an accounts data
         * @param dataKey The data key
         * @returns The decoded value, or undefined if it doesn't exist
         */
        BaseData.prototype.getDataEntry = function (dataKey) {
            var encodedData = this._data[dataKey];
            if (encodedData === undefined) {
                // @ts-ignore
                return undefined;
            }
            return Buffer.from(encodedData, 'base64').toString();
        };
        /**
         * Fetch a decode an entry from an accounts data
         * @param dataKey The data key
         * @returns The decoded value
         * @throws If the value does not exist
         */
        BaseData.prototype.getDataEntryWithError = function (dataKey) {
            var res = this.getDataEntry(dataKey);
            if (res) {
                return res;
            }
            throw new Error("Unable to find ".concat(dataKey, " in the account data"));
        };
        return BaseData;
    }());

    // Enums - they don't get along with ESLint
    /* eslint-disable */
    exports.ProtocolEventTypes = void 0;
    (function (ProtocolEventTypes) {
        ProtocolEventTypes[ProtocolEventTypes["TX_BURN"] = 0] = "TX_BURN";
        ProtocolEventTypes[ProtocolEventTypes["TX_CLAIM"] = 1] = "TX_CLAIM";
        ProtocolEventTypes[ProtocolEventTypes["TX_ESCROW"] = 2] = "TX_ESCROW";
        ProtocolEventTypes[ProtocolEventTypes["TX_LIQUIDATE"] = 3] = "TX_LIQUIDATE";
        ProtocolEventTypes[ProtocolEventTypes["TX_MINT"] = 4] = "TX_MINT";
        ProtocolEventTypes[ProtocolEventTypes["TX_PROPOSAL_CREATE"] = 5] = "TX_PROPOSAL_CREATE";
        ProtocolEventTypes[ProtocolEventTypes["TX_PROPOSAL_UPDATE"] = 6] = "TX_PROPOSAL_UPDATE";
        ProtocolEventTypes[ProtocolEventTypes["TX_REPAY"] = 7] = "TX_REPAY";
        ProtocolEventTypes[ProtocolEventTypes["TX_VOTE"] = 8] = "TX_VOTE";
    })(exports.ProtocolEventTypes || (exports.ProtocolEventTypes = {}));
    exports.BalanceType = void 0;
    (function (BalanceType) {
        BalanceType[BalanceType["Position"] = 0] = "Position";
        BalanceType[BalanceType["Stake"] = 1] = "Stake";
    })(exports.BalanceType || (exports.BalanceType = {}));
    exports.StakeType = void 0;
    (function (StakeType) {
        StakeType[StakeType["YBX"] = 0] = "YBX";
        StakeType[StakeType["SYBX"] = 1] = "SYBX";
        StakeType[StakeType["GYBX"] = 2] = "GYBX";
    })(exports.StakeType || (exports.StakeType = {}));
    exports.PositionType = void 0;
    (function (PositionType) {
        PositionType[PositionType["Borrow"] = 0] = "Borrow";
        PositionType[PositionType["Lend"] = 1] = "Lend";
        PositionType[PositionType["Escrow"] = 2] = "Escrow";
    })(exports.PositionType || (exports.PositionType = {}));
    exports.ProposalType = void 0;
    (function (ProposalType) {
        ProposalType[ProposalType["ALLOCATION"] = 0] = "ALLOCATION";
        ProposalType[ProposalType["CUSTOM"] = 1] = "CUSTOM";
        ProposalType[ProposalType["COUNCIL_SWAP_SIGNER"] = 2] = "COUNCIL_SWAP_SIGNER";
        ProposalType[ProposalType["COUNCIL_LOCK_CONTRACT"] = 3] = "COUNCIL_LOCK_CONTRACT";
    })(exports.ProposalType || (exports.ProposalType = {}));
    exports.ProposalStatus = void 0;
    (function (ProposalStatus) {
        ProposalStatus[ProposalStatus["NEW"] = 0] = "NEW";
        ProposalStatus[ProposalStatus["VOTING"] = 1] = "VOTING";
        ProposalStatus[ProposalStatus["REJECTED"] = 2] = "REJECTED";
        ProposalStatus[ProposalStatus["ACCEPTED"] = 3] = "ACCEPTED";
        ProposalStatus[ProposalStatus["IMPLEMENTING"] = 4] = "IMPLEMENTING";
        ProposalStatus[ProposalStatus["IMPLEMENTED"] = 5] = "IMPLEMENTED";
    })(exports.ProposalStatus || (exports.ProposalStatus = {}));
    exports.InterestType = void 0;
    (function (InterestType) {
        InterestType[InterestType["Float"] = 0] = "Float";
        InterestType[InterestType["Fixed"] = 1] = "Fixed";
    })(exports.InterestType || (exports.InterestType = {}));

    /**
     * Governance Data reads and decodes information off of the governance accounts entries
     * @extends BaseData
     */
    var ProposalData = /** @class */ (function (_super) {
        __extends(ProposalData, _super);
        function ProposalData() {
            // ********** KEYS **********
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.PROPOSAL_ACCOUNT_KEY = 'Proposal_Account';
            _this.PROPOSAL_STATUS_KEY = 'Proposal_Status';
            _this.PROPOSAL_LAST_MODIFIED = 'Proposal_Last_Modified';
            _this.PROPOSAL_TITLE_KEY = 'Proposal_Title';
            _this.PROPOSAL_DESCRIPTION_1 = 'Proposal_Description_1';
            _this.PROPOSAL_DESCRIPTION_2 = 'Proposal_Description_2';
            return _this;
        }
        /**
         * Fetch the proposal creator accountId
         * @returns
         */
        ProposalData.prototype.getProposerAccountId = function () {
            return this.getDataEntryWithError(this.PROPOSAL_ACCOUNT_KEY);
        };
        /**
         * Fetch the status of the proposal
         * @returns
         */
        ProposalData.prototype.getProposalStatus = function () {
            var dataEntry = this.getDataEntryWithError(this.PROPOSAL_STATUS_KEY);
            var key = parseFloat(dataEntry);
            if (exports.ProposalStatus[key] !== undefined) {
                return key;
            }
            throw new Error('Invalid ProposalStatus.');
        };
        /**
         * Fetch the last modified time of the proposal, as ms since epoch
         * @returns
         */
        ProposalData.prototype.getProposalLastModifiedTime = function () {
            var dataEntry = this.getDataEntryWithError(this.PROPOSAL_LAST_MODIFIED);
            var key = parseFloat(dataEntry);
            if (Number.isFinite(key)) {
                return key;
            }
            throw new Error('Invalid ProposalLastModifiedTime.');
        };
        /**
         * Fetch the title of the proposal
         * @returns undefined if no title provided
         */
        ProposalData.prototype.getProposalTitle = function () {
            return this.getDataEntry(this.PROPOSAL_TITLE_KEY);
        };
        /**
         * Fetch the description of the proposal
         * @returns undefined if no description provided
         */
        ProposalData.prototype.getProposalDescription = function () {
            var _a;
            var part1 = this.getDataEntry(this.PROPOSAL_DESCRIPTION_1);
            if (part1) {
                var part2 = (_a = this.getDataEntry(this.PROPOSAL_DESCRIPTION_2)) !== null && _a !== void 0 ? _a : '';
                return "".concat(part1).concat(part2);
            }
            return undefined;
        };
        /**
         * Fetch the encoded XDR on the proposal
         * @note
         * This is not applicable to AllocationProposals
         * @returns List of XDRs in the order they are to be applied
         */
        ProposalData.prototype.getXdrs = function () {
            var xdrSections = [];
            var xdrs = [];
            for (var key in this._data) {
                if (key.startsWith('Proposal'))
                    continue;
                var decodedValue = this.getDataEntryWithError(key);
                var txNum = parseFloat(key.slice(0, 1));
                var txSection = parseFloat(key.slice(1, 3));
                if (xdrSections[txNum] === undefined) {
                    xdrSections[txNum] = {};
                }
                // decodedValue has a dead bit at the front to avoid empty values
                xdrSections[txNum][txSection] = key.slice(3) + decodedValue.slice(1);
            }
            for (var _i = 0, xdrSections_1 = xdrSections; _i < xdrSections_1.length; _i++) {
                var xdrSection = xdrSections_1[_i];
                var xdr = '';
                for (var i = 0; i < Object.keys(xdrSection).length; i++) {
                    xdr = xdr.concat(xdrSection[i]);
                }
                xdrs.push(xdr);
            }
            return xdrs;
        };
        return ProposalData;
    }(BaseData));

    /**
     * Count votes for a given asset against a proposal
     * @param votingAssetId - The assetId to count votes for
     * @returns Number of votes counted for
     */
    function countVotes(votingAssetId) {
        return __awaiter(this, void 0, void 0, function () {
            var horizon, orderbook, ask;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        horizon = HorizonServer.getInstance();
                        return [4 /*yield*/, horizon.GetOrderbookAsync(VYBX_TOKEN, votingAssetId)];
                    case 1:
                        orderbook = _a.sent();
                        ask = orderbook === null || orderbook === void 0 ? void 0 : orderbook.asks.find(function (a) { return a.price === '1.0000000'; });
                        if (ask === undefined)
                            return [2 /*return*/, new BigNumber('0')];
                        return [2 /*return*/, new BigNumber(ask.amount)];
                }
            });
        });
    }
    /**
     * Get the total number of eligible votes for a certain proposal type
     * @param proposalType - The proposalType to get the eligible votes for
     * @returns The number of eligible votes as a BigNumber
     */
    function getEligibleVotes(proposalType) {
        return __awaiter(this, void 0, void 0, function () {
            var horizon, total, veYbxAsset, gYBX;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        horizon = HorizonServer.getInstance();
                        total = new BigNumber(0);
                        if (!(proposalType === exports.ProposalType.CUSTOM || proposalType === exports.ProposalType.ALLOCATION)) return [3 /*break*/, 2];
                        return [4 /*yield*/, horizon.GetAssetAsync(VEYBX_TOKEN)];
                    case 1:
                        veYbxAsset = _a.sent();
                        total = total
                            .plus(veYbxAsset.balances.authorized)
                            .plus(veYbxAsset.balances.authorized_to_maintain_liabilities)
                            .plus(veYbxAsset.balances.unauthorized);
                        _a.label = 2;
                    case 2: return [4 /*yield*/, horizon.GetAssetAsync(GYBX_TOKEN)];
                    case 3:
                        gYBX = _a.sent();
                        return [2 /*return*/, total
                                .plus(gYBX.balances.authorized)
                                .plus(gYBX.balances.authorized_to_maintain_liabilities)
                                .plus(gYBX.balances.unauthorized)];
                }
            });
        });
    }

    var votes = /*#__PURE__*/Object.freeze({
        __proto__: null,
        countVotes: countVotes,
        getEligibleVotes: getEligibleVotes
    });

    /**
     * A xdr based governance proposal for YieldBlox
     * @extends BaseProposal
     */
    var XdrProposal = /** @class */ (function (_super) {
        __extends(XdrProposal, _super);
        /**
         * @param baseAccountParams - The accountParams for the backing account
         * @param data - The proposal data
         * @param type - The type of proposal
         * @param status - The current status of the proposal
         * @param quorum - The quorum percentage required
         * @param ownerId - The accountId of the proposal owner
         * @param lastModifiedTime - The last time the account was modified
         * @param xdrs - The XDRs the proposal represents
         * @param title - The title of the proposal, if any
         * @param description - A description for the proposal, if any
         * @param signers - the signers on the proposal account
         * @param threshold  - the signer threshold on the proposal account
         */
        function XdrProposal(baseAccountParams, data, type, status, quorum, ownerId, lastModifiedTime, xdrs, title, description) {
            var _this = _super.call(this, baseAccountParams, data, type, status, quorum, ownerId, lastModifiedTime) || this;
            _this.xdrs = xdrs;
            _this.title = title;
            _this.description = description;
            return _this;
        }
        /**
         * Create an Xdr Proposal object
         * @param type - The proposal type defined by the gov account
         * @param quorum - The quorum threshold defined by the gov account
         * @param proposalAccount - The account response from Horizon
         * @returns An XDR proposal
         * @throws If the Proposal account is invalid
         */
        XdrProposal.create = function (type, quorum, proposalAccount) {
            var pData = new ProposalData(proposalAccount.data_attr);
            var ownerId = pData.getProposerAccountId();
            var status = pData.getProposalStatus();
            var lastModifiedTime = pData.getProposalLastModifiedTime();
            var title = pData.getProposalTitle();
            var description = pData.getProposalDescription();
            var xdrs = pData.getXdrs();
            if (xdrs.length === 0) {
                throw new Error('Proposal does not represent an XDR');
            }
            var baseAccountParams = BaseAccount.getBaseAccountParams(proposalAccount);
            return new XdrProposal(baseAccountParams, pData, type, status, quorum, ownerId, new Date(lastModifiedTime), xdrs, title, description);
        };
        /**
         * Get the votes for an account
         * @param accountId - The accountId to fetch votes for
         * @returns An array of vote balances, will be empty if the user has not voted
         */
        XdrProposal.prototype.getVotesForAccount = function (accountId) {
            return __awaiter(this, void 0, void 0, function () {
                var offers, accountVotes, offerForProposal;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._horizon.GetOffersAsync(accountId, VYBX_TOKEN)];
                        case 1:
                            offers = _a.sent();
                            accountVotes = [];
                            offerForProposal = offers.records.find(function (o) { return o.buying.asset_issuer === _this.id && o.price === '1.0000000'; });
                            if (offerForProposal) {
                                accountVotes.push({
                                    assetId: getAssetIdFromObject(offerForProposal.buying.asset_type, offerForProposal.buying.asset_issuer, offerForProposal.buying.asset_code),
                                    amount: offerForProposal.amount,
                                });
                            }
                            return [2 /*return*/, accountVotes];
                    }
                });
            });
        };
        /**
         * Get the total votes for the proposal
         * @returns The votes for YES and NO, as well as the current quorum percentage
         */
        XdrProposal.prototype.getVotes = function () {
            return __awaiter(this, void 0, void 0, function () {
                var noAssetId, yesAssetId, noVotes, yesVotes, totalVoted, totalOutstandingVotes, pctVoting;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            noAssetId = "NO:".concat(this.id);
                            yesAssetId = "YES:".concat(this.id);
                            return [4 /*yield*/, countVotes("NO:".concat(this.id))];
                        case 1:
                            noVotes = _a.sent();
                            return [4 /*yield*/, countVotes("YES:".concat(this.id))];
                        case 2:
                            yesVotes = _a.sent();
                            totalVoted = noVotes.plus(yesVotes);
                            return [4 /*yield*/, getEligibleVotes(this.type)];
                        case 3:
                            totalOutstandingVotes = _a.sent();
                            pctVoting = totalVoted.dividedBy(totalOutstandingVotes);
                            return [2 /*return*/, {
                                    proposalId: this.id,
                                    votes: [
                                        {
                                            assetId: yesAssetId,
                                            amount: yesVotes.toFixed(7, BigNumber.ROUND_DOWN),
                                        },
                                        {
                                            assetId: noAssetId,
                                            amount: noVotes.toFixed(7, BigNumber.ROUND_DOWN),
                                        },
                                    ],
                                    total: totalVoted.toFixed(0, BigNumber.ROUND_DOWN),
                                    pctOfQuorum: pctVoting.dividedBy(this.quorum).toFixed(7, BigNumber.ROUND_DOWN),
                                }];
                    }
                });
            });
        };
        return XdrProposal;
    }(BaseProposal));

    /**
     * An allocation governance proposal for YieldBlox
     * @extends BaseProposal
     */
    var AllocationProposal = /** @class */ (function (_super) {
        __extends(AllocationProposal, _super);
        /**
         * @param baseAccountParams - The accountParams for the backing account
         * @param data - The proposal data
         * @param status - The current status of the proposal
         * @param ownerId - The accountId of the proposal owner
         * @param lastModifiedTime - The last time the account was modified
         * @param pool - The pool account getting the allocation
         */
        function AllocationProposal(baseAccountParams, data, status, ownerId, lastModifiedTime, pool) {
            var _this = _super.call(this, baseAccountParams, data, exports.ProposalType.ALLOCATION, status, '0', ownerId, lastModifiedTime) || this;
            _this.pool = pool;
            return _this;
        }
        /**
         * Create an Allocation proposal
         * @param pool - The pool account getting the allocation
         * @param proposalAccount - The horizon account response for the proposal account
         * @returns An AllocationProposal
         */
        AllocationProposal.create = function (pool, proposalAccount) {
            var pData = new ProposalData(proposalAccount.data_attr);
            var ownerId = pData.getProposerAccountId();
            var status = pData.getProposalStatus();
            var lastModifiedTime = pData.getProposalLastModifiedTime();
            var baseAccountParams = BaseAccount.getBaseAccountParams(proposalAccount);
            return new AllocationProposal(baseAccountParams, pData, status, ownerId, new Date(lastModifiedTime), pool);
        };
        /**
         * Get the votes for an account
         * @param accountId - The accountId to fetch votes for
         * @returns The Vote balance or undefined if no votes
         */
        AllocationProposal.prototype.getVotesForAccount = function (accountId) {
            return __awaiter(this, void 0, void 0, function () {
                var balanceLines, offers, offerForProposal, _i, offerForProposal_1, offer, voteBLine;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            balanceLines = [];
                            return [4 /*yield*/, this._horizon.GetOffersAsync(accountId, VYBX_TOKEN)];
                        case 1:
                            offers = _a.sent();
                            offerForProposal = offers.records.filter(function (o) {
                                return (o.buying.asset_issuer === _this.pool.id ||
                                    (o.buying.asset_issuer === YBX_TOKEN.split(':')[1] &&
                                        o.buying.asset_code === YBX_TOKEN.split(':')[0])) &&
                                    o.price === '1.0000000';
                            });
                            if (offerForProposal.length > 0) {
                                for (_i = 0, offerForProposal_1 = offerForProposal; _i < offerForProposal_1.length; _i++) {
                                    offer = offerForProposal_1[_i];
                                    voteBLine = {
                                        assetId: getAssetIdFromObject(offer.buying.asset_type, offer.buying.asset_issuer, offer.buying.asset_code),
                                        amount: offer.amount,
                                    };
                                    balanceLines.push(voteBLine);
                                }
                            }
                            return [2 /*return*/, balanceLines];
                    }
                });
            });
        };
        /**
         * Count the number of votes for an allocation proposal
         * @override getVotes - Allocation votes in a unique way
         * @returns Votes object
         */
        AllocationProposal.prototype.getVotes = function () {
            return __awaiter(this, void 0, void 0, function () {
                var allocationVotes, totalVotes, poolAssets, _i, poolAssets_1, poolAsset, ybxVotes, liabilityVotes, poolVotes;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            allocationVotes = [];
                            totalVotes = new BigNumber(0);
                            poolAssets = this.pool.getSupportedAssets();
                            _i = 0, poolAssets_1 = poolAssets;
                            _a.label = 1;
                        case 1:
                            if (!(_i < poolAssets_1.length)) return [3 /*break*/, 7];
                            poolAsset = poolAssets_1[_i];
                            if (!(poolAsset.underlyingId === YBX_TOKEN)) return [3 /*break*/, 3];
                            return [4 /*yield*/, countVotes(poolAsset.underlyingId)];
                        case 2:
                            ybxVotes = _a.sent();
                            allocationVotes.push({
                                assetId: poolAsset.underlyingId,
                                amount: ybxVotes.toFixed(7, BigNumber.ROUND_DOWN),
                            });
                            totalVotes = totalVotes.plus(ybxVotes);
                            return [3 /*break*/, 6];
                        case 3: return [4 /*yield*/, countVotes(poolAsset.liabilityTokenId)];
                        case 4:
                            liabilityVotes = _a.sent();
                            allocationVotes.push({
                                assetId: poolAsset.liabilityTokenId,
                                amount: liabilityVotes.toFixed(7, BigNumber.ROUND_DOWN),
                            });
                            return [4 /*yield*/, countVotes(poolAsset.poolTokenId)];
                        case 5:
                            poolVotes = _a.sent();
                            allocationVotes.push({
                                assetId: poolAsset.poolTokenId,
                                amount: poolVotes.toFixed(7, BigNumber.ROUND_DOWN),
                            });
                            totalVotes = totalVotes.plus(liabilityVotes).plus(poolVotes);
                            _a.label = 6;
                        case 6:
                            _i++;
                            return [3 /*break*/, 1];
                        case 7: return [2 /*return*/, {
                                proposalId: this.id,
                                votes: allocationVotes,
                                total: totalVotes.toFixed(0, BigNumber.ROUND_DOWN),
                                pctOfQuorum: '1',
                            }];
                    }
                });
            });
        };
        return AllocationProposal;
    }(BaseProposal));

    /**
     * The Governance Account for YieldBlox. This account contains governance information
     * for all pools in the protocol
     * @extends ClientAccount
     */
    var Governance = /** @class */ (function (_super) {
        __extends(Governance, _super);
        /**
         * @param base - The client that created this governance account
         * @param baseAccountParams - The base account params
         * @param data - The governance data tied to this account
         */
        function Governance(base, baseAccountParams, data) {
            var _this = _super.call(this, baseAccountParams) || this;
            _this._base = base;
            _this.data = data;
            return _this;
        }
        /**
         * Fetch the current allocation proposal
         * @returns The current allocation proposal or undefined is there isn't an active one
         */
        Governance.prototype.getAllocationProposal = function () {
            return __awaiter(this, void 0, void 0, function () {
                var allocationAccountId, proposalAccount, pool;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            allocationAccountId = this.data.getAllocationProposal();
                            if (!allocationAccountId) return [3 /*break*/, 5];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, this._base.horizon.GetAccountAsync(allocationAccountId)];
                        case 2:
                            proposalAccount = _b.sent();
                            return [4 /*yield*/, this._base.pool(POOL_ACCOUNT_1_ID)];
                        case 3:
                            pool = _b.sent();
                            return [2 /*return*/, AllocationProposal.create(pool, proposalAccount)];
                        case 4:
                            _b.sent();
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/, undefined];
                    }
                });
            });
        };
        /**
         * Fetch the current council proposal
         * @param proposalType - Specify a Swap or Lock Council Proposal
         * @returns The proposal, or undefined if there is not an active one
         */
        Governance.prototype.getCouncilProposal = function (proposalType) {
            return __awaiter(this, void 0, void 0, function () {
                var councilPubKey, quorum, proposalAccount;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (proposalType === exports.ProposalType.COUNCIL_LOCK_CONTRACT) {
                                councilPubKey = this.data.getCouncilLockProposal();
                            }
                            else if (proposalType === exports.ProposalType.COUNCIL_SWAP_SIGNER) {
                                councilPubKey = this.data.getCouncilSwapProposal();
                            }
                            if (!(councilPubKey !== undefined)) return [3 /*break*/, 2];
                            quorum = this.data.getQuorumThreshold(proposalType);
                            return [4 /*yield*/, this._base.horizon.GetAccountAsync(councilPubKey)];
                        case 1:
                            proposalAccount = _a.sent();
                            return [2 /*return*/, XdrProposal.create(proposalType, quorum, proposalAccount)];
                        case 2: return [2 /*return*/, undefined];
                    }
                });
            });
        };
        /**
         * Fetch a custom proposal
         * @param proposalAccountId - The accountId for the proposal
         * @returns A proposal
         * @throws If the proposal is not valid
         */
        Governance.prototype.getCustomProposal = function (proposalAccountId) {
            return __awaiter(this, void 0, void 0, function () {
                var proposalType, proposalAccount, quorum;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            proposalType = this.data.getProposalType(proposalAccountId);
                            return [4 /*yield*/, this._base.horizon.GetAccountAsync(proposalAccountId)];
                        case 1:
                            proposalAccount = _a.sent();
                            quorum = this.data.getQuorumThreshold(proposalType);
                            return [2 /*return*/, XdrProposal.create(proposalType, quorum, proposalAccount)];
                    }
                });
            });
        };
        /**
         * Fetch locked contracts
         * @returns An array of locked contracts, or an empty array
         */
        Governance.prototype.getLockedContracts = function () {
            var lockedEntry = this.data.getLockedContracts();
            return lockedEntry
                .split('_')
                .map(function (entry) { return parseFloat(entry); })
                .filter(function (eventType) { return exports.ProtocolEventTypes[eventType] !== undefined; });
        };
        /**
         * Determines if the account is under control by the turrets
         * and prohibited from using the protocol
         * @param accountId - The accountId to check
         */
        Governance.prototype.isControlledAccount = function (accountId) {
            var isProtocolAccount = CONTROLLED_ACCOUNTS.some(function (id) { return id === accountId; });
            if (isProtocolAccount) {
                return true;
            }
            var isAllocation = this.data.getAllocationProposal() === accountId;
            var isCouncilSwap = this.data.getCouncilSwapProposal() === accountId;
            var isCouncilLock = this.data.getCouncilLockProposal() === accountId;
            var isCustom = this.data.getDataEntry(this.data.PROPOSAL_ACCOUNT_KEY(accountId)) !== undefined;
            if (isAllocation || isCouncilSwap || isCouncilLock || isCustom) {
                return true;
            }
            return false;
        };
        /**
         * Gets veYBX rate in terms of YBX
         * @returns veYBX value
         */
        Governance.prototype.getVeYBXRate = function () {
            return __awaiter(this, void 0, void 0, function () {
                var veYBXrecord, veYBXoutstanding, escrowAccount, escrowYBXBalance, accruedYBX;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this._base.horizon.GetAssetAsync(VEYBX_TOKEN)];
                        case 1:
                            veYBXrecord = _a.sent();
                            veYBXoutstanding = new BigNumber(veYBXrecord.balances.authorized)
                                .plus(veYBXrecord.balances.authorized_to_maintain_liabilities)
                                .plus(veYBXrecord.balances.unauthorized);
                            return [4 /*yield*/, this._base.horizon.GetAccountAsync(ESCROW_ACCOUNT_ID)];
                        case 2:
                            escrowAccount = _a.sent();
                            escrowYBXBalance = escrowAccount.balances.find(function (b) {
                                return b.asset_type === 'credit_alphanum4' &&
                                    b.asset_issuer === ISSUANCE_ACCOUNT_ID &&
                                    b.asset_code === 'YBX';
                            });
                            if (!escrowYBXBalance)
                                throw new Error('Unable to find YBX balance on escrow account');
                            accruedYBX = new BigNumber(escrowYBXBalance.balance);
                            return [2 /*return*/, divideToNumber(accruedYBX, veYBXoutstanding)];
                    }
                });
            });
        };
        return Governance;
    }(BaseAccount));

    /**
     * Governance Data reads and decodes information off of the governance accounts entries
     * @extends BaseData
     */
    var GovernanceData = /** @class */ (function (_super) {
        __extends(GovernanceData, _super);
        function GovernanceData() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            // ********** KEYS **********
            _this.TURRET_SPONSOR_KEY = function (signer) { return "turret.".concat(signer); };
            _this.ESCROW_MULTIPLE_KEY = function (period) { return "Period_".concat(period, "_Multiple"); };
            _this.PROPOSAL_ACCOUNT_KEY = function (publicKey) { return "P_".concat(publicKey); };
            _this.YBX_ISSUANCE_KEY = 'YBX_ISSUANCE_RATE';
            _this.YBX_SUPPLY_KEY = 'YBX_TOTAL_SUPPLY';
            _this.PROPOSAL_THRESHOLD_KEY = 'Proposal_Creation_Threshold';
            _this.PROPOSAL_ALLOCATION_KEY = 'P_ALLOCATION';
            _this.PROPOSAL_COUNCIL_LOCK_KEY = 'P_COUNCIL_LOCK';
            _this.PROPOSAL_COUNCIL_SWAP_KEY = 'P_COUNCIL_SWAP';
            _this.PROPOSAL_COUNCIL_QUORUM_KEY = 'Council_Quorum_Threshold';
            _this.PROPOSAL_CUSTOM_QUORUM_KEY = 'Custom_Quorum_Threshold';
            _this.PROPOSAL_XLM_BALANCE_KEY = 'Proposal_XLM_Balance_Requirement';
            _this.PROPOSAL_XLM_PENALTY_KEY = 'Proposal_XLM_Penalty';
            _this.LAST_SWAP_KEY = 'LAST_SIGNER_SWAP';
            _this.LOCKED_CONTRACTS_KEY = 'LOCKED_CONTRACTS';
            _this.YBX_CONTRACT_HASH = 'YieldBlox_Contract_Hash';
            return _this;
        }
        // ********** Turrets **********
        GovernanceData.prototype.getTurretSponsor = function (signer) {
            return this.getDataEntry(this.TURRET_SPONSOR_KEY(signer));
        };
        // ********** YBX / Voting **********
        GovernanceData.prototype.getYbxIssuanceRate = function () {
            return this.getDataEntryWithError(this.YBX_ISSUANCE_KEY);
        };
        GovernanceData.prototype.getYbxTotalSupply = function () {
            return this.getDataEntryWithError(this.YBX_SUPPLY_KEY);
        };
        GovernanceData.prototype.getEscrowPeriodMultiple = function (period) {
            var multiple = this.getDataEntryWithError(this.ESCROW_MULTIPLE_KEY(period));
            return multiple;
        };
        // ********** Proposals **********
        /**
         * Fetch all the non-allocation proposal account ids
         */
        GovernanceData.prototype.getAllCustomProposalIds = function () {
            var regexPropAccount = /^P_[a-zA-Z0-9]{56}$/;
            var proposalIds = [];
            for (var key in this._data) {
                if (regexPropAccount.test(key)) {
                    var propAccountId = key.split('_')[1];
                    proposalIds.push(propAccountId);
                }
            }
            return proposalIds;
        };
        /**
         * Fetch required votingPower to create a proposal
         * @returns
         */
        GovernanceData.prototype.getProposalCreationThreshold = function () {
            return this.getDataEntryWithError(this.PROPOSAL_THRESHOLD_KEY);
        };
        /**
         * Fetch the required XLM balance for a proposal
         * @returns
         */
        GovernanceData.prototype.getProposalXLMBalanceReq = function () {
            return this.getDataEntryWithError(this.PROPOSAL_XLM_BALANCE_KEY);
        };
        /**
         * Fetch the XLM penalty for a rejected proposal
         * @returns
         */
        GovernanceData.prototype.getProposalXLMPenalty = function () {
            return this.getDataEntryWithError(this.PROPOSAL_XLM_PENALTY_KEY);
        };
        /**
         * Fetch the proposal
         * @param proposalAccountId
         * @returns The type of proposal (as a string)
         * @throws If the proposal account is not supported
         */
        GovernanceData.prototype.getProposalType = function (proposalAccountId) {
            var type = this.getDataEntryWithError(this.PROPOSAL_ACCOUNT_KEY(proposalAccountId));
            var key = parseFloat(type);
            if (exports.ProposalType[key] !== undefined) {
                return key;
            }
            throw new Error('Invalid ProposalType.');
        };
        /**
         * Fetch the current allocation proposal, or undefined if none
         */
        GovernanceData.prototype.getAllocationProposal = function () {
            return this.getDataEntry(this.PROPOSAL_ALLOCATION_KEY);
        };
        /**
         * Fetch the current Council Lock proposal, or undefined if none
         */
        GovernanceData.prototype.getCouncilLockProposal = function () {
            return this.getDataEntry(this.PROPOSAL_COUNCIL_LOCK_KEY);
        };
        /**
         * Fetch the current Council Swap proposal, or undefined if none
         */
        GovernanceData.prototype.getCouncilSwapProposal = function () {
            return this.getDataEntry(this.PROPOSAL_COUNCIL_SWAP_KEY);
        };
        /**
         * Fetch the quorum threshold
         * @returns
         */
        GovernanceData.prototype.getQuorumThreshold = function (type) {
            switch (type) {
                case exports.ProposalType.COUNCIL_LOCK_CONTRACT:
                case exports.ProposalType.COUNCIL_SWAP_SIGNER:
                    return this.getDataEntryWithError(this.PROPOSAL_COUNCIL_QUORUM_KEY);
                case exports.ProposalType.CUSTOM:
                    return this.getDataEntryWithError(this.PROPOSAL_CUSTOM_QUORUM_KEY);
                case exports.ProposalType.ALLOCATION:
                    return '0';
                default:
                    throw new Error('Invalid proposal Type');
            }
        };
        /**
         * Fetch the last time a signer swap was run
         */
        GovernanceData.prototype.getLastSignerSwap = function () {
            var timestamp = this.getDataEntry(this.LAST_SWAP_KEY);
            if (!timestamp)
                timestamp = '0';
            return parseFloat(timestamp);
        };
        /**
         * Gets the current contracts that are locked
         * @returns
         */
        GovernanceData.prototype.getLockedContracts = function () {
            return this.getDataEntryWithError(this.LOCKED_CONTRACTS_KEY);
        };
        GovernanceData.prototype.getContractHash = function () {
            return this.getDataEntryWithError(this.YBX_CONTRACT_HASH);
        };
        return GovernanceData;
    }(BaseData));

    function CalculateAccruedInterest(lTokensOut, accrualData, assetData, blockLedger) {
        var accrualLedger = new BigNumber(STELLAR_MIN);
        //ensure we have enough transactions to calculate accrual
        if (accrualData.txWalked.length > 1) {
            // calculate this transactions accrual
            var lTokensOutLast = lTokensOut.minus(accrualData.txWalked[0].deltaLiabilities);
            var liabilitiesOutLast = accrualData.trackerBalance
                .times(lTokensOutLast)
                .dividedBy(STARTING_irTRACKER_BALANCE);
            var uRateLast = CalcUtilizationRatio(liabilitiesOutLast, accrualData.txWalked[0].poolBalance);
            var IRLast = CalcFloatInterestRate(assetData, uRateLast);
            accrualLedger = CalcAccrual(accrualData.txWalked[1].block, accrualData.txWalked[0].block, IRLast, accrualData.trackerBalance);
        }
        var nextAccrual = new BigNumber(STELLAR_MIN);
        //ensure we have enough transactions to calculate next accrual
        if (accrualData.txWalked.length > 0) {
            // calculate the estimated next transactions accrual
            var underlyingBalanceLedger = accrualData.txWalked[0].poolBalance.plus(accrualData.txWalked[0].deltaUnderlying);
            var nextTrackerBalance = accrualData.trackerBalance.plus(accrualLedger);
            var liabilitiesOutLedger = nextTrackerBalance
                .times(lTokensOut)
                .dividedBy(STARTING_irTRACKER_BALANCE);
            var uRateLedger = CalcUtilizationRatio(liabilitiesOutLedger, underlyingBalanceLedger);
            console.log('uRateNow', uRateLedger.toString());
            var IRLedger = CalcFloatInterestRate(assetData, uRateLedger);
            console.log('IRNOW', IRLedger.toString());
            nextAccrual = CalcAccrual(accrualData.txWalked[0].block, blockLedger, IRLedger, nextTrackerBalance);
        }
        return {
            accrual: accrualLedger,
            correction: accrualData.correction,
            totalAccrued: nextAccrual.plus(accrualLedger).plus(accrualData.trackerBalance),
        };
    }

    function GetVerifiedAccrualDataDesc(txPage, lTokensOutstandingBlock, poolAsset) {
        return __awaiter(this, void 0, void 0, function () {
            var foundActualTrackerBalance, trackerTxs, lastTxIdx, deltaBalancetoAccurate, currentPage, lTokensOutstanding, _i, _a, txLast, lastMeta, tx0, tx1, tx2, lastlastlTokensOutstanding, lastTrackerBalance, lastlastOutstandingLiabilities, expectedDelta, expectedURate, expectedIR, matchDelta, lastTxId, tx0, tx1, lastTrackerBal, outstandingLiabilities, URate, IR, correctAccrual, realBalance, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        foundActualTrackerBalance = false;
                        trackerTxs = [];
                        lastTxIdx = 0;
                        deltaBalancetoAccurate = new BigNumber(0);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        currentPage = txPage;
                        lTokensOutstanding = lTokensOutstandingBlock;
                        _b.label = 2;
                    case 2:
                        if (!(currentPage.records.length !== 0 && !foundActualTrackerBalance)) return [3 /*break*/, 4];
                        for (_i = 0, _a = currentPage.records; _i < _a.length; _i++) {
                            txLast = _a[_i];
                            lastMeta = GetAccrualDataFromTransaction(txLast, poolAsset);
                            if (lastMeta) {
                                // found a valid tracker transaction!
                                trackerTxs.push(lastMeta);
                                if (trackerTxs.length - lastTxIdx > 2) {
                                    tx0 = trackerTxs[lastTxIdx];
                                    tx1 = trackerTxs[lastTxIdx + 1];
                                    tx2 = trackerTxs[lastTxIdx + 2];
                                    lastlastlTokensOutstanding = lTokensOutstanding
                                        .minus(tx0.deltaLiabilities)
                                        .minus(tx1.deltaLiabilities);
                                    lastTrackerBalance = tx0.trackerBalance.plus(tx0.trackerCorrection);
                                    lastlastOutstandingLiabilities = CalcOutstandingLiabilities(lastlastlTokensOutstanding, lastTrackerBalance);
                                    lTokensOutstanding = lTokensOutstanding.minus(tx0.deltaLiabilities);
                                    // check if most desc tx is 5 mins behind. Then, nextAvail is correct!
                                    if (tx0.timestamp - tx1.timestamp > FIVE_MIN) {
                                        foundActualTrackerBalance = true;
                                        break;
                                    }
                                    expectedDelta = void 0;
                                    expectedURate = CalcUtilizationRatio(lastlastOutstandingLiabilities, tx1.poolBalance);
                                    expectedIR = CalcFloatInterestRate(poolAsset.data, expectedURate);
                                    expectedDelta = CalcAccrual(tx2.block, tx1.block, expectedIR, lastTrackerBalance);
                                    matchDelta = tx0.trackerPayment.toFixed(7, BigNumber.ROUND_FLOOR) ===
                                        expectedDelta.toFixed(7, BigNumber.ROUND_FLOOR);
                                    if (matchDelta) {
                                        foundActualTrackerBalance = true;
                                        break;
                                    }
                                    deltaBalancetoAccurate = deltaBalancetoAccurate
                                        .minus(tx0.trackerCorrection)
                                        .minus(tx0.trackerPayment);
                                    lastTxIdx += 1;
                                }
                            }
                        }
                        return [4 /*yield*/, currentPage.next()];
                    case 3:
                        currentPage = _b.sent();
                        return [3 /*break*/, 2];
                    case 4:
                        //short circuit if there are no tracker txs
                        if (trackerTxs.length < 1) {
                            return [2 /*return*/, {
                                    txWalked: trackerTxs,
                                    trackerBalance: new BigNumber(STARTING_irTRACKER_BALANCE),
                                    correction: deltaBalancetoAccurate,
                                }];
                        }
                        if (!deltaBalancetoAccurate.isZero()) {
                            // remove correct transaction as we don't need to recalc the accrual
                            trackerTxs.splice(trackerTxs.length - 1);
                            for (lastTxId = trackerTxs.length - 1; lastTxId > 1; lastTxId--) {
                                tx0 = trackerTxs[lastTxId];
                                tx1 = trackerTxs[lastTxId - 1];
                                lastTrackerBal = tx1.trackerBalance
                                    .plus(tx1.trackerPayment)
                                    .plus(tx1.trackerCorrection);
                                outstandingLiabilities = CalcOutstandingLiabilities(lTokensOutstanding, lastTrackerBal);
                                URate = CalcUtilizationRatio(outstandingLiabilities, tx1.poolBalance);
                                IR = CalcFloatInterestRate(poolAsset.data, URate);
                                correctAccrual = CalcAccrual(tx0.block, tx1.block, IR, lastTrackerBal);
                                deltaBalancetoAccurate = deltaBalancetoAccurate.plus(correctAccrual);
                            }
                        }
                        realBalance = trackerTxs[0].trackerBalance
                            .plus(trackerTxs[0].trackerCorrection)
                            .plus(trackerTxs[0].trackerPayment)
                            .plus(deltaBalancetoAccurate);
                        // not doing failure handling here because this should always be
                        // successful. If we don't find a correct payment the code's broken
                        if (!foundActualTrackerBalance) {
                            throw new Error('unable to find actual tracker balance');
                        }
                        return [2 /*return*/, {
                                txWalked: trackerTxs,
                                trackerBalance: realBalance,
                                correction: deltaBalancetoAccurate,
                            }];
                    case 5:
                        e_1 = _b.sent();
                        console.error(e_1);
                        // return bad data if there is an error
                        return [2 /*return*/, {
                                txWalked: trackerTxs,
                                trackerBalance: trackerTxs[0].trackerBalance.plus(trackerTxs[0].trackerPayment),
                                correction: new BigNumber(0),
                            }];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }

    /**
     * A supported asset for a pool
     */
    var PoolAsset = /** @class */ (function () {
        function PoolAsset(pool, underlyingId, assetKey, assetData) {
            this._horizon = HorizonServer.getInstance();
            this.pool = pool;
            this.underlyingId = underlyingId;
            this.liabilityTokenId = "l".concat(assetKey, ":").concat(pool.id);
            this.poolTokenId = "y".concat(assetKey, ":").concat(pool.id);
            this.accrualTokenId = "i".concat(assetKey, ":").concat(pool.id);
            this.poolRatioTokenId = "a".concat(assetKey, ":").concat(pool.id);
            this.poolShiftTokenId = "b".concat(assetKey, ":").concat(DIST_ACCOUNT_ID);
            this.liabilityRatioTokenId = "c".concat(assetKey, ":").concat(pool.id);
            this.liabilityShiftTokenId = "d".concat(assetKey, ":").concat(DIST_ACCOUNT_ID);
            this.data = assetData;
            this.assetKey = assetKey;
        }
        /**
         * Parse the base PoolAsset information from the assets respective pool
         * @param pool - The pool the asset belongs to
         * @param assetKey - The asset code key
         * @returns
         */
        PoolAsset.fromPoolEntries = function (pool, assetKey) {
            var underlyingData = pool.data.getAssetUnderlyingData(assetKey);
            var assetCode;
            if (assetKey === 'YBX') {
                assetCode = assetKey;
            }
            else {
                assetCode = assetKey.slice(2) + underlyingData[1];
            }
            var issuer = underlyingData[0];
            var underlyingId = "".concat(assetCode, ":").concat(issuer);
            var tracker = pool.data.getAssetTracker(assetKey);
            var ltv = pool.data.getAssetLoanToValue(assetKey);
            var interestData = pool.data.getAssetInterestData(assetKey);
            var feeData = pool.data.getAssetFeeData(assetKey);
            var allocationData = pool.data.getAssetAllocationData(assetKey);
            var exchangeData = pool.data.getAssetExchangeData(assetKey);
            // see https://docs.ybx.script3.io/technical-docs/underlying-asset-data
            var data = {
                trackingAccountId: tracker,
                baseRateConstant: parseFloat(interestData[0]) / 100,
                slope0: parseFloat(interestData[1]) / 10,
                slope1: parseFloat(interestData[2]) / 10,
                slope2: parseFloat(interestData[3]) / 10,
                slope3: parseFloat(interestData[4]) / 10,
                rateThreshold1: parseFloat(interestData[5]) / 100,
                rateThreshold2: parseFloat(interestData[6]) / 100,
                rateThreshold3: parseFloat(interestData[7]) / 100,
                loanToValue: parseFloat(ltv) / 100,
                liquidationIncentive: parseFloat(feeData[0]) / 100,
                liquidationFee: parseFloat(feeData[1]) / 100,
                ybxFeeAllocation: parseFloat(feeData[2]) / 100,
                withdrawalFee: parseFloat(feeData[3]) / 100,
                lendingAllocation: parseFloat(allocationData[0]) / 100,
                borrowingAllocation: parseFloat(allocationData[1]) / 100,
                exchangePrimary: parseFloat(exchangeData[0]),
                binance: parseFloat(exchangeData[1]),
                coinbase: parseFloat(exchangeData[2]),
                ftx: parseFloat(exchangeData[3]),
                assetTicker: exchangeData[4], // 2-4 digits
            };
            return new PoolAsset(pool, underlyingId, assetKey, data);
        };
        /**
         * Get the current amount of liability tokens outstanding
         * @param forceUpdate - (optional - defaults to false) Ignore cached data
         * @returns
         */
        PoolAsset.prototype.getLiabilityTokensOutstanding = function (forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var liabilityTokenRecord, resp, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._liabilityTokensOutstanding === undefined || forceUpdate)) return [3 /*break*/, 5];
                            liabilityTokenRecord = void 0;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this._horizon.GetAssetAsync(this.liabilityTokenId)];
                        case 2:
                            resp = _a.sent();
                            liabilityTokenRecord = resp;
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            if (error_1 instanceof stellarSdk.NotFoundError) {
                                this._liabilityTokensOutstanding = new BigNumber(0);
                                return [2 /*return*/, this._liabilityTokensOutstanding];
                            }
                            throw error_1;
                        case 4:
                            this._liabilityTokensOutstanding = new BigNumber(liabilityTokenRecord.claimable_balances_amount);
                            _a.label = 5;
                        case 5: return [2 /*return*/, this._liabilityTokensOutstanding];
                    }
                });
            });
        };
        /**
         * Find the next accrual for the asset
         * @remarks
         * First find the correct interest accrual tracker account balance
         * Next find the accrual that will be made in this transaction
         * Finally estimate the next accrual
         * @param forceUpdate - (optional - defaults to false) Ignore cached data
         * @returns
         */
        PoolAsset.prototype.getAccrual = function (timestamp, forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var liabilityTokensOut, blockLedger, txPage, walkBackResp, accrualData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._iAccrual === undefined || forceUpdate)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.getLiabilityTokensOutstanding()];
                        case 1:
                            liabilityTokensOut = _a.sent();
                            return [4 /*yield*/, this._horizon.GetCurrentLedger(timestamp)];
                        case 2:
                            blockLedger = _a.sent();
                            return [4 /*yield*/, this._horizon.GetTransactionsAsync(this.data.trackingAccountId)];
                        case 3:
                            txPage = _a.sent();
                            return [4 /*yield*/, GetVerifiedAccrualDataDesc(txPage, liabilityTokensOut, this)];
                        case 4:
                            walkBackResp = _a.sent();
                            accrualData = CalculateAccruedInterest(liabilityTokensOut, walkBackResp, this.data, blockLedger);
                            this._iAccrual = accrualData;
                            _a.label = 5;
                        case 5: return [2 /*return*/, this._iAccrual];
                    }
                });
            });
        };
        /**
         * Find the current liability token value to underlying
         * @remarks
         * get accrual data and divide totalAccrued by starting tracker balance
         * @param forceUpdate - (optional - defaults to false) Ignore cached data
         * @returns
         */
        PoolAsset.prototype.getLiabilityTokenRate = function (timestamp, forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var accrual;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getAccrual(timestamp, forceUpdate)];
                        case 1:
                            accrual = _a.sent();
                            return [2 /*return*/, accrual.totalAccrued.dividedBy(STARTING_irTRACKER_BALANCE)];
                    }
                });
            });
        };
        /**
         * Get the current number of pool tokens outstanding
         * @param forceUpdate - (optional - defaults to false) Ignore cached data
         * @returns
         */
        PoolAsset.prototype.getPoolTokensOutstanding = function (forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var poolTokenRecord, resp, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._poolTokensOutstanding === undefined || forceUpdate)) return [3 /*break*/, 5];
                            poolTokenRecord = void 0;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this._horizon.GetAssetAsync(this.poolTokenId)];
                        case 2:
                            resp = _a.sent();
                            poolTokenRecord = resp;
                            return [3 /*break*/, 4];
                        case 3:
                            error_2 = _a.sent();
                            if (error_2 instanceof stellarSdk.NotFoundError) {
                                this._poolTokensCollateralized = new BigNumber(0);
                                this._poolTokensOutstanding = new BigNumber(0);
                                return [2 /*return*/, this._poolTokensOutstanding];
                            }
                            throw error_2;
                        case 4:
                            this._poolTokensCollateralized = new BigNumber(poolTokenRecord.claimable_balances_amount);
                            this._poolTokensOutstanding = this._poolTokensCollateralized
                                .plus(poolTokenRecord.amount)
                                // @ts-ignore TODO: add liquidity_pools_amount to js-sdk
                                .plus(poolTokenRecord.liquidity_pools_amount);
                            _a.label = 5;
                        case 5: return [2 /*return*/, this._poolTokensOutstanding];
                    }
                });
            });
        };
        /**
         * Get current number of pool tokens collateralized
         * @param forceUpdate - (optional - defaults to false) Ignore cached data
         * @returns
         */
        PoolAsset.prototype.getPoolTokensCollateralized = function (forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._poolTokensCollateralized === undefined || forceUpdate)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getPoolTokensOutstanding(forceUpdate)];
                        case 1:
                            _a.sent();
                            if (!this._poolTokensCollateralized)
                                return [2 /*return*/, new BigNumber(0)];
                            _a.label = 2;
                        case 2: return [2 /*return*/, this._poolTokensCollateralized];
                    }
                });
            });
        };
        /**
         * Fetch the current pool token to underlying rate
         * @param forceUpdate - (optional - defaults to false) Ignore cached data
         * @returns
         */
        PoolAsset.prototype.getPoolTokenRate = function (timestamp, forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var poolTokensOut, liabilityTokensOut, liabilityRate, liabilitiesOutstanding, underlyingBalanceLine, underlyingBalance;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._poolTokenRate === undefined || forceUpdate)) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.getPoolTokensOutstanding()];
                        case 1:
                            poolTokensOut = _a.sent();
                            return [4 /*yield*/, this.getLiabilityTokensOutstanding()];
                        case 2:
                            liabilityTokensOut = _a.sent();
                            return [4 /*yield*/, this.getLiabilityTokenRate(timestamp, forceUpdate)];
                        case 3:
                            liabilityRate = _a.sent();
                            liabilitiesOutstanding = liabilityTokensOut.times(liabilityRate);
                            underlyingBalanceLine = this.pool.getBalance(this.underlyingId);
                            if (!underlyingBalanceLine) {
                                throw new Error("Asset ".concat(this.underlyingId, " is not supported by pool ").concat(this.pool.id));
                            }
                            underlyingBalance = new BigNumber(underlyingBalanceLine);
                            this._poolTokenRate = PoolTokenValue(poolTokensOut, underlyingBalance, liabilitiesOutstanding);
                            _a.label = 4;
                        case 4: return [2 /*return*/, this._poolTokenRate];
                    }
                });
            });
        };
        return PoolAsset;
    }());

    /**
     * A Lending / Borrowing pool powered by the YieldBlox Smart Contracts
     * @extends ClientAccount
     */
    var Pool = /** @class */ (function (_super) {
        __extends(Pool, _super);
        /**
         * @param base - The client used to fetch this pool
         * @param baseAccountParams - The baseAccountParams for the backing account
         * @param data - The PoolData for the pool
         */
        function Pool(base, baseAccountParams, data) {
            var _this = _super.call(this, baseAccountParams) || this;
            _this._base = base;
            _this.data = data;
            _this._poolAssets = {};
            _this._poolAssetKeys = {};
            return _this;
        }
        /**
         * Gets the balance for an asset
         * @param assetId - The assetId to check
         * @returns The available balance as a string, or undefined if no trustline exists
         */
        Pool.prototype.getBalance = function (assetId) {
            if (assetId === NATIVE) {
                // avoid any odd rounding due to floats
                // this shouldn't round, since we only have 7 digits of precision
                var xlmBalance = new BigNumber(this._balances[assetId]);
                return xlmBalance.minus(XLM_RESERVE).toFixed(7, BigNumber.ROUND_DOWN);
            }
            return this._balances[assetId];
        };
        /**
         * Get a pool asset from the underlying asset
         * @param underlyingAssetId - The underlying assetId
         * @returns The PoolAsset object or undefined if the asset is not supported
         */
        Pool.prototype.getAssetFromUnderlying = function (underlyingAssetId) {
            if (Object.keys(this._poolAssets).length === 0) {
                // assets haven't been loaded, load em!
                this.loadAssets();
            }
            return this._poolAssets[underlyingAssetId];
        };
        /**
         * Get a pool asset from the protocolToken
         * @param protocolAssetId - The protocol token assetId
         * @returns The PoolAsset object or undefined if the asset is not supported
         */
        Pool.prototype.getAssetFromToken = function (protocolAssetId) {
            if (Object.keys(this._poolAssetKeys).length === 0) {
                // assets haven't been loaded, load em!
                this.loadAssets();
            }
            var assetKey = protocolAssetId.split(':')[0].slice(1);
            return this.getAssetFromUnderlying(this._poolAssetKeys[assetKey]);
        };
        /**
         * Get the YBX Asset
         * @param protocolAssetId - The protocol token assetId
         * @returns The PoolAsset object or undefined if the asset is not supported
         */
        Pool.prototype.getYbx = function () {
            // TODO: Write this
            if (Object.keys(this._poolAssetKeys).length === 0) {
                // assets haven't been loaded, load em!
                this.loadAssets();
            }
            return this.getAssetFromUnderlying(YBX_TOKEN);
        };
        /**
         * Get all supported assets for this Pool
         * @returns List of supported PoolAssets
         */
        Pool.prototype.getSupportedAssets = function () {
            var _this = this;
            if (Object.keys(this._poolAssets).length === 0) {
                // assets haven't been loaded, load em!
                this.loadAssets();
            }
            var keys = Object.keys(this._poolAssets);
            return keys.map(function (k) { return _this._poolAssets[k]; });
        };
        /**
         * Get all debt for this pool
         * @returns List of all borrows the pool has accrued
         */
        Pool.prototype.getPoolDebt = function () {
            return __awaiter(this, void 0, void 0, function () {
                var poolAsUser;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!this.debt) return [3 /*break*/, 2];
                            return [4 /*yield*/, this._base.user(this.id)];
                        case 1:
                            poolAsUser = _a.sent();
                            this.debt = poolAsUser.positions.borrowed;
                            _a.label = 2;
                        case 2: return [2 /*return*/, this.debt];
                    }
                });
            });
        };
        /**
         * Get a borrowed position from the protocol tokenId
         * @param tokenId - The tokenId in the form `tokenCode:poolAccountId`
         * @returns A borrow position or undefined if none exist
         */
        Pool.prototype.getBorrowedPosition = function (tokenId) {
            return __awaiter(this, void 0, void 0, function () {
                var poolDebt;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getPoolDebt()];
                        case 1:
                            poolDebt = _a.sent();
                            return [2 /*return*/, poolDebt.find(function (b) { return b.assetId === tokenId; })];
                    }
                });
            });
        };
        // ========== Private Helpers ==========
        Pool.prototype.loadAssets = function () {
            var assetKeys = this.data.getSupportedAssetKeys();
            if (assetKeys.length === 0) {
                throw new Error('Pool does not have any supported assets');
            }
            var poolAssets = {};
            var poolKeys = {};
            for (var _i = 0, assetKeys_1 = assetKeys; _i < assetKeys_1.length; _i++) {
                var key = assetKeys_1[_i];
                var poolAsset = PoolAsset.fromPoolEntries(this, key);
                poolAssets[poolAsset.underlyingId] = poolAsset;
                poolKeys[key] = poolAsset.underlyingId;
            }
            this._poolAssets = poolAssets;
            this._poolAssetKeys = poolKeys;
        };
        return Pool;
    }(BaseAccount));

    /**
     * PoolData reads and decodes information off of a pools account data fields
     * @extends BaseData
     * @constructor
     * @param {AccountResponse} poolResponse The pool's account response for
     */
    var PoolData = /** @class */ (function (_super) {
        __extends(PoolData, _super);
        function PoolData() {
            // ********** KEYS **********
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ASSET_TRACKER_KEY = function (assetKey) { return "".concat(assetKey, "_Tracker"); };
            _this.ASSET_LTV_KEY = function (assetKey) { return "".concat(assetKey, "_LTV"); };
            _this.ASSET_UNDERLYING_KEY = function (assetKey) { return "".concat(assetKey, "_Underlying"); };
            _this.ASSET_INTEREST_KEY = function (assetKey) { return "".concat(assetKey, "_Interest"); };
            _this.ASSET_ALLOCATION_KEY = function (assetKey) { return "".concat(assetKey, "_Allocation"); };
            _this.ASSET_EXCHANGE_KEY = function (assetKey) { return "".concat(assetKey, "_Exchange"); };
            _this.ASSET_FEE_KEY = function (assetKey) { return "".concat(assetKey, "_Fee"); };
            return _this;
        }
        // ********** Pool Asset Data **********
        /**
         * Fetch all support asset keys
         * @returns List of supported asset keys
         */
        PoolData.prototype.getSupportedAssetKeys = function () {
            var regexAssetKey = /^\w\w[a-zA-Z0-9]{1,9}_Underlying$/;
            var supportedAssetKeys = [];
            for (var key in this._data) {
                if (regexAssetKey.test(key)) {
                    var trimmedKey = key.slice(0, -11);
                    supportedAssetKeys.push(trimmedKey);
                }
            }
            return supportedAssetKeys;
        };
        /**
         * Fetch the underlying asset interest tracker entry for a supported asset
         * @param assetKey - The assetKey for the asset
         * @returns The decoded interest tracker entry
         */
        PoolData.prototype.getAssetTracker = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_TRACKER_KEY(assetKey));
        };
        /**
         * Fetch the pool asset interest data
         * @param assetKey - The assetKey for the asset
         * @returns The loan to value as a string
         */
        PoolData.prototype.getAssetLoanToValue = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_LTV_KEY(assetKey));
        };
        /**
         * Fetch the underlying asset issuer and excess code for a supported asset
         * @param assetKey - The assetKey for the asset
         * @returns The decoded entry data as an array
         */
        PoolData.prototype.getAssetUnderlyingData = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_UNDERLYING_KEY(assetKey)).split('_');
        };
        /**
         * Fetch the pool asset interest data
         * @param assetKey - The assetKey for the asset
         * @returns The decoded entry data as an array
         */
        PoolData.prototype.getAssetInterestData = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_INTEREST_KEY(assetKey)).split('_');
        };
        /**
         * Fetch the pool asset allocation data
         * @param assetKey - The assetKey for the asset
         * @returns The decoded entry data as an array
         */
        PoolData.prototype.getAssetAllocationData = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_ALLOCATION_KEY(assetKey)).split('_');
        };
        /**
         * Fetch the pool asset exchange data
         * @param assetKey - The assetKey for the asset
         * @returns The decoded entry data as an array
         */
        PoolData.prototype.getAssetExchangeData = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_EXCHANGE_KEY(assetKey)).split('_');
        };
        /**
         * Fetch the pool asset fee data
         * @param assetKey - The assetKey for the asset
         * @returns The decoded entry data as an array
         */
        PoolData.prototype.getAssetFeeData = function (assetKey) {
            return this.getDataEntryWithError(this.ASSET_FEE_KEY(assetKey)).split('_');
        };
        return PoolData;
    }(BaseData));

    /**
     * A Position taken with YieldBlox. Represented by a claimable balance.
     * @abstract
     */
    var BasePosition = /** @class */ (function () {
        function BasePosition(accountId, balance, assetId, lastModifiedTime, balanceId) {
            this.accountId = accountId;
            this.balanceId = balanceId;
            this.balance = balance;
            this.assetId = assetId;
            this.lastModifiedTime = lastModifiedTime;
        }
        return BasePosition;
    }());

    /**
     * A borrow position in YieldBlox.
     * @extends Position
     */
    var Borrow = /** @class */ (function (_super) {
        __extends(Borrow, _super);
        function Borrow(accountId, balanceId, balance, assetId, lastModifiedTime, principal) {
            var _this = _super.call(this, accountId, balance, assetId, lastModifiedTime, balanceId) || this;
            _this._horizon = HorizonServer.getInstance();
            _this.principal = principal;
            _this.ybxAccrued = undefined;
            return _this;
        }
        /**
         * Builds a Borrow object from a Claimable Balances
         * @param cBalance - The claimable balance for the borrow
         * @returns A borrow or undefined if the claimable balance is invalid
         */
        Borrow.create = function (cBalance) {
            // ensure claimants are set up correctly
            // verify that there aren't too many claimants
            if (cBalance.claimants.length > 2)
                return undefined;
            // verify that distribution account is a claimant
            var distributionClaimant = cBalance.claimants.find(function (c) { return c.destination === DIST_ACCOUNT_ID; });
            if (!distributionClaimant || !distributionClaimant.predicate.abs_before)
                return undefined;
            // check for userClaimant and assign accountId
            var accountId;
            if (cBalance.claimants.length > 1) {
                var userClaimant = cBalance.claimants.find(function (c) { return c.destination !== DIST_ACCOUNT_ID; });
                if (!userClaimant ||
                    cBalance.sponsor !== ESCROW_ACCOUNT_ID ||
                    !VerifyNeverPredicate(userClaimant.predicate)) {
                    return undefined;
                }
                accountId = userClaimant.destination;
            }
            else {
                if (!cBalance.sponsor)
                    return undefined;
                accountId = cBalance.sponsor;
            }
            // assign principal
            var principal = numberFromPredicate(distributionClaimant.predicate)
                .toString();
            return new Borrow(accountId, cBalance.id, cBalance.amount, cBalance.asset, 
            // @ts-ignore - last modified time is missing from typing
            new Date(cBalance.last_modified_time), principal);
        };
        Borrow.prototype.getAccruedYBX = function (timestamp, pool, forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var userAccrued, protocolAsset, ratioToken, shiftToken, issuanceTradeHistory, foundLast, _i, _a, trade, positionSize, tradeTimestamp, issuanceRate, pctOfPeriod, weightedSize, pctOfPeriod;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(forceUpdate || !this.ybxAccrued)) return [3 /*break*/, 5];
                            userAccrued = new BigNumber(0);
                            protocolAsset = pool.getAssetFromToken(this.assetId);
                            if (!protocolAsset)
                                throw new Error('Unsupported balance asset');
                            ratioToken = protocolAsset.liabilityRatioTokenId;
                            shiftToken = protocolAsset.liabilityShiftTokenId;
                            return [4 /*yield*/, this._horizon.GetTradesAsync(ratioToken, shiftToken)];
                        case 1:
                            issuanceTradeHistory = _b.sent();
                            foundLast = false;
                            _b.label = 2;
                        case 2:
                            if (!(issuanceTradeHistory.records.length !== 0)) return [3 /*break*/, 4];
                            for (_i = 0, _a = issuanceTradeHistory.records; _i < _a.length; _i++) {
                                trade = _a[_i];
                                positionSize = new BigNumber(this.balance);
                                tradeTimestamp = new Date(trade.ledger_close_time).getTime();
                                issuanceRate = tradeToNumber(trade);
                                // exit if user has already claimed
                                if (tradeTimestamp < new Date(this.lastModifiedTime).getTime()) {
                                    this.ybxAccrued = userAccrued.toFixed(7, BigNumber.ROUND_DOWN);
                                    return [2 /*return*/, this.ybxAccrued];
                                }
                                // handle first trade
                                if (userAccrued.equals(0)) {
                                    pctOfPeriod = new BigNumber(timestamp)
                                        .minus(tradeTimestamp)
                                        .dividedBy(new BigNumber(24).times(60).times(60).times(1000));
                                    weightedSize = positionSize.times(pctOfPeriod);
                                    userAccrued = userAccrued.plus(weightedSize.times(issuanceRate));
                                }
                                // handle last trade
                                if (tradeTimestamp - 24 * 60 * 60 * 1000 < new Date(this.lastModifiedTime).getTime()) {
                                    pctOfPeriod = new BigNumber(tradeTimestamp)
                                        .minus(this.lastModifiedTime.getTime())
                                        .dividedBy(24 * 60 * 60 * 1000);
                                    positionSize = positionSize.times(pctOfPeriod);
                                    userAccrued = userAccrued.plus(positionSize.times(issuanceRate));
                                    foundLast = true;
                                    break;
                                }
                                userAccrued = userAccrued.plus(positionSize.times(issuanceRate));
                            }
                            if (foundLast)
                                return [3 /*break*/, 4];
                            return [4 /*yield*/, issuanceTradeHistory.next()];
                        case 3:
                            issuanceTradeHistory = _b.sent();
                            return [3 /*break*/, 2];
                        case 4:
                            this.ybxAccrued = userAccrued.toFixed(7, BigNumber.ROUND_DOWN);
                            _b.label = 5;
                        case 5: return [2 /*return*/, this.ybxAccrued];
                    }
                });
            });
        };
        return Borrow;
    }(BasePosition));

    /**
     * An escrow position in YieldBlox.
     * @extends Position
     */
    var Escrow = /** @class */ (function (_super) {
        __extends(Escrow, _super);
        function Escrow(accountId, balanceId, balance, assetId, lastModifiedTime, unlockTime, period, collateral, earlyUnlockAllowed, collateralDestination) {
            var _this = _super.call(this, accountId, balance, assetId, lastModifiedTime, balanceId) || this;
            _this.unlockTime = unlockTime;
            _this.period = period;
            _this.collateral = collateral;
            _this.collateralDestination = collateralDestination;
            _this.earlyUnlockAllowed = earlyUnlockAllowed;
            return _this;
        }
        /**
         * Builds an escrow object from a Claimable Balances
         * @param cBalance - The claimable balance for the borrow
         * @returns A borrow or undefined if the claimable balance is invalid
         */
        Escrow.create = function (cBalance) {
            var _a, _b, _c;
            var accountId;
            var earlyUnlockAllowed = true;
            // Set up claimants
            var userClaimant;
            var issuanceClaimant;
            var startClaimant;
            var collateralClaimant;
            // Handle liquidated balances and userClaimant
            if (cBalance.sponsor) {
                if (cBalance.sponsor === ESCROW_ACCOUNT_ID) {
                    userClaimant = cBalance.claimants.find(function (c) { return c.destination !== DIST_ACCOUNT_ID && c.destination !== POOL_ACCOUNT_1_ID; });
                    // validate userClaimant is set up correctly
                    if (!userClaimant || !VerifyNeverPredicate(userClaimant === null || userClaimant === void 0 ? void 0 : userClaimant.predicate)) {
                        return undefined;
                    }
                    // assign accountId
                    accountId = userClaimant.destination;
                }
                else {
                    accountId = cBalance.sponsor;
                }
            }
            else {
                return undefined;
            }
            // handle earlyUnlock and issuance claimant
            issuanceClaimant = cBalance.claimants.find(function (c) { return c.destination === ISSUANCE_ACCOUNT_ID; });
            if (issuanceClaimant) {
                if (VerifyNeverPredicate(issuanceClaimant.predicate)) {
                    earlyUnlockAllowed = false;
                }
                else {
                    return undefined;
                }
            }
            // handle unlockClaimant and unlockDate
            startClaimant = cBalance.claimants.find(function (c) { return c.destination === DIST_ACCOUNT_ID; });
            if (!startClaimant || !((_a = startClaimant.predicate.not) === null || _a === void 0 ? void 0 : _a.abs_before)) {
                return undefined;
            }
            var startDate = new Date(startClaimant.predicate.not.abs_before);
            // handle collateral claimant
            var collateral = true;
            collateralClaimant = cBalance.claimants.find(function (c) { return c.destination === POOL_ACCOUNT_1_ID; });
            if (!collateralClaimant) {
                collateral = false;
                collateralClaimant = cBalance.claimants.find(function (c) { return c.destination === ESCROW_ACCOUNT_ID; });
                if (!collateralClaimant)
                    return undefined;
            }
            if (!((_b = collateralClaimant === null || collateralClaimant === void 0 ? void 0 : collateralClaimant.predicate.not) === null || _b === void 0 ? void 0 : _b.abs_before))
                return undefined;
            // validate numClaimants
            var expectedNumClaimants = 2;
            if (issuanceClaimant)
                expectedNumClaimants++;
            if (userClaimant)
                expectedNumClaimants++;
            if (cBalance.claimants.length > expectedNumClaimants) {
                return undefined;
            }
            // get period
            var unlockDate = new Date((_c = collateralClaimant.predicate.not) === null || _c === void 0 ? void 0 : _c.abs_before);
            var period = unlockDate.getTime() - startDate.getTime();
            period = period / MONTH_IN_DAYS / 1000 / 60 / 60 / 24;
            if (period > 2.5 && period < 3.5) {
                period = 3;
            }
            else if (period > 5.5 && period < 6.5) {
                period = 6;
            }
            else if (period > 11.5 && period < 12.5) {
                period = 12;
            }
            else {
                return undefined;
            }
            return new Escrow(accountId, cBalance.id, cBalance.amount, YBX_TOKEN, 
            // @ts-ignore - last_modified_time isn't typed
            new Date(cBalance.last_modified_time), unlockDate, period, collateral, earlyUnlockAllowed, collateralClaimant.destination);
        };
        return Escrow;
    }(BasePosition));

    /**
     * A lent position in YieldBlox.
     * @extends Position
     */
    var Lend = /** @class */ (function (_super) {
        __extends(Lend, _super);
        function Lend(accountId, balance, assetId, uncollateralizedBalance, lastModifiedTime, balanceId) {
            var _this = _super.call(this, accountId, balance, assetId, lastModifiedTime, balanceId) || this;
            _this._horizon = HorizonServer.getInstance();
            _this.uncollateralizedBalance = uncollateralizedBalance;
            _this.ybxAccrued = undefined;
            return _this;
        }
        Lend.create = function (cBalance, accountBalance) {
            // assign uncollateralizedBalance
            var uncollateralizedBalance = '0';
            if (accountBalance) {
                uncollateralizedBalance = accountBalance;
            }
            // parse claimableBalance
            // ensure claimants are set up correctly
            if (cBalance.claimants.length > 1)
                return undefined;
            if (!VerifyNeverPredicate(cBalance.claimants[0].predicate))
                return undefined;
            if (!cBalance.sponsor)
                return undefined;
            // handle liquidated balance and assign accountId
            var accountId;
            if (cBalance.sponsor !== ESCROW_ACCOUNT_ID) {
                accountId = cBalance.sponsor;
                if (cBalance.claimants[0].destination !== DIST_ACCOUNT_ID)
                    return undefined;
            }
            else {
                accountId = cBalance.claimants[0].destination;
            }
            return new Lend(accountId, cBalance.amount, cBalance.asset, uncollateralizedBalance, 
            // @ts-ignore - TODO: file issue
            new Date(cBalance.last_modified_time), cBalance.id);
        };
        Lend.createFromBalanceLine = function (accountBalance, assetId, accountId) {
            return new Lend(accountId, '0', assetId, accountBalance, new Date(0), '');
        };
        Lend.prototype.getAccruedYBX = function (timestamp, pool, forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            return __awaiter(this, void 0, void 0, function () {
                var userAccrued, protocolAsset, ratioToken, shiftToken, issuanceTradeHistory, foundLast, _i, _a, trade, positionSize, tradeTimestamp, issuanceRate, pctOfPeriod, weightedSize, pctOfPeriod;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(forceUpdate || !this.ybxAccrued)) return [3 /*break*/, 5];
                            userAccrued = new BigNumber(0);
                            protocolAsset = pool.getAssetFromToken(this.assetId);
                            if (!protocolAsset)
                                throw new Error('Unsupported balance asset');
                            ratioToken = protocolAsset.poolRatioTokenId;
                            shiftToken = protocolAsset.poolShiftTokenId;
                            return [4 /*yield*/, this._horizon.GetTradesAsync(ratioToken, shiftToken)];
                        case 1:
                            issuanceTradeHistory = _b.sent();
                            foundLast = false;
                            _b.label = 2;
                        case 2:
                            if (!(issuanceTradeHistory.records.length !== 0)) return [3 /*break*/, 4];
                            for (_i = 0, _a = issuanceTradeHistory.records; _i < _a.length; _i++) {
                                trade = _a[_i];
                                positionSize = new BigNumber(this.balance);
                                tradeTimestamp = new Date(trade.ledger_close_time).getTime();
                                issuanceRate = tradeToNumber(trade);
                                // exit if user has already claimed
                                if (tradeTimestamp < new Date(this.lastModifiedTime).getTime()) {
                                    this.ybxAccrued = userAccrued.toFixed(7, BigNumber.ROUND_DOWN);
                                    return [2 /*return*/, this.ybxAccrued];
                                }
                                // handle first trade
                                if (userAccrued.equals(0)) {
                                    pctOfPeriod = new BigNumber(timestamp)
                                        .minus(tradeTimestamp)
                                        .dividedBy(new BigNumber(24).times(60).times(60).times(1000));
                                    weightedSize = positionSize.times(pctOfPeriod);
                                    userAccrued = userAccrued.plus(weightedSize.times(issuanceRate));
                                }
                                // handle last trade
                                if (tradeTimestamp - 24 * 60 * 60 * 1000 < new Date(this.lastModifiedTime).getTime()) {
                                    pctOfPeriod = new BigNumber(tradeTimestamp)
                                        .minus(this.lastModifiedTime.getTime())
                                        .dividedBy(new BigNumber(24).times(60).times(60).times(1000));
                                    positionSize = positionSize.times(pctOfPeriod);
                                    userAccrued = userAccrued.plus(positionSize.times(issuanceRate));
                                    foundLast = true;
                                    break;
                                }
                                userAccrued = userAccrued.plus(positionSize.times(issuanceRate));
                            }
                            if (foundLast)
                                return [3 /*break*/, 4];
                            return [4 /*yield*/, issuanceTradeHistory.next()];
                        case 3:
                            issuanceTradeHistory = _b.sent();
                            return [3 /*break*/, 2];
                        case 4:
                            this.ybxAccrued = userAccrued.toFixed(7, BigNumber.ROUND_DOWN);
                            _b.label = 5;
                        case 5: return [2 /*return*/, this.ybxAccrued];
                    }
                });
            });
        };
        Object.defineProperty(Lend.prototype, "totalBalance", {
            get: function () {
                return new BigNumber(this.uncollateralizedBalance)
                    .plus(this.balance)
                    .toFixed(7, BigNumber.ROUND_DOWN);
            },
            enumerable: false,
            configurable: true
        });
        return Lend;
    }(BasePosition));

    /**
     * Container for positions
     */
    var Positions = /** @class */ (function () {
        function Positions(escrowed, borrowed, lent) {
            this.escrowed = escrowed;
            this.borrowed = borrowed;
            this.lent = lent;
        }
        /**
         * Get a borrowed position from the protocol tokenId
         * @param tokenId - The tokenId in the form `tokenCode:poolAccountId`
         * @returns A borrow position or undefined if none exist
         */
        Positions.prototype.getBorrowedPosition = function (tokenId) {
            return this.borrowed.find(function (b) { return b.assetId === tokenId; });
        };
        /**
         * Get a lent position from the protocol tokenId
         * @param tokenId - The tokenId in the form `tokenCode:poolAccountId`
         * @returns A lent position or undefined if none exist
         */
        Positions.prototype.getLentPosition = function (tokenId) {
            return this.lent.find(function (l) { return l.assetId === tokenId; });
        };
        /**
         * Get the collateralized escrow positions for a given pool
         * @param poolAccountId - The pool account's public key
         * @returns An array of escrow positions
         */
        Positions.prototype.getEscrowedPositionsForPool = function (poolAccountId) {
            return this.escrowed.filter(function (e) { return e.collateral && e.collateralDestination === poolAccountId; });
        };
        /**
         * Get the borrowed positions for a given pool
         * @param poolAccountId - The pool account's public key
         * @returns An array of borrow positions
         */
        Positions.prototype.getBorrowedPositionsForPool = function (poolAccountId) {
            return this.borrowed.filter(function (b) { return poolAccountId === b.assetId.split(':')[1]; });
        };
        /**
         * Get the lent positions for a given pool
         * @param poolAccountId - The pool account's public key
         * @returns An array of lent positions
         */
        Positions.prototype.getLentPositionsForPool = function (poolAccountId) {
            return this.lent.filter(function (l) { return poolAccountId === l.assetId.split(':')[1]; });
        };
        return Positions;
    }());

    /**
     * Build a position from a claimable balance
     * @param cBalance - The claimable balance
     * @param accountBalances - The accounts current claimable balances
     * @returns An implementation of BasePosition, or undefined
     */
    function buildPositionFromClaimableBalance(cBalance, accountBalances) {
        // TODO-MULTI-POOL: Find a fast way to filter claimable balances
        // - or make the searching of them pool specific
        // - the position specific create methods will do deeper validation
        var cBalanceType = _classifyClaimableBalance(cBalance, POOL_ACCOUNT_1_ID);
        switch (cBalanceType) {
            case exports.PositionType.Borrow:
                return Borrow.create(cBalance);
            case exports.PositionType.Lend:
                // cBalance asset field is consistent with out format
                var nonCollateralBalance = accountBalances[cBalance.asset];
                return Lend.create(cBalance, nonCollateralBalance);
            case exports.PositionType.Escrow:
                return Escrow.create(cBalance);
        }
        return undefined; // return undefined if not a valid balance
    }
    /**
     * Determine the type of claimable balance. This DOES NOT validate
     * correctness of a claimable balance
     * @param cBalance - The claimable balance record to classify
     * @returns Indicator of what kind of claimable balance this is
     */
    function _classifyClaimableBalance(cBalance, poolAccountId) {
        if (cBalance.asset === YBX_TOKEN)
            return exports.PositionType.Escrow;
        var assetInfo = cBalance.asset.split(':');
        if (assetInfo[1] === poolAccountId) {
            if (assetInfo[0].startsWith('y'))
                return exports.PositionType.Lend;
            if (assetInfo[0].startsWith('l'))
                return exports.PositionType.Borrow;
        }
        return undefined;
    }

    /**
     * Load positions for accounts into the user
     * NOTE: This only parses the claimable balances
     */
    function loadPositions(horizon, accountId, accountBalances) {
        return __awaiter(this, void 0, void 0, function () {
            var borrowed, lent, escrowed, cBalancesPager, _loop_1, assetId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        borrowed = [];
                        lent = [];
                        escrowed = [];
                        cBalancesPager = horizon.GetClaimableBalancesAsync(accountId, undefined, DIST_ACCOUNT_ID);
                        return [4 /*yield*/, _loadPositionsForCollectionPage(cBalancesPager, accountBalances, borrowed, lent, escrowed)];
                    case 1:
                        _a.sent();
                        // fetch liquidated ClaimableBalances
                        // -> staking pool = sponsor, user = claimant
                        cBalancesPager = horizon.GetClaimableBalancesAsync(ESCROW_ACCOUNT_ID, undefined, accountId);
                        return [4 /*yield*/, _loadPositionsForCollectionPage(cBalancesPager, accountBalances, borrowed, lent, escrowed)];
                    case 2:
                        _a.sent();
                        _loop_1 = function (assetId) {
                            // TODO-MULTI-POOL: Figure out how to filter these
                            // verify that this balance is relevant
                            if (!poolAssetRegex.test(assetId) ||
                                accountBalances[assetId] === STELLAR_ZERO ||
                                lent.some(function (l) { return l.assetId === assetId; })) {
                                return "continue";
                            }
                            var lend = Lend.createFromBalanceLine(accountBalances[assetId], assetId, accountId);
                            lent.push(lend);
                        };
                        // run through balances to update/create any non-collateralized lends
                        for (assetId in accountBalances) {
                            _loop_1(assetId);
                        }
                        return [2 /*return*/, new Positions(escrowed, borrowed, lent)];
                }
            });
        });
    }
    function _loadPositionsForCollectionPage(pager, accountBalances, borrowed, lent, escrowed) {
        return __awaiter(this, void 0, void 0, function () {
            var page, _i, _a, cBalance, position;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, pager];
                    case 1:
                        page = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!(page.records.length !== 0)) return [3 /*break*/, 4];
                        for (_i = 0, _a = page.records; _i < _a.length; _i++) {
                            cBalance = _a[_i];
                            position = buildPositionFromClaimableBalance(cBalance, accountBalances);
                            if (position instanceof Borrow)
                                borrowed.push(position);
                            if (position instanceof Lend)
                                lent.push(position);
                            if (position instanceof Escrow)
                                escrowed.push(position);
                        }
                        return [4 /*yield*/, page.next()];
                    case 3:
                        page = _b.sent();
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    var poolAssetRegex = new RegExp("^y[a-zA-Z0-9]{3,11}:".concat(POOL_ACCOUNT_1_ID, "$"));

    /**
     * YbxUser manages fetching information about a YBX user
     * @extends ClientAccount
     */
    var YbxUser = /** @class */ (function (_super) {
        __extends(YbxUser, _super);
        /**
         * @param base - The client that made that the user
         * @param baseAccountParams - The base account params for the user
         * @param positions - The users current positions
         */
        function YbxUser(base, baseAccountParams, positions) {
            var _this = _super.call(this, baseAccountParams) || this;
            _this._base = base;
            _this.positions = positions;
            return _this;
        }
        /**
         * Fetch the current voting power of the user
         * @returns The total number of votes as a string
         */
        YbxUser.prototype.getVotePower = function () {
            var veVotes = this.getBalance(VEYBX_TOKEN);
            var gVotes = this.getBalance(GYBX_TOKEN);
            return new BigNumber(veVotes !== null && veVotes !== void 0 ? veVotes : 0).plus(gVotes !== null && gVotes !== void 0 ? gVotes : 0).toFixed(7, BigNumber.ROUND_DOWN);
        };
        /**
         * Fetch the outstanding votes the user has against governance proposals
         * @returns The total count of votes, as a BigNumber
         */
        YbxUser.prototype.getCurrentVotes = function () {
            return __awaiter(this, void 0, void 0, function () {
                var offers, userVotes, _i, _a, offer, userVote;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this._base.horizon.GetOffersAsync(this.id, VYBX_TOKEN)];
                        case 1:
                            offers = _b.sent();
                            userVotes = [];
                            for (_i = 0, _a = offers.records; _i < _a.length; _i++) {
                                offer = _a[_i];
                                userVote = ToVote(offer);
                                // transformer returns undefined for invalid offers
                                if (userVote) {
                                    userVotes.push(userVote);
                                }
                            }
                            return [2 /*return*/, userVotes];
                    }
                });
            });
        };
        /**
         * Fetch the users current health factor against a pool
         * @param poolAccountId - The pool accountId
         * @param timestamp - The timestamp to check the health factor against
         * @returns A health factor object
         */
        YbxUser.prototype.getHealthFactorForPool = function (poolAccountId, timestamp) {
            return __awaiter(this, void 0, void 0, function () {
                var pool, prices, lent, borrowed, escrowed, borrowingPower, _i, lent_1, lend, poolAsset, tokenToUnderling, rate, additionalBorrowingPower, ybx, rate, _a, escrowed_1, escrow, additionalBorrowingPower, liabilities, _b, borrowed_1, borrow, poolAsset, tokenToUnderling, rate, additionalLiabilities, hf;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this._base.pool(poolAccountId)];
                        case 1:
                            pool = _c.sent();
                            prices = this._base.prices(timestamp);
                            lent = this.positions.getLentPositionsForPool(pool.id);
                            borrowed = this.positions.getBorrowedPositionsForPool(pool.id);
                            escrowed = this.positions.getEscrowedPositionsForPool(pool.id);
                            borrowingPower = new BigNumber(0);
                            _i = 0, lent_1 = lent;
                            _c.label = 2;
                        case 2:
                            if (!(_i < lent_1.length)) return [3 /*break*/, 6];
                            lend = lent_1[_i];
                            if (!(lend.balanceId !== '')) return [3 /*break*/, 5];
                            poolAsset = pool.getAssetFromToken(lend.assetId);
                            if (!poolAsset) return [3 /*break*/, 5];
                            return [4 /*yield*/, poolAsset.getPoolTokenRate(timestamp)];
                        case 3:
                            tokenToUnderling = _c.sent();
                            return [4 /*yield*/, prices.getProtocolPrice(poolAsset)];
                        case 4:
                            rate = _c.sent();
                            additionalBorrowingPower = rate
                                .times(lend.balance)
                                .times(tokenToUnderling)
                                .times(poolAsset.data.loanToValue);
                            borrowingPower = borrowingPower.plus(additionalBorrowingPower);
                            _c.label = 5;
                        case 5:
                            _i++;
                            return [3 /*break*/, 2];
                        case 6:
                            ybx = pool.getYbx();
                            if (!ybx) return [3 /*break*/, 8];
                            return [4 /*yield*/, prices.getProtocolPrice(ybx)];
                        case 7:
                            rate = _c.sent();
                            for (_a = 0, escrowed_1 = escrowed; _a < escrowed_1.length; _a++) {
                                escrow = escrowed_1[_a];
                                additionalBorrowingPower = rate.times(escrow.balance).times(ybx.data.loanToValue);
                                borrowingPower = borrowingPower.plus(additionalBorrowingPower);
                            }
                            _c.label = 8;
                        case 8:
                            liabilities = new BigNumber(0);
                            _b = 0, borrowed_1 = borrowed;
                            _c.label = 9;
                        case 9:
                            if (!(_b < borrowed_1.length)) return [3 /*break*/, 13];
                            borrow = borrowed_1[_b];
                            poolAsset = pool.getAssetFromToken(borrow.assetId);
                            if (!poolAsset) return [3 /*break*/, 12];
                            return [4 /*yield*/, poolAsset.getLiabilityTokenRate(timestamp)];
                        case 10:
                            tokenToUnderling = _c.sent();
                            return [4 /*yield*/, prices.getProtocolPrice(poolAsset)];
                        case 11:
                            rate = _c.sent();
                            additionalLiabilities = rate.times(borrow.balance).times(tokenToUnderling);
                            liabilities = liabilities.plus(additionalLiabilities);
                            _c.label = 12;
                        case 12:
                            _b++;
                            return [3 /*break*/, 9];
                        case 13:
                            hf = divideToNumber(borrowingPower, liabilities);
                            return [2 /*return*/, {
                                    value: hf.toNumber(),
                                    liabilitiesUSD: liabilities.toFixed(7, BigNumber.ROUND_UP),
                                    borrowLimitUSD: borrowingPower.toFixed(7, BigNumber.ROUND_DOWN),
                                }];
                    }
                });
            });
        };
        return YbxUser;
    }(BaseAccount));

    function DEXPricePrimary(horizon, sellAssetId, buyAssetId, timestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var tradeAggregations, priceSum;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, horizon.getTWAPAsync(sellAssetId, buyAssetId, timestamp, 30)];
                    case 1:
                        tradeAggregations = _a.sent();
                        if (tradeAggregations.records.length >= 10) {
                            priceSum = tradeAggregations.records.reduce(function (prev, r) { return prev.plus(r.avg); }, new BigNumber(0));
                            return [2 /*return*/, priceSum.dividedBy(tradeAggregations.records.length)];
                        }
                        throw new Error("Unable to find enough trades for ".concat(sellAssetId, " - ").concat(buyAssetId));
                }
            });
        });
    }
    function DEXPriceValidation(horizon, sellAssetId, buyAssetId, timestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var tradeAggregations, priceSum;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, horizon.getTWAPAsync(sellAssetId, buyAssetId, timestamp, 10)];
                    case 1:
                        tradeAggregations = _a.sent();
                        // don't throw if we can't find prices to validate with
                        if (tradeAggregations.records.length === 0) {
                            return [2 /*return*/, undefined];
                        }
                        priceSum = tradeAggregations.records.reduce(function (prev, r) { return prev.plus(r.avg); }, new BigNumber(0));
                        return [2 /*return*/, priceSum.dividedBy(tradeAggregations.records.length)];
                }
            });
        });
    }
    function CoinbasePrice(ticker, timestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var start, end, granularity, resp, data, total, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        start = new Date(timestamp - 10 * 60 * 1000).toISOString();
                        end = new Date(timestamp).toISOString();
                        granularity = '60';
                        return [4 /*yield*/, axios__default["default"].get("https://api.pro.coinbase.com/products/".concat(ticker, "-USD/candles?start=").concat(start, "&end=").concat(end, "&granularity=").concat(granularity))];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === 200) {
                            if (resp.data.length >= 5) {
                                data = resp.data.slice(0, 5);
                                total = data.reduce(function (prev, cbObj) {
                                    var avg = calcTWAPForPeriod(cbObj[1], cbObj[2], cbObj[3], cbObj[4]);
                                    if (avg.isFinite()) {
                                        return prev.plus(avg);
                                    }
                                    return prev;
                                }, new BigNumber(0));
                                return [2 /*return*/, total.dividedBy(data.length)];
                            }
                        }
                        return [2 /*return*/, undefined];
                    case 2:
                        error_1 = _a.sent();
                        console.log('coinbaseError', JSON.stringify(error_1));
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function BinancePrice(ticker, timestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var start, end, interval, resp, data, total, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        start = new Date(timestamp - 10 * 60 * 1000).getTime();
                        end = new Date(timestamp).getTime();
                        interval = '1m';
                        return [4 /*yield*/, axios__default["default"].get("https://api.binance.com/api/v3/klines?symbol=".concat(ticker, "USDT&interval=").concat(interval, "&startTime=").concat(start, "&endTime=").concat(end))];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === 200) {
                            if (resp.data.length >= 5) {
                                data = resp.data.slice(0, 5);
                                total = data.reduce(function (prev, bnObj) {
                                    var avg = calcTWAPForPeriod(bnObj[1], bnObj[2], bnObj[3], bnObj[4]);
                                    if (avg.isFinite()) {
                                        return prev.plus(avg);
                                    }
                                    return prev;
                                }, new BigNumber(0));
                                return [2 /*return*/, total.dividedBy(data.length)];
                            }
                        }
                        return [2 /*return*/, undefined];
                    case 2:
                        error_2 = _a.sent();
                        console.log('binanceError', JSON.stringify(error_2));
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function FTXPrice(ticker, timestamp) {
        return __awaiter(this, void 0, void 0, function () {
            var start, end, interval, resp, data, total, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        start = Math.floor(new Date(timestamp - 10 * 60 * 1000).getTime() / 1000);
                        end = Math.floor(new Date(timestamp).getTime() / 1000);
                        interval = '60';
                        return [4 /*yield*/, axios__default["default"].get("https://ftx.com/api/markets/".concat(ticker, "/USD/candles?resolution=").concat(interval, "&start_time=").concat(start, "&end_time=").concat(end))];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === 200) {
                            data = resp.data.result;
                            if (data.length >= 5) {
                                // FTX orders data from oldest -> newest... ??
                                data = data.slice(-5).reverse();
                                total = data.reduce(function (prev, ftxObj) {
                                    var avg = calcTWAPForPeriod(ftxObj.open, ftxObj.high, ftxObj.low, ftxObj.close);
                                    if (avg.isFinite()) {
                                        return prev.plus(avg);
                                    }
                                    return prev;
                                }, new BigNumber(0));
                                return [2 /*return*/, total.dividedBy(data.length)];
                            }
                        }
                        return [2 /*return*/, undefined];
                    case 2:
                        error_3 = _a.sent();
                        console.log('ftxError', JSON.stringify(error_3));
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }

    /**
     * Get prices for assets at a given timestamp
     */
    var Prices = /** @class */ (function () {
        /**
         * @param timestamp - The timestamp to fetch the prices at
         */
        function Prices(timestamp) {
            this._horizon = HorizonServer.getInstance();
            this.timestamp = timestamp;
            this._cachedPrices = {};
        }
        /**
         * Fetch the SDEX USDC TWAP price for an asset.
         * Verifies it against an external source like Coinbase.
         * @note
         * This is used by the protocol to price assets safely during Health Factor calculations.
         * @param poolAsset - The pool asset to grab the price for
         * @returns The price as a BigNumber
         * @throws If it can't validate the SDEX price with an external source when possible
         */
        Prices.prototype.getProtocolPrice = function (poolAsset) {
            return __awaiter(this, void 0, void 0, function () {
                var price;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._cachedPrices[poolAsset.underlyingId] === undefined)) return [3 /*break*/, 5];
                            if (poolAsset.underlyingId === TESTNET_USDC) {
                                return [2 /*return*/, new BigNumber(1)];
                            }
                            price = void 0;
                            if (!!poolAsset.data.exchangePrimary) return [3 /*break*/, 2];
                            return [4 /*yield*/, this._fetchPrice(poolAsset)];
                        case 1:
                            price = _a.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this._fetchExchangePrice(poolAsset)];
                        case 3:
                            price = _a.sent();
                            console.log('aggregate price', price.toString());
                            _a.label = 4;
                        case 4:
                            this._cachedPrices[poolAsset.underlyingId] = price;
                            _a.label = 5;
                        case 5: return [2 /*return*/, this._cachedPrices[poolAsset.underlyingId]];
                    }
                });
            });
        };
        // ========== Private Helpers ==========
        Prices.prototype._fetchPrice = function (poolAsset) {
            return __awaiter(this, void 0, void 0, function () {
                var nativeToUsd, assetToNative, dexPrice, totalExchanges, validationScore, binancePrice, coinbasePrice, ftxPrice;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this._primaryNativeToUsd === undefined)) return [3 /*break*/, 2];
                            return [4 /*yield*/, DEXPricePrimary(this._horizon, NATIVE, this._horizon.USDCAssetId, this.timestamp)];
                        case 1:
                            nativeToUsd = _a.sent();
                            this._primaryNativeToUsd = nativeToUsd;
                            _a.label = 2;
                        case 2: return [4 /*yield*/, DEXPricePrimary(this._horizon, poolAsset.underlyingId, NATIVE, this.timestamp)];
                        case 3:
                            assetToNative = _a.sent();
                            dexPrice = this._primaryNativeToUsd.times(assetToNative);
                            totalExchanges = poolAsset.data.binance + poolAsset.data.coinbase + poolAsset.data.ftx;
                            if (!totalExchanges) return [3 /*break*/, 10];
                            validationScore = 0;
                            if (!poolAsset.data.binance) return [3 /*break*/, 5];
                            return [4 /*yield*/, BinancePrice(poolAsset.data.assetTicker, this.timestamp)];
                        case 4:
                            binancePrice = _a.sent();
                            validationScore += this._validatePrice(dexPrice, binancePrice);
                            _a.label = 5;
                        case 5:
                            if (!poolAsset.data.coinbase) return [3 /*break*/, 7];
                            return [4 /*yield*/, CoinbasePrice(poolAsset.data.assetTicker, this.timestamp)];
                        case 6:
                            coinbasePrice = _a.sent();
                            validationScore += this._validatePrice(dexPrice, coinbasePrice);
                            _a.label = 7;
                        case 7:
                            if (!poolAsset.data.ftx) return [3 /*break*/, 9];
                            return [4 /*yield*/, FTXPrice(poolAsset.data.assetTicker, this.timestamp)];
                        case 8:
                            ftxPrice = _a.sent();
                            validationScore += this._validatePrice(dexPrice, ftxPrice);
                            _a.label = 9;
                        case 9:
                            // check if validation was successful
                            if (totalExchanges === 1) {
                                // valid if an exchange did not DISAGREE with the SDEX
                                if (validationScore === 0) {
                                    throw new Error("Unable to validate SDEX price of ".concat(dexPrice.toString(), " for ").concat(poolAsset.underlyingId));
                                }
                            }
                            // more than 1 exchange, force 1 less than total exchanges to match
                            if (validationScore < (totalExchanges - 1) * 3) {
                                throw new Error("Unable to validate SDEX price of ".concat(dexPrice.toString(), " for ").concat(poolAsset.underlyingId));
                            }
                            _a.label = 10;
                        case 10: return [2 /*return*/, dexPrice];
                    }
                });
            });
        };
        Prices.prototype._fetchExchangePrice = function (poolAsset) {
            return __awaiter(this, void 0, void 0, function () {
                var prices, binancePrice, coinbasePrice, ftxPrice, needsValidation, validatablePrices, sortedPrices, median_1, matchedPrices, sum, avg, avg, nativeToUsd, assetToNative, dexPrice, _i, validatablePrices_1, toValidate, valid;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('get exchange price for: ', poolAsset.underlyingId);
                            prices = [];
                            if (!poolAsset.data.binance) return [3 /*break*/, 2];
                            return [4 /*yield*/, BinancePrice(poolAsset.data.assetTicker, this.timestamp)];
                        case 1:
                            binancePrice = _a.sent();
                            if (binancePrice) {
                                prices.push(binancePrice);
                            }
                            console.log('binancePrice', binancePrice);
                            _a.label = 2;
                        case 2:
                            if (!poolAsset.data.coinbase) return [3 /*break*/, 4];
                            return [4 /*yield*/, CoinbasePrice(poolAsset.data.assetTicker, this.timestamp)];
                        case 3:
                            coinbasePrice = _a.sent();
                            if (coinbasePrice) {
                                prices.push(coinbasePrice);
                            }
                            console.log('coinbasePrice', coinbasePrice);
                            _a.label = 4;
                        case 4:
                            if (!poolAsset.data.ftx) return [3 /*break*/, 6];
                            return [4 /*yield*/, FTXPrice(poolAsset.data.assetTicker, this.timestamp)];
                        case 5:
                            ftxPrice = _a.sent();
                            if (ftxPrice) {
                                prices.push(ftxPrice);
                            }
                            console.log('ftxPrice', ftxPrice);
                            _a.label = 6;
                        case 6:
                            needsValidation = true;
                            validatablePrices = [];
                            if (prices.length === 3) {
                                sortedPrices = prices.sort(function (a, b) { return (a.lessThan(b) ? -1 : 1); });
                                median_1 = sortedPrices[1];
                                matchedPrices = sortedPrices.filter(function (price) { return _this._validatePrice(price, median_1) === 3; });
                                if (matchedPrices.length >= 1) {
                                    sum = matchedPrices.reduce(function (prev, next) { return prev.plus(next); }, new BigNumber(0));
                                    avg = sum.dividedBy(matchedPrices.length);
                                    // require validation if not all 3 match
                                    validatablePrices.push(avg);
                                    needsValidation = matchedPrices.length !== 3;
                                }
                            }
                            else if (prices.length === 2 && this._validatePrice(prices[0], prices[1]) === 3) {
                                avg = prices[0].plus(prices[1]).dividedBy(prices.length);
                                validatablePrices.push(avg);
                                needsValidation = false;
                            }
                            else if (prices.length > 0) {
                                // otherwise, attempt to validate any valid exchange price
                                needsValidation = true;
                                validatablePrices = prices;
                            }
                            if (prices.length === 0 || validatablePrices.length === 0) {
                                throw new Error("Unable to get exchange price for ".concat(poolAsset.underlyingId));
                            }
                            if (!needsValidation) return [3 /*break*/, 10];
                            if (!(this._validationNativeToUsd === undefined)) return [3 /*break*/, 8];
                            return [4 /*yield*/, DEXPriceValidation(this._horizon, NATIVE, this._horizon.USDCAssetId, this.timestamp)];
                        case 7:
                            nativeToUsd = _a.sent();
                            this._validationNativeToUsd = nativeToUsd;
                            _a.label = 8;
                        case 8: return [4 /*yield*/, DEXPriceValidation(this._horizon, poolAsset.underlyingId, NATIVE, this.timestamp)];
                        case 9:
                            assetToNative = _a.sent();
                            dexPrice = this._validationNativeToUsd !== undefined && assetToNative !== undefined
                                ? this._validationNativeToUsd.times(assetToNative)
                                : undefined;
                            for (_i = 0, validatablePrices_1 = validatablePrices; _i < validatablePrices_1.length; _i++) {
                                toValidate = validatablePrices_1[_i];
                                valid = this._validatePrice(toValidate, dexPrice) === 3;
                                if (valid)
                                    return [2 /*return*/, toValidate];
                            }
                            return [3 /*break*/, 11];
                        case 10:
                            if (validatablePrices.length === 1) {
                                // validation can only be skipped if
                                // -> 1 verifiable price was listed
                                // -> needsValidation is false
                                return [2 /*return*/, validatablePrices[0]];
                            }
                            _a.label = 11;
                        case 11: throw new Error("Unable to validate SDEX price of ".concat(validatablePrices[0].toString(), " for ").concat(poolAsset.underlyingId));
                    }
                });
            });
        };
        /**
         * Score an exchange price
         * @param base - The SDEX price
         * @param validator - The Exchange price
         * @returns
         * - 0 if the exchange price differs from the SDEX price
         * - 1 if no valid price was received from the exchange
         * - 3 if the exchange price matches
         */
        Prices.prototype._validatePrice = function (base, validator) {
            if (validator !== undefined) {
                var percentDif = validator.minus(base).absoluteValue().dividedBy(base);
                var match = percentDif.lessThan('0.05'); // TODO: Find good value for this
                return match ? 3 : 0;
            }
            return 1;
        };
        return Prices;
    }());

    /**
     * A container for caching instances of T via K/V
     */
    var CacheContainer = /** @class */ (function () {
        /**
         * Construct a cache container
         * @param ttl - The TTL of the cache in seconds. Defaults to 6 seconds (approx. block time)
         */
        function CacheContainer(ttl) {
            this._cache = {};
            this.ttl = ttl !== null && ttl !== void 0 ? ttl : 6;
        }
        /**
         * Cache an instance
         * @param key - The key to cache the object under
         * @param instance - The instance to cache
         */
        CacheContainer.prototype.put = function (key, instance) {
            var cachedInstance = {
                time: Date.now(),
                instance: instance,
            };
            this._cache[key] = cachedInstance;
        };
        /**
         * Get an instance
         * @param key- The key to fetch the cached instance
         * @returns The instance if it exists, or undefined if the instance was not found or has expired
         */
        CacheContainer.prototype.get = function (key) {
            var cachedInstance = this._cache[key];
            if (cachedInstance) {
                if (Date.now() - cachedInstance.time <= this.ttl * 1000) {
                    // cache time is valid
                    return cachedInstance.instance;
                }
                delete this._cache[key];
            }
            return undefined;
        };
        return CacheContainer;
    }());

    /**
     * YbxBase provides functionality to interpret the ledger the
     * same way as YieldBlox protocol.
     * @constructor
     */
    var YbxBase = /** @class */ (function () {
        /**
         * @param ttl - How long the cache should persist objects. 6 seconds by default
         */
        function YbxBase(ttl) {
            // Note - Stellar users Axios under the hood. Should work for
            // both browsers and node
            this.horizon = HorizonServer.getInstance();
            this._pools = new CacheContainer(ttl);
            this._governance = new CacheContainer(ttl);
        }
        YbxBase.Configure = function (horizonUrl) {
            HorizonServer.Configure(horizonUrl);
        };
        YbxBase.prototype.getNetworkPassphrase = function () {
            return this.horizon.network;
        };
        /**
         * Fetch a Pool object
         * @returns A pool object
         */
        YbxBase.prototype.pool = function (poolAccountId) {
            return __awaiter(this, void 0, void 0, function () {
                var pool, poolAccountResponse, baseAccountParams, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            pool = this._pools.get(poolAccountId);
                            if (!!pool) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.horizon.GetAccountAsync(POOL_ACCOUNT_1_ID)];
                        case 1:
                            poolAccountResponse = _a.sent();
                            baseAccountParams = BaseAccount.getBaseAccountParams(poolAccountResponse);
                            data = new PoolData(poolAccountResponse.data_attr);
                            pool = new Pool(this, baseAccountParams, data);
                            this._pools.put(poolAccountId, pool);
                            _a.label = 2;
                        case 2: return [2 /*return*/, pool];
                    }
                });
            });
        };
        /**
         * Fetch a Governance object
         * @returns A pool object
         */
        YbxBase.prototype.governance = function () {
            return __awaiter(this, void 0, void 0, function () {
                var gov, accountResponse, baseAccountParams, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            gov = this._governance.get(DIST_ACCOUNT_ID);
                            if (!!gov) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.horizon.GetAccountAsync(DIST_ACCOUNT_ID)];
                        case 1:
                            accountResponse = _a.sent();
                            baseAccountParams = BaseAccount.getBaseAccountParams(accountResponse);
                            data = new GovernanceData(accountResponse.data_attr);
                            gov = new Governance(this, baseAccountParams, data);
                            this._governance.put(DIST_ACCOUNT_ID, gov);
                            _a.label = 2;
                        case 2: return [2 /*return*/, gov];
                    }
                });
            });
        };
        /**
         * Fetch a Ybx User
         * @returns YBX User
         */
        YbxBase.prototype.user = function (accountId) {
            return __awaiter(this, void 0, void 0, function () {
                var accountResponse, baseAccountParams, positions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.horizon.GetAccountAsync(accountId)];
                        case 1:
                            accountResponse = _a.sent();
                            baseAccountParams = BaseAccount.getBaseAccountParams(accountResponse);
                            return [4 /*yield*/, loadPositions(this.horizon, accountId, baseAccountParams.balances)];
                        case 2:
                            positions = _a.sent();
                            return [2 /*return*/, new YbxUser(this, baseAccountParams, positions)];
                    }
                });
            });
        };
        /**
         * Fetch prices the way Ybx does
         * @param timestamp - The timestamp to find prices for (in ms)
         * @returns Price object
         */
        YbxBase.prototype.prices = function (timestamp) {
            if (this._prices !== undefined && this._prices.timestamp === timestamp) {
                return this._prices;
            }
            var prices = new Prices(timestamp);
            this._prices = prices;
            return prices;
        };
        YbxBase.VERSION = LIB_VERSION;
        return YbxBase;
    }());

    /**
     * Fetch liquidation values
     * @param pool - The pool a user is getting liquidated in
     * @param timestamp - The timestamp the user is being liquidated at
     * @param escrows - The users escrow positions
     * @param lends - The users lent positions
     * @returns The avgLiqIncentive and collateralValueUSD
     */
    function getLiquidationValues(pool, timestamp, escrows, lends) {
        return __awaiter(this, void 0, void 0, function () {
            var weightedLiquidationIncentives, collateralValueUSD, _i, lends_1, lend, poolAsset, poolTokenRate, underlyingPrice, collateralValue, incentive, thisWeightedIncentive, ybxPoolAsset, ybxPrice, incentive, _a, escrows_1, escrow, collateralValue, thisWeightedIncentive, avgLiqIncentive;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        weightedLiquidationIncentives = new BigNumber(0);
                        collateralValueUSD = new BigNumber(0);
                        _i = 0, lends_1 = lends;
                        _b.label = 1;
                    case 1:
                        if (!(_i < lends_1.length)) return [3 /*break*/, 5];
                        lend = lends_1[_i];
                        // skip position if it is not collateral
                        if (lend.balance === '0')
                            return [3 /*break*/, 4];
                        poolAsset = pool.getAssetFromToken(lend.assetId);
                        // skip if poolAsset unsupported
                        if (!poolAsset)
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, poolAsset.getPoolTokenRate(timestamp)];
                    case 2:
                        poolTokenRate = _b.sent();
                        return [4 /*yield*/, pool._base.prices(timestamp).getProtocolPrice(poolAsset)];
                    case 3:
                        underlyingPrice = _b.sent();
                        collateralValue = new BigNumber(lend.balance).times(poolTokenRate).times(underlyingPrice);
                        collateralValueUSD = collateralValueUSD.plus(collateralValue);
                        incentive = poolAsset.data.liquidationIncentive;
                        thisWeightedIncentive = collateralValue.times(incentive);
                        weightedLiquidationIncentives = weightedLiquidationIncentives.plus(thisWeightedIncentive);
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5:
                        if (!(escrows.length > 0)) return [3 /*break*/, 7];
                        ybxPoolAsset = pool.getYbx();
                        if (!ybxPoolAsset) return [3 /*break*/, 7];
                        return [4 /*yield*/, pool._base.prices(timestamp).getProtocolPrice(ybxPoolAsset)];
                    case 6:
                        ybxPrice = _b.sent();
                        incentive = ybxPoolAsset.data.liquidationIncentive;
                        for (_a = 0, escrows_1 = escrows; _a < escrows_1.length; _a++) {
                            escrow = escrows_1[_a];
                            collateralValue = new BigNumber(escrow.balance).times(ybxPrice);
                            collateralValueUSD = collateralValueUSD.plus(collateralValue);
                            thisWeightedIncentive = collateralValue.times(incentive);
                            weightedLiquidationIncentives = weightedLiquidationIncentives.plus(thisWeightedIncentive);
                        }
                        _b.label = 7;
                    case 7:
                        avgLiqIncentive = divideToNumber(weightedLiquidationIncentives, collateralValueUSD);
                        return [2 /*return*/, { avgLiqIncentive: avgLiqIncentive, collateralValueUSD: collateralValueUSD }];
                }
            });
        });
    }

    /**
     * Checks if new pool debt is necessary
     * @param liquidationRepayments - The lTokens being repaid
     * @param pool - The pool the user is being liquidated against
     * @param timestamp - The timestamp the user is being liquidated at
     * @param backstopOrder - The order the pool will allocated pool debt
     * @param user - The user being liquidated
     * @param currentHealthFactor - The users current health factor
     * @returns
     */
    function getNewPoolDebt(liquidationRepayments, // expects lTokens
    pool, timestamp, backstopOrder, // expects lTokens
    user, currentHealthFactor) {
        return __awaiter(this, void 0, void 0, function () {
            var positions, liquidationNumbers, backstopAmount, newPoolDebt, remainingBackstop, _loop_1, _i, backstopOrder_1, backstop, state_1, backstopDif;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!currentHealthFactor) return [3 /*break*/, 2];
                        return [4 /*yield*/, user.getHealthFactorForPool(pool.id, timestamp)];
                    case 1:
                        currentHealthFactor = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (currentHealthFactor.value >= 1) {
                            return [2 /*return*/, undefined];
                        }
                        positions = user.positions;
                        return [4 /*yield*/, getLiquidationValues(pool, timestamp, positions.getEscrowedPositionsForPool(pool.id), positions.getLentPositionsForPool(pool.id))];
                    case 3:
                        liquidationNumbers = _a.sent();
                        backstopAmount = CalcBackstopAmount(liquidationNumbers.avgLiqIncentive, new BigNumber(currentHealthFactor.liabilitiesUSD), liquidationNumbers.collateralValueUSD);
                        newPoolDebt = [];
                        if (backstopAmount.lessThanOrEqualTo(0)) {
                            return [2 /*return*/, newPoolDebt];
                        }
                        remainingBackstop = backstopAmount;
                        _loop_1 = function (backstop) {
                            var poolAsset, thisBorrow, repayableAmount, relevantRepayment, lTokenRate, underlyingPrice, repayableValue, newDebt;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        poolAsset = pool.getAssetFromToken(backstop);
                                        if (!poolAsset) {
                                            throw new Error("".concat(backstop, " is not supported by the pool"));
                                        }
                                        thisBorrow = positions.getBorrowedPosition(poolAsset.liabilityTokenId);
                                        if (!thisBorrow) {
                                            throw new Error("Liquidatee does not have an outstanding borrow for ".concat(poolAsset.underlyingId));
                                        }
                                        repayableAmount = new BigNumber(thisBorrow.balance);
                                        relevantRepayment = liquidationRepayments.find(function (r) { return r.assetId === (poolAsset === null || poolAsset === void 0 ? void 0 : poolAsset.liabilityTokenId); });
                                        if (relevantRepayment) {
                                            repayableAmount = repayableAmount.minus(relevantRepayment.amount);
                                        }
                                        return [4 /*yield*/, poolAsset.getLiabilityTokenRate(timestamp)];
                                    case 1:
                                        lTokenRate = _b.sent();
                                        return [4 /*yield*/, pool._base.prices(timestamp).getProtocolPrice(poolAsset)];
                                    case 2:
                                        underlyingPrice = _b.sent();
                                        repayableValue = repayableAmount.times(lTokenRate).times(underlyingPrice);
                                        remainingBackstop = remainingBackstop.minus(repayableValue.toFixed(7, BigNumber.ROUND_UP));
                                        // check if backstopAmount has been filled
                                        if (remainingBackstop.lessThanOrEqualTo(0)) {
                                            newDebt = repayableValue
                                                .plus(remainingBackstop)
                                                .dividedBy(underlyingPrice)
                                                .dividedBy(lTokenRate);
                                            newPoolDebt.push({
                                                amount: newDebt.toFixed(7, BigNumber.ROUND_UP),
                                                assetId: backstop,
                                            });
                                            return [2 /*return*/, "break"];
                                        }
                                        // add debt and continue
                                        newPoolDebt.push({
                                            amount: repayableAmount.toFixed(7, BigNumber.ROUND_UP),
                                            assetId: backstop,
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _i = 0, backstopOrder_1 = backstopOrder;
                        _a.label = 4;
                    case 4:
                        if (!(_i < backstopOrder_1.length)) return [3 /*break*/, 7];
                        backstop = backstopOrder_1[_i];
                        return [5 /*yield**/, _loop_1(backstop)];
                    case 5:
                        state_1 = _a.sent();
                        if (state_1 === "break")
                            return [3 /*break*/, 7];
                        _a.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7:
                        backstopDif = remainingBackstop.dividedBy(backstopAmount);
                        if (backstopDif.greaterThan(0.01)) {
                            throw new Error('Backstop not fully settled, either liquidator repayments were too large or not enough backstop assets were provided');
                        }
                        return [2 /*return*/, newPoolDebt];
                }
            });
        });
    }

    function getMaxLiquidation(user, pool, timestamp, withdrawals, prices, hf) {
        return __awaiter(this, void 0, void 0, function () {
            var weightedIncentive, weightedLTV, withdrawalValueUSD, _i, withdrawals_1, withdrawal, poolAsset, poolTokenRate, price, thisWithdrawalValue, avgWithdrawalLTV, avgWithdrawalIncentive;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!hf) return [3 /*break*/, 2];
                        return [4 /*yield*/, user.getHealthFactorForPool(pool.id, timestamp)];
                    case 1:
                        hf = _a.sent();
                        _a.label = 2;
                    case 2:
                        weightedIncentive = new BigNumber(0);
                        weightedLTV = new BigNumber(0);
                        withdrawalValueUSD = new BigNumber(0);
                        _i = 0, withdrawals_1 = withdrawals;
                        _a.label = 3;
                    case 3:
                        if (!(_i < withdrawals_1.length)) return [3 /*break*/, 9];
                        withdrawal = withdrawals_1[_i];
                        poolAsset = void 0;
                        poolTokenRate = void 0;
                        if (!(withdrawal.assetId === YBX_TOKEN)) return [3 /*break*/, 4];
                        poolAsset = pool.getYbx();
                        if (!poolAsset)
                            throw Error("".concat(withdrawal.assetId, " is not supported by pool"));
                        poolTokenRate = new BigNumber(1);
                        return [3 /*break*/, 6];
                    case 4:
                        poolAsset = pool.getAssetFromToken(withdrawal.assetId);
                        if (!poolAsset)
                            throw Error("".concat(withdrawal.assetId, " is not supported by pool"));
                        return [4 /*yield*/, poolAsset.getPoolTokenRate(timestamp)];
                    case 5:
                        poolTokenRate = _a.sent();
                        _a.label = 6;
                    case 6: return [4 /*yield*/, prices.getProtocolPrice(poolAsset)];
                    case 7:
                        price = _a.sent();
                        thisWithdrawalValue = price.times(poolTokenRate).times(withdrawal.amount);
                        weightedLTV = weightedLTV.plus(thisWithdrawalValue.times(poolAsset.data.loanToValue));
                        weightedIncentive = weightedIncentive.plus(thisWithdrawalValue.times(poolAsset.data.liquidationIncentive));
                        withdrawalValueUSD = withdrawalValueUSD.plus(thisWithdrawalValue);
                        _a.label = 8;
                    case 8:
                        _i++;
                        return [3 /*break*/, 3];
                    case 9:
                        avgWithdrawalLTV = weightedLTV.dividedBy(withdrawalValueUSD);
                        avgWithdrawalIncentive = weightedIncentive.dividedBy(withdrawalValueUSD);
                        return [2 /*return*/, CalcMaxLiquidationAmount(new BigNumber(hf.borrowLimitUSD), new BigNumber(hf.liabilitiesUSD), avgWithdrawalIncentive, avgWithdrawalLTV)];
                }
            });
        });
    }

    var index = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getNewPoolDebt: getNewPoolDebt,
        getLiquidationValues: getLiquidationValues,
        getMaxLiquidation: getMaxLiquidation
    });

    function YbxConfigure(horizonUrl) {
        HorizonServer.Configure(horizonUrl);
    }

    exports.AllocationProposal = AllocationProposal;
    exports.BLOCKS_PER_YEAR = BLOCKS_PER_YEAR;
    exports.BasePosition = BasePosition;
    exports.Borrow = Borrow;
    exports.CONTROLLED_ACCOUNTS = CONTROLLED_ACCOUNTS;
    exports.DAO_TREASURY_ID = DAO_TREASURY_ID;
    exports.DEX_USDC = DEX_USDC;
    exports.DIST_ACCOUNT_ID = DIST_ACCOUNT_ID;
    exports.ESCROW_ACCOUNT_ID = ESCROW_ACCOUNT_ID;
    exports.Escrow = Escrow;
    exports.FIVE_MIN = FIVE_MIN;
    exports.GYBX_TOKEN = GYBX_TOKEN;
    exports.Governance = Governance;
    exports.GovernanceData = GovernanceData;
    exports.HorizonServer = HorizonServer;
    exports.ISSUANCE_ACCOUNT_ID = ISSUANCE_ACCOUNT_ID;
    exports.Lend = Lend;
    exports.MONTH_IN_DAYS = MONTH_IN_DAYS;
    exports.NATIVE = NATIVE;
    exports.POOL_ACCOUNT_1_ID = POOL_ACCOUNT_1_ID;
    exports.PUBNET_USDC = PUBNET_USDC;
    exports.Pool = Pool;
    exports.PoolAsset = PoolAsset;
    exports.PoolData = PoolData;
    exports.Positions = Positions;
    exports.Prices = Prices;
    exports.ProposalData = ProposalData;
    exports.STARTING_irTRACKER_BALANCE = STARTING_irTRACKER_BALANCE;
    exports.STELLAR_MAX = STELLAR_MAX;
    exports.STELLAR_MIN = STELLAR_MIN;
    exports.STELLAR_ZERO = STELLAR_ZERO;
    exports.TESTNET_USDC = TESTNET_USDC;
    exports.VEYBX_TOKEN = VEYBX_TOKEN;
    exports.VYBX_TOKEN = VYBX_TOKEN;
    exports.XDR_NUMBER_SHIFT = XDR_NUMBER_SHIFT;
    exports.XLM_RESERVE = XLM_RESERVE;
    exports.XdrProposal = XdrProposal;
    exports.YBX_TOKEN = YBX_TOKEN;
    exports.YbxBase = YbxBase;
    exports.YbxConfigure = YbxConfigure;
    exports.YbxUser = YbxUser;
    exports.liquidationUtils = index;
    exports.predicateUtils = predicates;
    exports.safeMath = safeMath;
    exports.transformer = transformer;
    exports.txDecoder = txDecoder;
    exports.txParser = opParser;
    exports.voteUtils = votes;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
